import React, { useState, useEffect, useCallback, Fragment } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { db, auth } from '../firebase'; // Pastikan firebase.js sudah diekspor dengan benar
import { collection, getDocs, addDoc, deleteDoc, doc, serverTimestamp, query, orderBy, updateDoc, getDoc, setDoc, arrayUnion, arrayRemove, where, writeBatch } from 'firebase/firestore';

import AgendaManager from '../components/AgendaManager'; // Import Agenda Component
import {
  FaImages, FaNewspaper, FaSignOutAlt, FaThLarge, FaEnvelope, FaCog, FaInfoCircle,
  FaUsers, FaLandmark, FaChalkboardTeacher, FaTrash, FaExternalLinkAlt, FaPencilAlt,
  FaEye, FaEyeSlash, FaBars, FaPlus, FaToggleOn, FaToggleOff, FaChevronDown, FaChevronLeft, FaChevronRight,
  FaTrophy, FaHandshake, FaMobileAlt, FaYoutube, FaSortAlphaDown, FaSortAlphaUp,
  FaInstagram, FaFilePdf, FaSearch, FaList, FaTimes, FaCalendarAlt, FaUser, FaWhatsapp, FaBullseye, FaDownload, FaListUl, FaSave,
  FaQuoteRight, FaGraduationCap, FaLink, FaClock
} from 'react-icons/fa';
import ReactQuill, { Quill } from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import ImageCropper from '../components/ImageCropper';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ConfirmationModal from '../components/ConfirmationModal';
import DashboardOverview from '../components/DashboardOverview';
import './AdminDashboard.css';
import '../components/ImageCropper.css';
import logo from '../assets/logo.svg';
import { signOut } from 'firebase/auth';

// Register Line Height Format for ReactQuill
const Parchment = Quill.import('parchment');
const LineHeightStyle = new Parchment.Attributor.Style('lineheight', 'line-height', {
  scope: Parchment.Scope.BLOCK,
  whitelist: ['1.0', '1.25', '1.5', '1.75', '2.0']
});
Quill.register(LineHeightStyle, true);

// Register Align Style Attributor
const AlignStyle = Quill.import('attributors/style/align');
Quill.register(AlignStyle, true);

const AdminDashboard = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const [pesanKontak, setPesanKontak] = useState([]);

  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  // Sync activeTab dengan URL search param (?tab=...)
  const getInitialTab = () => {
    const params = new URLSearchParams(window.location.search);
    const tabParam = params.get('tab');
    if (tabParam) return tabParam;
    return localStorage.getItem('activeAdminTab') || 'dashboard';
  };

  const [activeTab, setActiveTabState] = useState(getInitialTab);

  const setActiveTab = useCallback((tabName) => {
    setActiveTabState(tabName);
    localStorage.setItem('activeAdminTab', tabName);
    const params = new URLSearchParams(window.location.search);
    if (params.get('tab') !== tabName) {
      navigate(`/admin/dashboard?tab=${tabName}`, { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tabParam = params.get('tab');
    if (tabParam && tabParam !== activeTab) {
      setActiveTabState(tabParam);
      localStorage.setItem('activeAdminTab', tabParam);
    } else if (!tabParam) {
      navigate(`/admin/dashboard?tab=${activeTab}`, { replace: true });
    }
  }, [location.search, activeTab, navigate]);

  const [imageToCrop, setImageToCrop] = useState(null);
  const [cropTarget, setCropTarget] = useState(null);
  const [cropAspect, setCropAspect] = useState(16 / 9); // Default aspect ratio
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 768);
  const [openDropdown, setOpenDropdown] = useState(''); // State untuk dropdown yang aktif

  // State untuk Galeri (diperbarui)

  // Gallery Categories (Album Types)
  const [albumCategories, setAlbumCategories] = useState([]);
  const [showAlbumCategoryModal, setShowAlbumCategoryModal] = useState(false);
  const [isEditingAlbumCategory, setIsEditingAlbumCategory] = useState(false);
  const [currentAlbumCategory, setCurrentAlbumCategory] = useState({ id: '', name: '' });

  // Gallery (Albums)
  const [galleryCategories, setGalleryCategories] = useState([]); // This stores the Albums
  const [gallerySearchQuery, setGallerySearchQuery] = useState('');
  const [gallerySelectedYear, setGallerySelectedYear] = useState('Semua Tahun');
  const [gallerySelectedCategory, setGallerySelectedCategory] = useState('Semua');
  const [galleryVisibilityFilter, setGalleryVisibilityFilter] = useState('Semua'); // 'Semua' | 'Visible' | 'Hidden'
  const [galleryCurrentPage, setGalleryCurrentPage] = useState(1);
  const GALLERY_ITEMS_PER_PAGE = 12;
  const [showCategoryForm, setShowCategoryForm] = useState(false);
  const [categoryName, setCategoryName] = useState('');
  const [categoryDate, setCategoryDate] = useState('');
  const [categoryEndDate, setCategoryEndDate] = useState('');
  const [categoryDescription, setCategoryDescription] = useState('');
  const [categoryFile, setCategoryFile] = useState(null);
  const [categoryPreview, setCategoryPreview] = useState(null);
  const [categoryExternalLink, setCategoryExternalLink] = useState('');
  const [categoryExternalLinks, setCategoryExternalLinks] = useState([{ label: 'Day 1', url: '' }]);

  const handleAddCategoryExternalLink = () => {
    setCategoryExternalLinks(prev => [...prev, { label: `Day ${prev.length + 1}`, url: '' }]);
  };

  const handleUpdateCategoryExternalLink = (index, field, value) => {
    setCategoryExternalLinks(prev => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  const handleRemoveCategoryExternalLink = (index) => {
    setCategoryExternalLinks(prev => prev.filter((_, i) => i !== index));
  };
  const [activeGalleryCategory, setActiveGalleryCategory] = useState(null);
  const [categoryId, setCategoryId] = useState(null);
  const [isEditingCategory, setIsEditingCategory] = useState(false);
  const [selectedAlbumCategory, setSelectedAlbumCategory] = useState(''); // Selected Category for the Album being created/edited

  // Drag and Drop State (Moved to top level)
  const [draggedGalleryItem, setDraggedGalleryItem] = useState(null);
  const [isGalleryOrderChanged, setIsGalleryOrderChanged] = useState(false);
  // groupedGalleryImages dihapus
  // orphanedPhotos dihapus

  // Section Management State dihapus


  // State untuk Berita (News CMS)
  const [beritaList, setBeritaList] = useState([]);
  const [currentBerita, setCurrentBerita] = useState({ title: '', content: '', excerpt: '', image: '', imagePath: '', instagramLink: '', videoUrl: '', tiktokLink: '', status: 'draft', linkedGallery: '', titleAlignment: 'left', titleColor: '#2563eb', contentAlignment: 'left', fullDescription: '' });
  const [beritaFile, setBeritaFile] = useState(null);
  const [beritaPreview, setBeritaPreview] = useState('');
  const [isEditingBerita, setIsEditingBerita] = useState(false);
  const [showBeritaForm, setShowBeritaForm] = useState(false);
  const [showBeritaCategoryModal, setShowBeritaCategoryModal] = useState(false);
  const [beritaId, setBeritaId] = useState(null);
  // State untuk paginasi berita
  const [beritaSearchTerm, setBeritaSearchTerm] = useState('');
  const [filteredBeritaList, setFilteredBeritaList] = useState([]);
  const [beritaCurrentPage, setBeritaCurrentPage] = useState(1);
  const [beritaItemsPerPage] = useState(5); // Tampilkan 5 berita per halaman

  // Tooltip Helper untuk ReactQuill Toolbar
  useEffect(() => {
    if (showBeritaForm) {
      const timer = setTimeout(() => {
        const toolbar = document.querySelector('.ql-toolbar');
        if (!toolbar) return;

        const titles = {
          '.ql-header': 'Ukuran / Judul Teks (Heading)',
          '.ql-lineheight': 'Jarak Antar Baris (Spasi Atas-Bawah)',
          '.ql-color': 'Warna Teks (Text Color)',
          '.ql-background': 'Warna Stabilo / Latar Teks (Highlight)',
          '.ql-bold': 'Tebal (Bold)',
          '.ql-italic': 'Miring (Italic)',
          '.ql-underline': 'Garis Bawah (Underline)',
          '.ql-strike': 'Coret Teks (Strikethrough)',
          '.ql-blockquote': 'Kutipan (Blockquote)',
          '.ql-align': 'Perataan Teks (Alignment)',
          '.ql-list[value="ordered"]': 'Daftar Angka (Numbered List)',
          '.ql-list[value="bullet"]': 'Daftar Poin (Bullet List)',
          '.ql-indent[value="-1"]': 'Kurangi Inden',
          '.ql-indent[value="+1"]': 'Tambah Inden',
          '.ql-link': 'Sisipkan Link',
          '.ql-image': 'Sisipkan Gambar',
          '.ql-clean': 'Hapus Semua Format (Reset)'
        };

        Object.entries(titles).forEach(([selector, titleText]) => {
          const els = toolbar.querySelectorAll(selector);
          els.forEach(el => el.setAttribute('title', titleText));
        });
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [showBeritaForm]);

  // Floating Image Toolbar State for ReactQuill
  const [selectedEditorImage, setSelectedEditorImage] = useState(null);
  const [imageToolbarPos, setImageToolbarPos] = useState({ top: 0, left: 0 });

  useEffect(() => {
    if (showBeritaForm) {
      const handleImageClick = (e) => {
        if (e.target && e.target.tagName === 'IMG') {
          const img = e.target;
          const rect = img.getBoundingClientRect();
          const modalBody = document.querySelector('.admin-modal-body');
          const bodyRect = modalBody ? modalBody.getBoundingClientRect() : { top: 0, left: 0 };

          setSelectedEditorImage(img);
          setImageToolbarPos({
            top: Math.max(10, (rect.top - bodyRect.top) + (modalBody ? modalBody.scrollTop : 0) - 45),
            left: Math.max(10, (rect.left - bodyRect.left) + (rect.width / 2) - 180)
          });
        } else if (!e.target.closest('.image-floating-toolbar')) {
          setSelectedEditorImage(null);
        }
      };

      const timer = setTimeout(() => {
        const editor = document.querySelector('.ql-editor');
        if (editor) {
          editor.addEventListener('click', handleImageClick);
        }
      }, 300);

      return () => {
        clearTimeout(timer);
        const editor = document.querySelector('.ql-editor');
        if (editor) editor.removeEventListener('click', handleImageClick);
      };
    } else {
      setSelectedEditorImage(null);
    }
  }, [showBeritaForm]);

  // State untuk Prestasi
  const [prestasiList, setPrestasiList] = useState([]);
  const [currentPrestasi, setCurrentPrestasi] = useState({ title: '', excerpt: '', content: '', image: '', date: '', order: 0 });
  const [prestasiFile, setPrestasiFile] = useState(null);
  const [prestasiPreview, setPrestasiPreview] = useState('');
  const [isEditingPrestasi, setIsEditingPrestasi] = useState(false);
  const [prestasiId, setPrestasiId] = useState(null);
  const [showPrestasiForm, setShowPrestasiForm] = useState(false);

  // State untuk Alumni Lulus
  const [alumniLulusList, setAlumniLulusList] = useState([]);
  const [currentAlumniLulus, setCurrentAlumniLulus] = useState({ title: '', excerpt: '', content: '', image: '', date: '', order: 0 });
  const [alumniLulusFile, setAlumniLulusFile] = useState(null);
  const [alumniLulusPreview, setAlumniLulusPreview] = useState('');
  const [isEditingAlumniLulus, setIsEditingAlumniLulus] = useState(false);
  const [alumniLulusId, setAlumniLulusId] = useState(null);
  const [showAlumniLulusForm, setShowAlumniLulusForm] = useState(false);

  // State untuk Testimoni Alumni
  const [testimoniList, setTestimoniList] = useState([]);
  const [currentTestimoni, setCurrentTestimoni] = useState({ title: '', excerpt: '', content: '', image: '', date: '', order: 0 });
  const [testimoniFile, setTestimoniFile] = useState(null);
  const [testimoniPreview, setTestimoniPreview] = useState('');
  const [isEditingTestimoni, setIsEditingTestimoni] = useState(false);
  const [testimoniId, setTestimoniId] = useState(null);
  const [showTestimoniForm, setShowTestimoniForm] = useState(false);


  // State untuk Kategori Berita
  const [beritaCategories, setBeritaCategories] = useState([]);
  const [isEditingBeritaCategory, setIsEditingBeritaCategory] = useState(false);
  const [beritaCategoryId, setBeritaCategoryId] = useState(null);
  const [beritaCategoryName, setBeritaCategoryName] = useState('');
  const [beritaCategoryColor, setBeritaCategoryColor] = useState('#3498db'); // Default color
  const [originalBeritaCategoryName, setOriginalBeritaCategoryName] = useState(''); // State baru untuk nama kategori lama

  // State untuk Staff (Guru & Kependidikan)
  const [staffList, setStaffList] = useState([]);
  const [currentStaff, setCurrentStaff] = useState({ name: '', role: '', type: 'pendidik', image: '', public_id: '', order: 0 });
  const [staffFile, setStaffFile] = useState(null);
  const [staffPreview, setStaffPreview] = useState('');
  const [isEditingStaff, setIsEditingStaff] = useState(false);
  const [staffId, setStaffId] = useState(null);
  // State baru untuk sorting staff
  const [showStaffForm, setShowStaffForm] = useState(false);
  const [staffSortBy, setStaffSortBy] = useState('order'); // Default: urutkan berdasarkan urutan
  const [staffSortOrder, setStaffSortOrder] = useState('asc'); // Default: urutan menaik
  // State baru untuk search staff
  const [staffSearchTerm, setStaffSearchTerm] = useState('');
  const [filteredStaffList, setFilteredStaffList] = useState([]);
  const [staffViewMode, setStaffViewMode] = useState('list'); // 'grid' or 'list'

  // State untuk Ruang Publik
  const [publicFacilitiesList, setPublicFacilitiesList] = useState([]);
  const [currentPublicFacility, setCurrentPublicFacility] = useState({ title: '', description: '', image: '', public_id: '', order: 0 });
  const [publicFacilityFile, setPublicFacilityFile] = useState(null);
  const [publicFacilityPreview, setPublicFacilityPreview] = useState('');
  const [isEditingPublicFacility, setIsEditingPublicFacility] = useState(false);
  const [publicFacilityId, setPublicFacilityId] = useState(null);
  const [showPublicFacilityForm, setShowPublicFacilityForm] = useState(false);

  // State untuk Pengembangan Akademik
  const [academicFacilitiesList, setAcademicFacilitiesList] = useState([]);
  const [currentAcademicFacility, setCurrentAcademicFacility] = useState({ title: '', description: '', image: '', public_id: '', order: 0, fullDescription: '', linkedGallery: '' });
  const [academicFacilityFile, setAcademicFacilityFile] = useState(null);
  const [academicFacilityPreview, setAcademicFacilityPreview] = useState('');
  const [isEditingAcademicFacility, setIsEditingAcademicFacility] = useState(false);
  const [academicFacilityId, setAcademicFacilityId] = useState(null);
  const [showAcademicFacilityForm, setShowAcademicFacilityForm] = useState(false);

  // State untuk Program Keahlian (Majors)
  const [majorsList, setMajorsList] = useState([]);
  const [currentMajor, setCurrentMajor] = useState({ title: '', description: '', image: '', public_id: '', order: 0, fullDescription: '', linkedGallery: '', careerProspects: [] });
  const [majorFile, setMajorFile] = useState(null);
  const [majorPreview, setMajorPreview] = useState('');
  const [isEditingMajor, setIsEditingMajor] = useState(false);
  const [majorId, setMajorId] = useState(null);
  const [showMajorForm, setShowMajorForm] = useState(false);
  // State untuk Prospek Karir dinamis
  const [careerProspects, setCareerProspects] = useState([{ title: '', description: '' }]);

  // --- END OF MAJORS STATE ---


  // State untuk Ekstrakurikuler
  const [ekstrakurikulerList, setEkstrakurikulerList] = useState([]);
  const [currentEkstrakurikuler, setCurrentEkstrakurikuler] = useState({ title: '', description: '', image: '', public_id: '', order: 0 });
  const [ekstrakurikulerFile, setEkstrakurikulerFile] = useState(null);
  const [ekstrakurikulerPreview, setEkstrakurikulerPreview] = useState('');
  const [isEditingEkstrakurikuler, setIsEditingEkstrakurikuler] = useState(false);
  const [ekstrakurikulerId, setEkstrakurikulerId] = useState(null);
  const [showEkstrakurikulerForm, setShowEkstrakurikulerForm] = useState(false);

  // State untuk Mitra Industri
  const [mitraList, setMitraList] = useState([]);
  const [currentMitra, setCurrentMitra] = useState({ name: '', website: '', logoUrl: '', public_id: '', order: 0, category: 'Hotel' });
  const [mitraFile, setMitraFile] = useState(null);
  const [mitraPreview, setMitraPreview] = useState('');
  const [isEditingMitra, setIsEditingMitra] = useState(false);
  const [mitraId, setMitraId] = useState(null);
  const [showMitraForm, setShowMitraForm] = useState(false);

  const [siteSettings, setSiteSettings] = useState({ siteName: '', tagline: '', contactEmail: '', contactPhone: '', contactPhone2: '', address: '', googleMapsUrl: '', instagramUrl: '', spmbWhatsappNumbers: [], isMaintenanceMode: false });

  // State untuk preview gambar Hero
  const [heroImages, setHeroImages] = useState([]); // Mengganti state untuk menampung array gambar hero
  const [heroSlideDuration, setHeroSlideDuration] = useState(8); // Durasi slide dalam detik
  const [isSavingHeroDuration, setIsSavingHeroDuration] = useState(false);
  const [showAddHeroLinkModal, setShowAddHeroLinkModal] = useState(false);
  const [heroMediaUrlInput, setHeroMediaUrlInput] = useState('');
  const [heroMediaTypeInput, setHeroMediaTypeInput] = useState('auto');
  const [heroMediaDurationInput, setHeroMediaDurationInput] = useState('');
  const [isAddingHeroLink, setIsAddingHeroLink] = useState(false);

  // State untuk preview gambar di Halaman Tentang Kami
  const [kepsekImagePreview, setKepsekImagePreview] = useState('');
  const [orgChartPreview, setOrgChartPreview] = useState('');
  const [ctaBgPreview, setCtaBgPreview] = useState('');

  // State untuk Video Shorts
  const [shortVideosList, setShortVideosList] = useState([]);
  const [currentShortVideo, setCurrentShortVideo] = useState({ title: '', url: '', public_id: '', order: 0 });
  const [isEditingShortVideo, setIsEditingShortVideo] = useState(false);
  const [shortVideoId, setShortVideoId] = useState(null);
  const [showShortVideoForm, setShowShortVideoForm] = useState(false);
  const [shortsViewMode, setShortsViewMode] = useState('list'); // 'list' or 'grid'



  // State untuk Video Youtube (Horizontal)
  const [youtubeVideosList, setYoutubeVideosList] = useState([]);
  const [currentYoutubeVideo, setCurrentYoutubeVideo] = useState({ title: '', url: '', public_id: '', order: 0 });
  const [isEditingYoutubeVideo, setIsEditingYoutubeVideo] = useState(false);
  const [youtubeVideoId, setYoutubeVideoId] = useState(null);
  const [showYoutubeVideoForm, setShowYoutubeVideoForm] = useState(false);
  const [youtubeViewMode, setYoutubeViewMode] = useState('list'); // 'list' or 'grid'

  // State untuk Halaman Tentang Kami
  const [tentangKamiContent, setTentangKamiContent] = useState({
    sambutan_text: '',
    sambutan_nama: '',
    sambutan_jabatan: '',
    visi: '',
    misi: '',
    sejarah: '',
    sambutan_imageUrl: '',
    organizationChartUrl: '',
  });

  // State untuk Halaman SPMB
  const [spmbPageContent, setSpmbPageContent] = useState({
    introTitle: '',
    introDescription: '',
    spmbPosters: [], // Mengubah dari introImageUrl menjadi array spmbPosters
  });

  // State untuk konfirmasi modal
  const [confirmModalState, setConfirmModalState] = useState({ isOpen: false, title: '', message: '', onConfirm: () => { } });

  // State untuk expand/collapse pesan
  const [expandedPesanId, setExpandedPesanId] = useState(null);

  // --- State for Dashboard Overview ---
  const [dashboardStats, setDashboardStats] = useState({
    beritaCount: 0,
    pesanCount: 0,
    unreadPesanCount: 0,
    galleryCount: 0,
    prestasiCount: 0,
    alumniLulusCount: 0
  });

  const [recentActivity, setRecentActivity] = useState([]);

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour < 11) return 'Selamat Pagi';
    if (hour < 15) return 'Selamat Siang';
    if (hour < 18) return 'Selamat Sore';
    return 'Selamat Malam';
  };



  // Cek status login. Jika tidak ada user, redirect ke halaman login.
  useEffect(() => {
    if (!currentUser) {
      navigate('/admin');
    }
  }, [currentUser, navigate]);

  // Efek untuk menampilkan notifikasi dari halaman login atau halaman lain
  useEffect(() => {
    if (location.state?.message) {
      toast.success(location.state.message);
      // Hapus state dari lokasi agar notifikasi tidak muncul lagi saat refresh
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, [location, navigate]);

  // ... (fetch functions) ...

  const fetchPesan = useCallback(async () => {
    const q = query(collection(db, 'pesanKontak'), orderBy('timestamp', 'desc'));
    const querySnapshot = await getDocs(q);
    const pesanData = querySnapshot.docs.map(doc => {
      const data = doc.data();
      return {
        id: doc.id,
        name: data.name,
        email: data.email,
        subject: data.subject,
        message: data.message,
        timestamp: data.timestamp?.toDate().toLocaleString('id-ID') || 'No date',
        read: data.read || false, // Default ke false jika field tidak ada
      };
    });
    setPesanKontak(pesanData);
  }, []);

  // ... (rest of fetch functions) ...

  // ... (skipping down to render/header) ...





  const fetchGalleryCategories = useCallback(async () => {
    // Ambil data tanpa sorting dari server untuk menghindari error composite index.
    const q = query(collection(db, 'galeri_kategori'));
    const querySnapshot = await getDocs(q);
    let categoriesData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

    // Lakukan sorting di client-side berdasarkan order (asc), lalu nama.
    categoriesData.sort((a, b) => {
      if (a.order !== undefined && b.order !== undefined) {
        return a.order - b.order;
      }
      return a.name.localeCompare(b.name);
    });

    setGalleryCategories(categoriesData);
  }, []);

  const fetchAlbumCategories = useCallback(async () => {
    try {
      const q = query(collection(db, 'album_categories'), orderBy('name', 'asc'));
      const querySnapshot = await getDocs(q);
      const categoriesData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setAlbumCategories(categoriesData);
    } catch (error) {
      console.error("Error fetching album categories:", error);
    }
  }, []);

  const fetchBerita = useCallback(async () => {
    const q = query(collection(db, 'berita'), orderBy('date', 'desc'));
    const querySnapshot = await getDocs(q);
    const beritaData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setBeritaList(beritaData);
  }, []);

  const fetchPrestasi = useCallback(async () => {
    const q = query(collection(db, 'prestasi'), orderBy('date', 'desc'));
    const querySnapshot = await getDocs(q);
    const prestasiData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setPrestasiList(prestasiData);
  }, []);

  const fetchAlumniLulus = useCallback(async () => {
    const q = query(collection(db, 'alumni_lulus'), orderBy('date', 'desc'));
    const querySnapshot = await getDocs(q);
    const alumniLulusData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setAlumniLulusList(alumniLulusData);
  }, []);

  const fetchTestimoniAlumni = useCallback(async () => {
    const q = query(collection(db, 'testimoni_alumni'), orderBy('order', 'asc'));
    const querySnapshot = await getDocs(q);
    const testimoniData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setTestimoniList(testimoniData);
  }, []);


  const fetchBeritaCategories = useCallback(async () => {
    const q = query(collection(db, 'berita_kategori'), orderBy('name', 'asc'));
    const querySnapshot = await getDocs(q);
    const categoriesData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setBeritaCategories(categoriesData);
  }, []);

  const fetchSiteSettings = useCallback(async () => {
    const docRef = doc(db, "settings", "siteConfig");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      setSiteSettings({
        ...data,
        spmbWhatsappNumbers: data.spmbWhatsappNumbers || [], // Pastikan array ada
        spmbRegistrationLink: data.spmbRegistrationLink || '' // Tambahkan link pendaftaran
      });
    } else {
      console.log("No site settings found, using defaults.");
    }
  }, []);

  const fetchTentangKamiContent = useCallback(async () => {
    const docRef = doc(db, "pageContent", "tentangKami");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      // Fallback untuk field yang mungkin belum ada di db
      const data = docSnap.data();
      setTentangKamiContent({
        sambutan_text: '',
        sambutan_nama: '',
        sambutan_jabatan: '',
        visi: '',
        misi: '',
        sejarah: '',
        ...data
      });
      setKepsekImagePreview(data.sambutan_imageUrl || '');
      setOrgChartPreview(data.organizationChartUrl || '');
    } else {
      console.log("No 'Tentang Kami' content found! You can save new content from the form.");
    }
  }, []);

  const fetchStaff = useCallback(async () => {
    // Modifikasi query untuk menggunakan state sorting
    const q = query(collection(db, 'staff'), orderBy(staffSortBy, staffSortOrder));
    const querySnapshot = await getDocs(q);
    const staffData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setStaffList(staffData);
  }, [staffSortBy, staffSortOrder]);

  const fetchPublicFacilities = useCallback(async () => {
    const q = query(collection(db, 'publicFacilities'), orderBy('order', 'asc'));
    const querySnapshot = await getDocs(q);
    const facilitiesData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setPublicFacilitiesList(facilitiesData);
  }, []);

  const fetchAcademicFacilities = useCallback(async () => {
    const q = query(collection(db, 'academicFacilities'), orderBy('order', 'asc'));
    const querySnapshot = await getDocs(q);
    const facilitiesData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setAcademicFacilitiesList(facilitiesData);
  }, []);

  const fetchMajors = useCallback(async () => {
    const q = query(collection(db, 'majors'), orderBy('order', 'asc'));
    const querySnapshot = await getDocs(q);
    const majorsData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setMajorsList(majorsData);
  }, []);


  const fetchEkstrakurikuler = useCallback(async () => {
    const q = query(collection(db, 'ekstrakurikuler'), orderBy('order', 'asc'));
    const querySnapshot = await getDocs(q);
    const ekstrakurikulerData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setEkstrakurikulerList(ekstrakurikulerData);
  }, []);

  const fetchMitra = useCallback(async () => {
    const q = query(collection(db, 'mitraIndustri'), orderBy('order', 'asc'));
    const querySnapshot = await getDocs(q);
    const mitraData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setMitraList(mitraData);
  }, []);

  const fetchShortVideos = useCallback(async () => {
    const q = query(collection(db, 'shortVideos'), orderBy('date', 'desc'));
    const querySnapshot = await getDocs(q);
    const videosData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setShortVideosList(videosData);
  }, []);

  const fetchYoutubeVideos = useCallback(async () => {
    const q = query(collection(db, 'youtubeVideos'), orderBy('date', 'desc'));
    const querySnapshot = await getDocs(q);
    const videosData = querySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
    setYoutubeVideosList(videosData);
  }, []);

  const fetchHomePageContent = useCallback(async () => {
    const docRef = doc(db, "pageContent", "homePage");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      // Pastikan heroImages adalah array
      const data = docSnap.data();
      const images = data.heroImages || [];
      setHeroImages(Array.isArray(images) ? images : []);
      if (data.heroSlideDuration) {
        setHeroSlideDuration(Number(data.heroSlideDuration));
      }

      setCtaBgPreview(data.ctaBgUrl || ''); // Ambil URL gambar CTA
    } else {
      setHeroImages([]); // Set array kosong jika dokumen tidak ada
      setHeroSlideDuration(8);
      console.log("No homePage content document found.");
    }
  }, []);

  const fetchSpmbPageContent = useCallback(async () => {
    const docRef = doc(db, "pageContent", "spmbPage");
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      const data = docSnap.data();
      setSpmbPageContent({
        ...data,
        spmbPosters: Array.isArray(data.spmbPosters) ? data.spmbPosters : [] // Pastikan spmbPosters adalah array
      });
    } else {
      // Set state default jika dokumen belum ada
      setSpmbPageContent({ introTitle: '', introDescription: '', spmbPosters: [], brochureLink: '' });
      console.log("No SPMB page content document found.");
    }
  }, []);

  // --- KURIKULUM LOGIC ---
  const [kurikulumContent, setKurikulumContent] = useState({
    wakaName: '',
    wakaRole: 'Wakil Kepala Sekolah Bidang Kurikulum',
    wakaQuote: '',
    wakaImageUrl: '',
    visi: '',
    misi: [],
    programs: [],
    documents: [],
    imageUrl: ''
  });
  const [kurikulumFile, setKurikulumFile] = useState(null);
  const [kurikulumHeroFile, setKurikulumHeroFile] = useState(null); // New state for hero image
  const [kurikulumPreview, setKurikulumPreview] = useState('');

  const fetchKurikulum = useCallback(async () => {
    try {
      const docRef = doc(db, 'unitKerja', 'kurikulum');
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setKurikulumContent({
          wakaName: data.wakaName || '',
          wakaRole: data.wakaRole || 'Wakil Kepala Sekolah Bidang Kurikulum',
          wakaQuote: data.wakaQuote || '',
          wakaImageUrl: data.wakaImageUrl || '',
          visi: data.visi || '',
          misi: data.misi || [],
          programs: data.programs || [],
          documents: data.documents || [],
          imageUrl: data.imageUrl || ''
        });
      }
    } catch (err) {
      console.error("Error fetching kurikulum:", err);
    }
  }, []);

  const handleKurikulumSubmit = async (e) => {
    if (e) e.preventDefault();
    setUploading(true);
    try {
      let wakaImageUrl = kurikulumContent.wakaImageUrl || '';
      let heroImageUrl = kurikulumContent.imageUrl || '';

      if (kurikulumFile) {
        const data = await uploadCroppedImage(kurikulumFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
        wakaImageUrl = data.secure_url;
      }

      if (kurikulumHeroFile) {
        const data = await uploadCroppedImage(kurikulumHeroFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
        heroImageUrl = data.secure_url;
      }

      await setDoc(doc(db, 'unitKerja', 'kurikulum'), {
        ...kurikulumContent,
        wakaImageUrl: wakaImageUrl,
        imageUrl: heroImageUrl
      });
      toast.success('Data Kurikulum berhasil disimpan!');
      setKurikulumFile(null); // Reset file after upload
      setKurikulumHeroFile(null);
    } catch (err) {
      toast.error('Gagal menyimpan data.');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const addItemToArray = (field, item) => {
    setKurikulumContent(prev => ({ ...prev, [field]: [...prev[field], item] }));
  };

  const updateItemInArray = (field, index, newItem) => {
    setKurikulumContent(prev => {
      const newArray = [...prev[field]];
      newArray[index] = newItem;
      return { ...prev, [field]: newArray };
    });
  };

  const removeItemFromArray = (field, index) => {
    setKurikulumContent(prev => ({
      ...prev,
      [field]: (prev[field] || []).filter((_, i) => i !== index)
    }));
  };

  const handleDeleteKurikulumProgram = (index) => {
    // Add confirmation dialog
    if (window.confirm('Yakin ingin menghapus program ini?')) {
      removeItemFromArray('programs', index);
      toast.success('Program dihapus from list (click Simpan to permanent)');
    }
  };

  // --- KESISWAAN LOGIC ---
  const [kesiswaanContent, setKesiswaanContent] = useState({
    wakaName: '',
    wakaRole: 'Wakil Kepala Sekolah Bidang Kesiswaan',
    wakaQuote: '',
    wakaImageUrl: '',
    visi: '',
    misi: [],
    programs: [],
    documents: [],
    imageUrl: ''
  });
  const [kesiswaanFile, setKesiswaanFile] = useState(null);
  const [kesiswaanHeroFile, setKesiswaanHeroFile] = useState(null); // State for hero image file
  const [kesiswaanPreview, setKesiswaanPreview] = useState('');

  const fetchKesiswaan = useCallback(async () => {
    try {
      const docRef = doc(db, 'unitKerja', 'kesiswaan');
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setKesiswaanContent({
          wakaName: data.wakaName || '',
          wakaRole: data.wakaRole || 'Wakil Kepala Sekolah Bidang Kesiswaan',
          wakaQuote: data.wakaQuote || '',
          wakaImageUrl: data.wakaImageUrl || '',
          visi: data.visi || '',
          misi: data.misi || [],
          programs: data.programs || [],
          documents: data.documents || [],
          imageUrl: data.imageUrl || ''
        });
      }
    } catch (err) {
      console.error("Error fetching kesiswaan:", err);
    }
  }, []);

  const handleKesiswaanSubmit = async (e) => {
    if (e) e.preventDefault();
    setUploading(true);
    try {
      let wakaImageUrl = kesiswaanContent.wakaImageUrl || '';
      let heroImageUrl = kesiswaanContent.imageUrl || '';

      if (kesiswaanFile) {
        const data = await uploadCroppedImage(kesiswaanFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
        wakaImageUrl = data.secure_url;
      }

      if (kesiswaanHeroFile) {
        const data = await uploadCroppedImage(kesiswaanHeroFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
        heroImageUrl = data.secure_url;
      }

      await setDoc(doc(db, 'unitKerja', 'kesiswaan'), {
        ...kesiswaanContent,
        wakaImageUrl: wakaImageUrl,
        imageUrl: heroImageUrl
      });
      toast.success('Data Kesiswaan berhasil disimpan!');
      setKesiswaanFile(null);
      setKesiswaanHeroFile(null);
    } catch (err) {
      toast.error('Gagal menyimpan data.');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const addKesiswaanItem = (field, item) => {
    setKesiswaanContent(prev => ({ ...prev, [field]: [...prev[field], item] }));
  };

  const updateKesiswaanItem = (field, index, newItem) => {
    setKesiswaanContent(prev => {
      const newArray = [...prev[field]];
      newArray[index] = newItem;
      return { ...prev, [field]: newArray };
    });
  };

  const removeKesiswaanItem = (field, index) => {
    setKesiswaanContent(prev => ({
      ...prev,
      [field]: (prev[field] || []).filter((_, i) => i !== index)
    }));
  };

  const handleProgramImageUpload = async (index, e, section = 'kesiswaan') => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      try {
        setUploading(true);
        const data = await uploadCroppedImage(file, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);

        if (section === 'kesiswaan') {
          updateKesiswaanItem('programs', index, { ...kesiswaanContent.programs[index], image: data.secure_url });
        } else if (section === 'kurikulum') {
          updateItemInArray('programs', index, { ...kurikulumContent.programs[index], image: data.secure_url });
        }

        toast.success("Gambar program berhasil diunggah!");
      } catch (err) {
        console.error("Failed to upload program image", err);
        toast.error("Gagal mengunggah gambar program.");
      } finally {
        setUploading(false);
      }
    }
  };

  const fetchDashboardStats = useCallback(async () => {
    try {
      // 1. Count Berita
      const beritaSnapshot = await getDocs(collection(db, 'berita'));
      const beritaCount = beritaSnapshot.size;

      // 2. Count Pesan (Total & Unread)
      const pesanSnapshot = await getDocs(collection(db, 'pesanKontak'));
      const pesanCount = pesanSnapshot.size;
      const unreadPesanCount = pesanSnapshot.docs.filter(doc => !doc.data().read).length;

      // 3. Count Gallery Images
      const gallerySnapshot = await getDocs(collection(db, 'galeri'));
      const galleryCount = gallerySnapshot.size;

      // 4. Count Prestasi
      const prestasiSnapshot = await getDocs(collection(db, 'prestasi'));
      const prestasiCount = prestasiSnapshot.size;

      // 4.5 Count Alumni Lulus
      const alumniLulusSnapshot = await getDocs(collection(db, 'alumni_lulus'));
      const alumniLulusCount = alumniLulusSnapshot.size;

      setDashboardStats({
        beritaCount,
        pesanCount,
        unreadPesanCount,
        galleryCount,
        prestasiCount,
        alumniLulusCount
      });

      // 5. Fetch Recent Activity (Mixed)
      const recentBeritaQuery = query(collection(db, 'berita'), orderBy('date', 'desc'), where('status', '==', 'published')); // Limit manually
      const recentPesanQuery = query(collection(db, 'pesanKontak'), orderBy('timestamp', 'desc'));

      const [recentBeritaSnap, recentPesanSnap] = await Promise.all([
        getDocs(recentBeritaQuery),
        getDocs(recentPesanQuery)
      ]);

      const activities = [];

      recentBeritaSnap.docs.slice(0, 3).forEach(doc => {
        activities.push({
          id: doc.id,
          type: 'berita',
          title: doc.data().title || 'Berita Baru',
          desc: 'Telah dipublikasikan',
          time: doc.data().date ? new Date(doc.data().date) : new Date(),
          icon: <FaNewspaper style={{ color: '#52c41a' }} />
        });
      });

      recentPesanSnap.docs.slice(0, 3).forEach(doc => {
        activities.push({
          id: doc.id,
          type: 'pesan',
          title: doc.data().name || 'Pesan Baru',
          desc: 'Mengirim pesan baru',
          time: doc.data().timestamp ? new Date(doc.data().timestamp.seconds * 1000) : new Date(), // Handle both string/timestamp later if needed, mostly explicit timestamp in firestore
          icon: <FaEnvelope style={{ color: '#1890ff' }} />
        });
      });

      // Sort combined activities
      activities.sort((a, b) => b.time - a.time);
      setRecentActivity(activities.slice(0, 5));

    } catch (error) {
      console.error("Error fetching dashboard stats:", error);
    }
  }, []);


  // Ambil data hanya jika pengguna sudah login.
  useEffect(() => {
    if (currentUser) {
      if (activeTab === 'halamanutama') fetchHomePageContent();
      if (activeTab === 'kurikulum') fetchKurikulum(); // Fetch data Kurikulum
      if (activeTab === 'pesan') fetchPesan();
      if (activeTab === 'galeri') {
        fetchGalleryCategories();
        fetchAlbumCategories();
      }
      if (activeTab === 'berita') {
        fetchBerita();
        fetchGalleryCategories(); // Ambil kategori galeri untuk dropdown di form berita
        fetchBeritaCategories(); // Ambil kategori berita
      }
      if (activeTab === 'pengaturan') fetchSiteSettings();
      if (activeTab === 'tentang-kami') fetchTentangKamiContent();
      if (activeTab === 'program-keahlian') fetchMajors();
      if (activeTab === 'ruang-publik') fetchPublicFacilities();
      if (activeTab === 'pengembangan-akademik') {
        fetchAcademicFacilities();
        fetchGalleryCategories();
      }
      if (activeTab === 'ekstrakurikuler') fetchEkstrakurikuler();
      // Fetch data untuk unit kerja
      if (activeTab === 'kesiswaan') fetchKesiswaan();
      if (activeTab === 'spmb') fetchSpmbPageContent();
      if (activeTab === 'mitra-industri') fetchMitra();
      if (activeTab === 'prestasi') fetchPrestasi();
      if (activeTab === 'alumni-lulus') fetchAlumniLulus();
      if (activeTab === 'testimoni-alumni') fetchTestimoniAlumni();
      if (activeTab === 'video-shorts') fetchShortVideos();
      if (activeTab === 'video-shorts') fetchShortVideos();
      if (activeTab === 'video-youtube') fetchYoutubeVideos();
      if (activeTab === 'dashboard') fetchDashboardStats();
    }
  }, [currentUser, activeTab, fetchHomePageContent, fetchKurikulum, fetchKesiswaan, fetchPesan, fetchGalleryCategories, fetchAlbumCategories, fetchBerita, fetchBeritaCategories, fetchSiteSettings, fetchTentangKamiContent, fetchPublicFacilities, fetchMajors, fetchAcademicFacilities, fetchEkstrakurikuler, fetchSpmbPageContent, fetchStaff, fetchPrestasi, fetchAlumniLulus, fetchTestimoniAlumni, fetchMitra, fetchShortVideos, fetchYoutubeVideos, fetchDashboardStats]);

  // useEffect khusus untuk staff, agar sorting bisa trigger re-fetch
  useEffect(() => {
    if (currentUser && activeTab === 'staf') {
      fetchStaff();
    }
  }, [currentUser, activeTab, fetchStaff]);

  // useEffect untuk filtering staff
  useEffect(() => {
    const lowercasedFilter = staffSearchTerm.toLowerCase();
    const filteredData = staffList.filter(item => {
      // Mencari berdasarkan nama atau jabatan, dengan pengaman
      return item && item.name && item.role && (
        item.name.toLowerCase().includes(lowercasedFilter) ||
        item.role.toLowerCase().includes(lowercasedFilter)
      );
    });
    setFilteredStaffList(filteredData);
  }, [staffSearchTerm, staffList]);





  // Utility untuk membuat slug URL-friendly dari judul
  const createSlug = (title) => title ? title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)+/g, '') : '';

  // useEffect untuk filtering berita
  useEffect(() => {
    const lowercasedFilter = beritaSearchTerm.toLowerCase();
    const filteredData = beritaList.filter(item => {
      // Mencari berdasarkan judul
      return item.title && item.title.toLowerCase().includes(lowercasedFilter);
    });
    setFilteredBeritaList(filteredData);
    setBeritaCurrentPage(1); // Reset ke halaman pertama setiap kali ada pencarian baru
  }, [beritaSearchTerm, beritaList]);

  // --- LOGIKA PAGINASI UNTUK BERITA ---
  const indexOfLastBerita = beritaCurrentPage * beritaItemsPerPage;
  const indexOfFirstBerita = indexOfLastBerita - beritaItemsPerPage;
  const currentBeritaItems = filteredBeritaList.slice(indexOfFirstBerita, indexOfLastBerita);

  const pageNumbersBerita = [];
  for (let i = 1; i <= Math.ceil(filteredBeritaList.length / beritaItemsPerPage); i++) {
    pageNumbersBerita.push(i);
  }

  const paginateBerita = (pageNumber) => setBeritaCurrentPage(pageNumber);

  if (!currentUser) {
    return <div style={{ padding: '20px', textAlign: 'center' }}>Memeriksa otentikasi...</div>;
  }

  const handleFileChangeWithCrop = (e, target, aspect) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener('load', () => setImageToCrop(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      setCropTarget(target);
      setCropAspect(aspect); // Set aspect ratio untuk cropper
      // Reset the input value to allow re-selecting the same file
      // Sembunyikan form staf sementara saat cropper aktif
      if (target === 'staff') {
        setShowStaffForm(false);
      }
      if (target === 'mitra') {
        setShowMitraForm(false);
      }
      e.target.value = null;
      window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll ke atas saat cropper muncul
    }
  };

  // --- FUNGSI BARU UNTUK UPLOAD GAMBAR PENUH (TANPA CROP) ---
  const handleFullImageUpload = (e, target) => {
    if (e.target.files && e.target.files.length > 0) {
      const files = Array.from(e.target.files);
      const previewUrls = files.map(file => URL.createObjectURL(file));

      // Untuk kasus unggah tunggal, kita ambil file dan preview pertama
      const file = files[0];
      const previewUrl = previewUrls[0];


      switch (target) {
        case 'berita':
          setBeritaFile(file);
          setBeritaPreview(previewUrl);
          break;
        case 'staff':
          setStaffFile(file);
          setStaffPreview(previewUrl);
          break;
        case 'publicFacility':
          setPublicFacilityFile(file);
          setPublicFacilityPreview(previewUrl);
          break;
        case 'academicFacility':
          setAcademicFacilityFile(file);
          setAcademicFacilityPreview(previewUrl);
          break;
        case 'major':
          setMajorFile(file);
          setMajorPreview(previewUrl);
          break;
        case 'ekstrakurikuler':
          setEkstrakurikulerFile(file);
          setEkstrakurikulerPreview(previewUrl);
          break;
        case 'prestasi':
          setPrestasiFile(file);
          setPrestasiPreview(previewUrl);
          break;
        case 'alumni-lulus':
          setAlumniLulusFile(file);
          setAlumniLulusPreview(previewUrl);
          break;

        case 'mitra':
          setMitraFile(file);
          setMitraPreview(previewUrl);
          break;
        case 'kurikulum':
          setKurikulumFile(file);
          setKurikulumPreview(previewUrl);
          break;
        case 'kesiswaan':
          setKesiswaanFile(file);
          setKesiswaanPreview(previewUrl);
          break;
        case 'kesiswaanHero':
          setKesiswaanHeroFile(file);
          setKesiswaanContent(prev => ({ ...prev, imageUrl: previewUrl }));
          break;
        case 'testimoni':
          setTestimoniFile(file);
          setTestimoniPreview(previewUrl);
          break;
        default:
          break;
      }
      // Reset input value agar bisa memilih file yang sama lagi
      e.target.value = null;
    }
  };

  // --- HELPER UNTUK MEMILIH GAMBAR HALAMAN SECARA FULL (TANPA CROP) ---
  const handleFullPageImageSelect = (e, previewSetter) => {
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      setFile(selectedFile); // Set state global file yang digunakan oleh handlePageImageUpload
      const previewUrl = URL.createObjectURL(selectedFile);
      previewSetter(previewUrl);
      // Reset input value
      e.target.value = null;
    }
  };

  const onCropCancel = () => {
    setImageToCrop(null);
    setCropTarget(null);
    setCropAspect(undefined); // Reset aspect
    // Tampilkan kembali form staf jika proses crop dibatalkan dari sana
    if (cropTarget === 'staff') {
      setShowStaffForm(true);
    }
    if (cropTarget === 'mitra') {
      setShowMitraForm(true);
    }
    // Tampilkan kembali form jika proses crop dibatalkan
    if (cropTarget === 'berita' || cropTarget === 'publicFacility' || cropTarget === 'academicFacility' || cropTarget === 'ekstrakurikuler' || cropTarget === 'mitra') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // --- FUNGSI UNTUK MENGGANTI GAMBAR DI HALAMAN TERTENTU ---
  const handlePageImageUpload = async (pageId, fieldId) => {
    if (!file) {
      setError('Pilih file gambar terlebih dahulu.');
      return;
    }
    setUploading(true);
    setError('');
    setSuccessMessage('');

    const formData = new FormData();
    formData.append('file', file);
    formData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);

    try {
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`,
        {
          method: 'POST',
          body: formData,
        }
      );
      const data = await response.json();

      // Update URL di Firestore. Gunakan setDoc dengan merge untuk membuat dokumen jika belum ada.
      await setDoc(doc(db, 'pageContent', pageId), { [fieldId]: data.secure_url, [`${fieldId}_public_id`]: data.public_id }, { merge: true });

      setSuccessMessage('Gambar berhasil diperbarui!');
      // Ambil ulang data yang relevan untuk update preview
      if (pageId === 'homePage') {
        fetchHomePageContent();
      } else if (pageId === 'tentangKami') {
        fetchTentangKamiContent();
      }
      setFile(null); // Reset file input
    } catch (err) {
      setError('Upload gagal. Coba lagi.');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  // --- FUNGSI UNTUK PRESTASI (CRUD) ---
  const resetPrestasiForm = () => {
    setIsEditingPrestasi(false);
    setPrestasiId(null);
    setCurrentPrestasi({ title: '', excerpt: '', content: '', image: '', date: '', order: 0 });
    setPrestasiFile(null);
    setPrestasiPreview('');
    setShowPrestasiForm(false);
    const form = document.getElementById('prestasi-form');
    if (form) form.reset();
  };

  const handlePrestasiSubmit = async (e) => {
    e.preventDefault();
    if (!currentPrestasi.title || !currentPrestasi.excerpt || !currentPrestasi.content) {
      setError("Judul, Kutipan, dan Konten tidak boleh kosong.");
      return;
    }
    setUploading(true);
    setError('');
    setSuccessMessage('');

    let imageUrl = currentPrestasi.image || '';
    let publicId = currentPrestasi.public_id || '';

    try {
      if (prestasiFile) {
        const data = await uploadCroppedImage(prestasiFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
        imageUrl = data.secure_url;
        publicId = data.public_id;
      }

      const prestasiData = {
        ...currentPrestasi,
        image: imageUrl || '',
        public_id: publicId || '',
        slug: createSlug(currentPrestasi.title),
        date: currentPrestasi.date ? new Date(currentPrestasi.date) : serverTimestamp(),
        lastUpdated: serverTimestamp(),
      };

      if (isEditingPrestasi) {
        const docRef = doc(db, 'prestasi', prestasiId);
        await updateDoc(docRef, prestasiData);
        toast.success('Data prestasi berhasil diperbarui.');
      } else {
        await addDoc(collection(db, 'prestasi'), prestasiData);
        toast.success('Prestasi baru berhasil ditambahkan.');
      }

      resetPrestasiForm();
      fetchPrestasi();
    } catch (err) {
      toast.error('Gagal menyimpan data prestasi.');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const handleEditPrestasi = (item) => {
    setIsEditingPrestasi(true);
    setShowPrestasiForm(true);
    setPrestasiId(item.id);
    const itemDate = item.date?.toDate ? item.date.toDate().toISOString().split('T')[0] : '';
    setCurrentPrestasi({ ...item, date: itemDate });
    setPrestasiPreview(item.image);
  };

  const handleDeletePrestasi = async (id) => {
    showConfirmationModal('Hapus Prestasi?', 'Anda yakin ingin menghapus data prestasi ini?', async () => {
      await deleteDoc(doc(db, 'prestasi', id));
      toast.success('Data prestasi berhasil dihapus.');
      fetchPrestasi();
    });
  };

  // --- FUNGSI UNTUK ALUMNI LULUS (CRUD) ---
  const resetAlumniLulusForm = () => {
    setIsEditingAlumniLulus(false);
    setAlumniLulusId(null);
    setCurrentAlumniLulus({ title: '', excerpt: '', content: '', image: '', date: '', order: 0 });
    setAlumniLulusFile(null);
    setAlumniLulusPreview('');
    setShowAlumniLulusForm(false);
    const form = document.getElementById('alumni-lulus-form');
    if (form) form.reset();
  };

  const handleAlumniLulusSubmit = async (e) => {
    e.preventDefault();
    if (!currentAlumniLulus.title || !currentAlumniLulus.excerpt || !currentAlumniLulus.content) {
      setError("Nama, Kutipan, dan Konten tidak boleh kosong.");
      return;
    }
    setUploading(true);
    setError('');
    setSuccessMessage('');

    let imageUrl = currentAlumniLulus.image || '';
    let publicId = currentAlumniLulus.public_id || '';

    try {
      if (alumniLulusFile) {
        const data = await uploadCroppedImage(alumniLulusFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
        imageUrl = data.secure_url;
        publicId = data.public_id;
      }

      const alumniLulusData = {
        ...currentAlumniLulus,
        image: imageUrl || '',
        public_id: publicId || '',
        slug: createSlug(currentAlumniLulus.title),
        date: currentAlumniLulus.date ? new Date(currentAlumniLulus.date) : serverTimestamp(),
        lastUpdated: serverTimestamp(),
      };

      if (isEditingAlumniLulus) {
        const docRef = doc(db, 'alumni_lulus', alumniLulusId);
        await updateDoc(docRef, alumniLulusData);
        toast.success('Data alumni lulus berhasil diperbarui.');
      } else {
        await addDoc(collection(db, 'alumni_lulus'), alumniLulusData);
        toast.success('Data alumni lulus baru berhasil ditambahkan.');
      }

      resetAlumniLulusForm();
      fetchAlumniLulus();
    } catch (err) {
      toast.error('Gagal menyimpan data alumni lulus.');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const handleEditAlumniLulus = (item) => {
    setIsEditingAlumniLulus(true);
    setShowAlumniLulusForm(true);
    setAlumniLulusId(item.id);
    const itemDate = item.date?.toDate ? item.date.toDate().toISOString().split('T')[0] : '';
    setCurrentAlumniLulus({ ...item, date: itemDate });
    setAlumniLulusPreview(item.image);
  };

  const handleDeleteAlumniLulus = async (id) => {
    showConfirmationModal('Hapus Alumni Lulus?', 'Anda yakin ingin menghapus data alumni lulus ini?', async () => {
      await deleteDoc(doc(db, 'alumni_lulus', id));
      toast.success('Data alumni lulus berhasil dihapus.');
      fetchAlumniLulus();
    });
  };

  // --- FUNGSI UNTUK TESTIMONI ALUMNI (CRUD) ---
  const resetTestimoniForm = () => {
    setIsEditingTestimoni(false);
    setTestimoniId(null);
    setCurrentTestimoni({ title: '', excerpt: '', content: '', image: '', date: '', order: 0 });
    setTestimoniFile(null);
    setTestimoniPreview('');
    setShowTestimoniForm(false);
    const form = document.getElementById('testimoni-form');
    if (form) form.reset();
  };

  const handleTestimoniSubmit = async (e) => {
    e.preventDefault();
    if (!currentTestimoni.title || !currentTestimoni.excerpt || !currentTestimoni.content) {
      toast.error("Judul, Kutipan, dan Konten tidak boleh kosong.");
      return;
    }
    setUploading(true);

    let imageUrl = currentTestimoni.image || '';
    let publicId = currentTestimoni.public_id || '';

    try {
      if (testimoniFile) {
        const data = await uploadCroppedImage(testimoniFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
        imageUrl = data.secure_url;
        publicId = data.public_id;
      }

      const testimoniData = {
        ...currentTestimoni,
        image: imageUrl || '',
        public_id: publicId || '',
        slug: createSlug(currentTestimoni.title),
        date: currentTestimoni.date ? new Date(currentTestimoni.date) : serverTimestamp(),
        lastUpdated: serverTimestamp(),
      };

      if (isEditingTestimoni) {
        const docRef = doc(db, 'testimoni_alumni', testimoniId);
        await updateDoc(docRef, testimoniData);
        toast.success('Testimoni berhasil diperbarui.');
      } else {
        await addDoc(collection(db, 'testimoni_alumni'), testimoniData);
        toast.success('Testimoni baru berhasil ditambahkan.');
      }

      resetTestimoniForm();
      fetchTestimoniAlumni();
    } catch (err) {
      toast.error('Gagal menyimpan testimoni.');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const handleEditTestimoni = (item) => {
    setIsEditingTestimoni(true);
    setShowTestimoniForm(true);
    setTestimoniId(item.id);
    const itemDate = item.date?.toDate ? item.date.toDate().toISOString().split('T')[0] : '';
    setCurrentTestimoni({ ...item, date: itemDate });
    setTestimoniPreview(item.image);
  };

  const handleDeleteTestimoni = async (id) => {
    showConfirmationModal('Hapus Testimoni?', 'Anda yakin ingin menghapus testimoni ini?', async () => {
      await deleteDoc(doc(db, 'testimoni_alumni', id));
      toast.success('Testimoni berhasil dihapus.');
      fetchTestimoniAlumni();
    });
  };

  // --- FUNGSI UNTUK KATEGORI BERITA ---
  const handleBeritaCategorySubmit = async (e) => {
    e.preventDefault();
    if (!beritaCategoryName.trim()) {
      toast.error("Nama kategori tidak boleh kosong.");
      return;
    }
    setUploading(true);
    try {
      if (isEditingBeritaCategory) {
        const categoryRef = doc(db, 'berita_kategori', beritaCategoryId);
        await updateDoc(categoryRef, { name: beritaCategoryName, slug: createSlug(beritaCategoryName), color: beritaCategoryColor });
        toast.success("Kategori berita berhasil diperbarui.");

        // --- LOGIKA BARU: Update semua berita yang terkait ---
        if (originalBeritaCategoryName && originalBeritaCategoryName !== beritaCategoryName) {
          toast.info(`Memperbarui berita dengan kategori lama "${originalBeritaCategoryName}"...`);
          const beritaQuery = query(collection(db, 'berita'), where("category", "==", originalBeritaCategoryName));
          const beritaSnapshot = await getDocs(beritaQuery);

          const updatePromises = [];
          beritaSnapshot.forEach((beritaDoc) => {
            const beritaRef = doc(db, 'berita', beritaDoc.id);
            updatePromises.push(updateDoc(beritaRef, { category: beritaCategoryName }));
          });

          await Promise.all(updatePromises);
          if (updatePromises.length > 0) {
            toast.success(`${updatePromises.length} berita berhasil disinkronkan dengan kategori baru.`);
            fetchBerita(); // Muat ulang daftar berita untuk melihat perubahan
          }
        }
        // --- AKHIR LOGIKA BARU ---

      } else {
        await addDoc(collection(db, 'berita_kategori'), { name: beritaCategoryName, slug: createSlug(beritaCategoryName), color: beritaCategoryColor });
        toast.success("Kategori berita baru berhasil ditambahkan.");
      }
      resetBeritaCategoryForm();
      fetchBeritaCategories();
    } catch (err) {
      toast.error("Gagal menyimpan kategori berita.");
    } finally {
      setUploading(false);
    }
  };

  const handleEditBeritaCategory = (category) => {
    setIsEditingBeritaCategory(true);
    setBeritaCategoryId(category.id);
    setBeritaCategoryName(category.name);
    setBeritaCategoryColor(category.color || '#3498db');
    setOriginalBeritaCategoryName(category.name); // Simpan nama asli untuk perbandingan
  };

  const resetBeritaCategoryForm = () => {
    setIsEditingBeritaCategory(false);
    setBeritaCategoryId(null);
    setBeritaCategoryName('');
    setBeritaCategoryColor('#3498db');
    setOriginalBeritaCategoryName(''); // Reset nama asli
  };

  const handleDeleteBeritaCategory = async (id) => {
    showConfirmationModal('Hapus Kategori Berita?', 'Anda yakin ingin menghapus kategori ini? Berita yang menggunakan kategori ini tidak akan terhapus.', async () => {
      await deleteDoc(doc(db, 'berita_kategori', id));
      toast.success('Kategori berita berhasil dihapus.');
      fetchBeritaCategories();
    });
  };

  // Fungsi untuk menampilkan modal konfirmasi
  const showConfirmationModal = (title, message, onConfirm) => {
    setConfirmModalState({ isOpen: true, title, message, onConfirm });
  };

  // Fungsi untuk menutup modal konfirmasi
  const closeConfirmationModal = () => {
    setConfirmModalState({ isOpen: false, title: '', message: '', onConfirm: () => { } });
  };

  const handleConfirmAction = () => {
    confirmModalState.onConfirm();
    closeConfirmationModal();
  };

  const handleDeletePageImage = async (pageId, fieldId) => {
    showConfirmationModal('Hapus Gambar?', 'Apakah Anda yakin ingin menghapus gambar ini? Gambar akan dikosongkan.', async () => {
      try {
        setUploading(true); // Show loading state
        const publicIdField = `${fieldId}_public_id`;
        await updateDoc(doc(db, 'pageContent', pageId), {
          [fieldId]: '',
          [publicIdField]: ''
        });
        toast.success('Gambar berhasil dihapus.');
        if (pageId === 'tentangKami') {
          fetchTentangKamiContent();
        }
      } catch (error) {
        toast.error('Gagal menghapus gambar.');
        console.error("Error deleting page image: ", error);
      } finally {
        setUploading(false);
      }
    });
  };

  // --- FUNGSI-FUNGSI UPLOAD ---

  const uploadCroppedImage = async (croppedFile, uploadPreset) => {
    setUploading(true);
    // Removed legacy state clearing
    // setError('');
    // setSuccessMessage('');

    const formData = new FormData();
    formData.append('file', croppedFile);
    formData.append('upload_preset', uploadPreset);

    try {
      const response = await fetch(
        `https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/upload`,
        {
          method: 'POST',
          body: formData,
        }
      );
      const data = await response.json();
      if (!response.ok) {
        console.error("Cloudinary Error Details:", data);
        throw new Error(data.error?.message || 'Upload to Cloudinary failed');
      }
      return data;
    } catch (err) {
      toast.error(`Upload gagal: ${err.message}. Coba lagi.`);
      console.error("Upload error:", err);
      throw err; // Re-throw error to be caught by caller
    } finally {
      setUploading(false);
    }
  };



  const handleMoveHeroImage = async (index, direction) => {
    if (direction === 'up' && index === 0) return;
    if (direction === 'down' && index === heroImages.length - 1) return;

    const newImages = [...heroImages];
    const targetIndex = direction === 'up' ? index - 1 : index + 1;

    // Swap
    [newImages[index], newImages[targetIndex]] = [newImages[targetIndex], newImages[index]];

    // Optimistic update
    setHeroImages(newImages);

    try {
      await setDoc(doc(db, 'pageContent', 'homePage'), {
        heroImages: newImages
      }, { merge: true });
      // toast.success('Urutan gambar berhasil diperbarui');
    } catch (error) {
      console.error("Gagal mengubah urutan:", error);
      toast.error("Gagal mengubah urutan gambar.");
      fetchHomePageContent(); // Revert on error
    }
  };

  // --- FUNGSI BARU UNTUK HERO SLIDER ---
  const handleAddHeroImage = async (croppedFile) => {
    try {
      const data = await uploadCroppedImage(croppedFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);

      const newImage = {
        url: data.secure_url,
        public_id: data.public_id,
        // Tambahkan ID unik untuk key di React
        id: `hero_${new Date().getTime()}`
      };

      // Update array di Firestore menggunakan arrayUnion
      await updateDoc(doc(db, 'pageContent', 'homePage'), {
        heroImages: arrayUnion(newImage)
      });

      toast.success('Gambar berhasil ditambahkan ke slider!');
      fetchHomePageContent(); // Ambil ulang data untuk update UI

    } catch (err) {
      // Error handling is done in uploadCroppedImage
    }
  };

  const handleFullHeroImageUpload = async (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      e.target.value = null; // Reset input

      try {
        const data = await uploadCroppedImage(file, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
        const newImage = {
          url: data.secure_url,
          public_id: data.public_id,
          id: `hero_${new Date().getTime()}`
        };

        await updateDoc(doc(db, 'pageContent', 'homePage'), {
          heroImages: arrayUnion(newImage)
        });

        toast.success('Gambar berhasil ditambahkan ke slider!');
        fetchHomePageContent();
      } catch (err) { /* Error is handled by uploadCroppedImage */ }
    }
  };

  const handleSaveHeroSlideDuration = async () => {
    const durationNum = parseFloat(heroSlideDuration);
    if (isNaN(durationNum) || durationNum < 2) {
      toast.warn('Durasi minimal adalah 2 detik.');
      return;
    }

    try {
      setIsSavingHeroDuration(true);
      await setDoc(doc(db, 'pageContent', 'homePage'), {
        heroSlideDuration: durationNum
      }, { merge: true });
      toast.success(`Durasi slide otomatis berhasil disimpan (${durationNum} detik).`);
    } catch (error) {
      console.error('Gagal menyimpan durasi slider:', error);
      toast.error('Gagal menyimpan durasi slider.');
    } finally {
      setIsSavingHeroDuration(false);
    }
  };

  const handleAddHeroMediaUrl = async (e) => {
    e.preventDefault();
    if (!heroMediaUrlInput.trim()) {
      toast.warn('Masukkan link / URL media terlebih dahulu.');
      return;
    }

    const trimmedUrl = heroMediaUrlInput.trim();
    let mediaType = heroMediaTypeInput;
    if (mediaType === 'auto') {
      if (/\.(mp4|webm|ogg|mov)(\?.*)?$/i.test(trimmedUrl)) {
        mediaType = 'video';
      } else if (trimmedUrl.includes('drive.google.com') || trimmedUrl.includes('docs.google.com')) {
        mediaType = 'drive_video';
      } else if (trimmedUrl.includes('youtube.com') || trimmedUrl.includes('youtu.be')) {
        mediaType = 'youtube';
      } else {
        mediaType = 'image';
      }
    }

    try {
      setIsAddingHeroLink(true);
      const parsedDuration = heroMediaDurationInput ? parseFloat(heroMediaDurationInput) : null;
      const newMedia = {
        id: `hero_${new Date().getTime()}`,
        url: trimmedUrl,
        mediaType: mediaType,
        duration: parsedDuration && parsedDuration >= 2 ? parsedDuration : null,
        isExternalUrl: true
      };

      await updateDoc(doc(db, 'pageContent', 'homePage'), {
        heroImages: arrayUnion(newMedia)
      });

      toast.success('Slide via URL/Link berhasil ditambahkan!');
      setHeroMediaUrlInput('');
      setHeroMediaTypeInput('auto');
      setHeroMediaDurationInput('');
      setShowAddHeroLinkModal(false);
      fetchHomePageContent();
    } catch (error) {
      console.error('Gagal menambahkan slide link:', error);
      toast.error('Gagal menambahkan slide.');
    } finally {
      setIsAddingHeroLink(false);
    }
  };

  const handleUpdateSlideDuration = async (index, durationValue) => {
    const parsedDuration = durationValue ? parseFloat(durationValue) : null;
    const updatedImages = heroImages.map((img, i) => {
      if (i === index) {
        return {
          ...img,
          duration: parsedDuration && parsedDuration >= 2 ? parsedDuration : null
        };
      }
      return img;
    });

    setHeroImages(updatedImages);

    try {
      await setDoc(doc(db, 'pageContent', 'homePage'), {
        heroImages: updatedImages
      }, { merge: true });
      toast.success(`Durasi Slide #${index + 1} berhasil diperbarui.`);
    } catch (error) {
      console.error('Gagal memperbarui durasi slide:', error);
      toast.error('Gagal memperbarui durasi slide.');
      fetchHomePageContent();
    }
  };

  // --- FUNGSI BARU: Upload Gambar Tentang Kami (Full) ---
  const handleFullTentangKamiImageUpload = async (e, fieldId) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      e.target.value = null; // Reset input

      try {
        setUploading(true);
        const data = await uploadCroppedImage(file, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);

        await setDoc(doc(db, 'pageContent', 'tentangKami'), {
          [fieldId]: data.secure_url,
          [`${fieldId}_public_id`]: data.public_id
        }, { merge: true });

        setSuccessMessage('Gambar berhasil diperbarui!');
        fetchTentangKamiContent();
      } catch (err) {
        console.error("Upload failed", err);
        setError('Upload gagal. Coba lagi.');
      } finally {
        setUploading(false);
      }
    }
  };

  const handleToggleWelcomeModal = async () => {
    const currentStatus = siteSettings.welcomeModal?.isEnabled || false;
    const newStatus = !currentStatus;
    try {
      await updateDoc(doc(db, "settings", "siteConfig"), {
        "welcomeModal.isEnabled": newStatus,
      });
      setSiteSettings(prev => ({
        ...prev,
        welcomeModal: { ...(prev.welcomeModal || {}), isEnabled: newStatus },
      }));
      toast.success(`Modal Selamat Datang telah ${newStatus ? 'diaktifkan' : 'dinonaktifkan'}.`);
    } catch (err) {
      toast.error("Gagal mengubah status modal.");
      console.error(err);
    }
  };

  const handleWelcomePosterUpdate = (index, field, value) => {
    setSiteSettings(prev => {
      const welcomeModal = prev.welcomeModal || { isEnabled: false, posters: [] };
      const newPosters = [...(welcomeModal.posters || [])];

      if (newPosters[index]) {
        // Jika poster adalah string (URL legacy), ubah jadi object
        if (typeof newPosters[index] === 'string') {
          newPosters[index] = { url: newPosters[index], id: `welcome_${Date.now()}_${index}` };
        }
        newPosters[index] = { ...newPosters[index], [field]: value };
      }

      return {
        ...prev,
        welcomeModal: { ...welcomeModal, posters: newPosters }
      };
    });
  };

  const handleReorderWelcomePoster = async (index, direction) => {
    const posters = [...(siteSettings.welcomeModal?.posters || [])];
    const newIndex = direction === 'up' ? index - 1 : index + 1;
    if (newIndex < 0 || newIndex >= posters.length) return;
    // Swap
    [posters[index], posters[newIndex]] = [posters[newIndex], posters[index]];
    setSiteSettings(prev => ({ ...prev, welcomeModal: { ...prev.welcomeModal, posters } }));
    try {
      await updateDoc(doc(db, 'settings', 'siteConfig'), { 'welcomeModal.posters': posters });
      toast.success('Urutan poster berhasil diubah.');
    } catch (err) {
      toast.error('Gagal mengubah urutan poster.');
    }
  };

  const handleReplaceWelcomePoster = async (index, file) => {
    if (!file) return;
    try {
      const data = await uploadCroppedImage(file, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
      const posters = [...(siteSettings.welcomeModal?.posters || [])];
      const oldPoster = typeof posters[index] === 'string'
        ? { url: posters[index], id: `welcome_${Date.now()}` }
        : posters[index];
      posters[index] = { ...oldPoster, url: data.secure_url, public_id: data.public_id };
      setSiteSettings(prev => ({ ...prev, welcomeModal: { ...prev.welcomeModal, posters } }));
      await updateDoc(doc(db, 'settings', 'siteConfig'), { 'welcomeModal.posters': posters });
      toast.success('Foto poster berhasil diganti!');
    } catch (err) {
      toast.error('Gagal mengganti foto poster.');
    }
  };

  const handleAddWelcomePoster = async (fileToUpload) => {
    try {
      const data = await uploadCroppedImage(fileToUpload, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
      const newPoster = {
        url: data.secure_url,
        public_id: data.public_id,
        id: `welcome_${new Date().getTime()}`,
      };
      await updateDoc(doc(db, "settings", "siteConfig"), { "welcomeModal.posters": arrayUnion(newPoster) });
      toast.success("Poster berhasil ditambahkan ke modal.");
      fetchSiteSettings();
    } catch (err) { /* Error handled by uploadCroppedImage */ }
  };

  // --- FUNGSI UNTUK SLIDER POSTER SPMB ---
  const handleAddSpmbPoster = async (fileToUpload) => {
    try {
      const data = await uploadCroppedImage(fileToUpload, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
      const newPoster = {
        url: data.secure_url,
        public_id: data.public_id,
        id: `spmb_${new Date().getTime()}`
      };
      await updateDoc(doc(db, 'pageContent', 'spmbPage'), { spmbPosters: arrayUnion(newPoster) });
      toast.success('Poster berhasil ditambahkan!');
      fetchSpmbPageContent();
    } catch (err) {
      // Error handling is in uploadCroppedImage
    }
  };



  const onCropComplete = (croppedImageBlob) => {
    const fileName = `cropped-${Date.now()}.png`;
    const croppedFile = new File([croppedImageBlob], fileName, { type: 'image/png' });
    const previewUrl = URL.createObjectURL(croppedImageBlob);

    // Immediately trigger the upload/update logic based on the target
    switch (cropTarget) {
      case 'berita':
        setBeritaFile(croppedFile);
        setBeritaPreview(previewUrl);
        // For news, we also wait for form submit.
        break;
      case 'staff':
        setStaffFile(croppedFile);
        setStaffPreview(previewUrl);
        break;
      case 'publicFacility':
        setPublicFacilityFile(croppedFile);
        setPublicFacilityPreview(previewUrl);
        break;
      case 'academicFacility':
        setAcademicFacilityFile(croppedFile);
        setAcademicFacilityPreview(previewUrl);
        break;
      case 'major':
        setMajorFile(croppedFile);
        setMajorPreview(previewUrl);
        break;
      case 'ekstrakurikuler':
        setEkstrakurikulerFile(croppedFile);
        setEkstrakurikulerPreview(previewUrl);
        break;

      case 'mitra':
        setMitraFile(croppedFile);
        setMitraPreview(previewUrl);
        break;
      case 'hero':
        handleAddHeroImage(croppedFile);
        break;
      case 'spmbPosterCrop':
        handleAddSpmbPoster(croppedFile);
        break;
      case 'welcomePoster':
        handleAddWelcomePoster(croppedFile);
        break;
      case 'kepsek':
        setFile(croppedFile);
        break;
      case 'orgChart':
        setFile(croppedFile);
        break;
      case 'spmbPoster':
        setFile(croppedFile);
        break;
      case 'ctaBg':
        setFile(croppedFile);
        break;
      case 'kurikulum':
        setKurikulumFile(croppedFile);

        break;
      case 'kesiswaan':
        setKesiswaanFile(croppedFile);
        setKesiswaanPreview(previewUrl);
        break;
      case 'prestasi':
        setPrestasiFile(croppedFile);
        setPrestasiPreview(previewUrl);
        break;
      case 'alumni-lulus':
        setAlumniLulusFile(croppedFile);
        setAlumniLulusPreview(previewUrl);
        break;
      case 'testimoni':
        setTestimoniFile(croppedFile);
        setTestimoniPreview(previewUrl);
        break;
      // Cases for direct upload
      // ... you can add more direct uploads here if needed
      default:
        break;
    }
    setImageToCrop(null);
    setCropTarget(null);
    setCropAspect(undefined); // Reset aspect
    // Tampilkan kembali form staf jika proses crop selesai dari sana
    if (cropTarget === 'staff') {
      setShowStaffForm(true);
    }
    if (cropTarget === 'mitra') {
      setShowMitraForm(true);
    }
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Kembali ke atas untuk melihat form
  };

  const handleDeleteHeroImage = async (imageToRemove) => {
    showConfirmationModal('Hapus Gambar Slider?', 'Apakah Anda yakin ingin menghapus gambar ini dari slider?', async () => {
      try {
        await updateDoc(doc(db, 'pageContent', 'homePage'), {
          heroImages: arrayRemove(imageToRemove)
        });
        toast.success('Gambar berhasil dihapus dari slider.');
        fetchHomePageContent(); // Refresh UI
      } catch (error) {
        toast.error('Gagal menghapus gambar.');
        console.error("Gagal menghapus gambar hero: ", error);
      }
    });
  };

  const handleDeleteWelcomePoster = async (posterToRemove) => {
    showConfirmationModal(
      "Hapus Poster Modal?",
      "Anda yakin ingin menghapus poster ini dari modal selamat datang?",
      async () => {
        try {
          await updateDoc(doc(db, "settings", "siteConfig"), { "welcomeModal.posters": arrayRemove(posterToRemove) });
          toast.success("Poster berhasil dihapus.");
          fetchSiteSettings();
        } catch (error) {
          toast.error("Gagal menghapus poster.");
          console.error("Gagal menghapus poster modal: ", error);
        }
      }
    );
  };
  const handleDeleteSpmbPoster = async (posterToRemove) => {
    showConfirmationModal('Hapus Poster SPMB?', 'Anda yakin ingin menghapus poster ini dari slider?', async () => {
      try {
        await updateDoc(doc(db, 'pageContent', 'spmbPage'), {
          spmbPosters: arrayRemove(posterToRemove)
        });
        toast.success('Poster berhasil dihapus.');
        fetchSpmbPageContent(); // Refresh UI
      } catch (error) {
        toast.error('Gagal menghapus poster.');
        console.error("Gagal menghapus poster SPMB: ", error);
      }
    });
  };



  // --- FUNGSI UNTUK PESAN ---
  const handleMarkAsRead = async (id) => {
    const pesanRef = doc(db, 'pesanKontak', id);
    try {
      await updateDoc(pesanRef, {
        read: true
      });
      // Update state secara lokal agar perubahan langsung terlihat
      setPesanKontak(prevPesan =>
        prevPesan.map(p => p.id === id ? { ...p, read: true } : p)
      );
    } catch (err) {
      console.error("Gagal menandai pesan sebagai sudah dibaca:", err);
      toast.error("Gagal mengubah status pesan.");
    }
  };

  const togglePesanDetail = (pesan) => {
    const { id, read } = pesan;
    // Jika pesan belum dibaca, tandai sebagai sudah dibaca
    if (!read) {
      handleMarkAsRead(id);
    }
    setExpandedPesanId(expandedPesanId === id ? null : id);
  };

  const handleDeletePesan = async (id) => {
    showConfirmationModal('Hapus Pesan?', 'Apakah Anda yakin ingin menghapus pesan ini secara permanen?', async () => {
      try {
        await deleteDoc(doc(db, 'pesanKontak', id));
        setSuccessMessage('Pesan berhasil dihapus.');
        fetchPesan(); // Refresh list
      } catch (err) {
        setError('Gagal menghapus pesan.');
        console.error(err);
      }
    });
  };

  // --- FUNGSI UNTUK KATEGORI GALERI ---
  // --- FUNGSI UNTUK KATEGORI GALERI ---
  const handleCategorySubmit = async (e) => {
    e.preventDefault();
    const trimmedName = categoryName.trim();
    if (!trimmedName) {
      toast.error("Nama kategori tidak boleh kosong.");
      return;
    }
    setUploading(true);
    try {
      // Upload Cover Image if exists
      let coverImageUrl = '';
      if (categoryFile) {
        const uploadData = await uploadCroppedImage(categoryFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
        coverImageUrl = uploadData.secure_url;
      }

      // Filter valid external links
      const validExternalLinks = categoryExternalLinks
        .map(item => ({ label: (item.label || 'Link').trim(), url: (item.url || '').trim() }))
        .filter(item => item.url !== '');

      const primaryLink = validExternalLinks[0]?.url || categoryExternalLink || '';

      if (isEditingCategory) {
        // Cek apakah nama berubah
        const oldCategory = galleryCategories.find(cat => cat.id === categoryId);
        const nameChanged = oldCategory && oldCategory.name !== trimmedName;
        const oldName = oldCategory?.name;

        // Prepare update data
        const updateData = {
          name: trimmedName,
          description: categoryDescription,
          slug: createSlug(trimmedName),
          category: selectedAlbumCategory || 'Umum',
          date: categoryDate ? new Date(categoryDate).toISOString() : null,
          endDate: categoryEndDate ? new Date(categoryEndDate).toISOString() : null,
          externalLink: primaryLink,
          externalLinks: validExternalLinks
        };

        if (coverImageUrl) {
          updateData.imageUrl = coverImageUrl;
        }

        // Update dokumen kategori
        if (nameChanged && oldName) {
          await updateDoc(doc(db, 'galeri_kategori', categoryId), updateData);

          toast.info(`Menyelaraskan ${trimmedName}...`);
          const q = query(collection(db, 'galeri'), where('category', '==', oldName));
          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            const batch = writeBatch(db);
            querySnapshot.docs.forEach((photoDoc) => {
              batch.update(photoDoc.ref, { category: trimmedName });
            });
            await batch.commit();
            toast.success(`Berhasil menyelaraskan ${querySnapshot.size} foto.`);
          }

          // Sinkronkan active category jika sedang dibuka
          if (activeGalleryCategory === oldName) {
            setActiveGalleryCategory(trimmedName);
          }
        } else {
          // If name didn't change, just update the category doc
          await updateDoc(doc(db, 'galeri_kategori', categoryId), updateData);
        }

        toast.success("Album berhasil diperbarui!");
      } else {
        // Create new Category (Album)
        await addDoc(collection(db, 'galeri_kategori'), {
          name: trimmedName,
          slug: createSlug(trimmedName),
          description: categoryDescription,
          imageUrl: coverImageUrl,
          date: categoryDate ? new Date(categoryDate).toISOString() : null,
          endDate: categoryEndDate ? new Date(categoryEndDate).toISOString() : null,
          externalLink: primaryLink,
          externalLinks: validExternalLinks,
          category: selectedAlbumCategory || 'Umum', // Assign to an Album Category
          createdAt: new Date().toISOString(),
          isVisible: true
        });
        toast.success("Album baru berhasil dibuat!");
      }

      setShowCategoryForm(false);
      resetCategoryForm();
      fetchGalleryCategories(); // Refresh list
    } catch (err) {
      console.error("Error saving category:", err);
      toast.error("Gagal menyimpan album.");
    } finally {
      setUploading(false);
    }
  };



  /**
   * SECTION MANAGEMENT HANDLERS
   */

  const handleEditCategory = (cat) => {
    setIsEditingCategory(true);
    setCategoryId(cat.id);
    setCategoryName(cat.name);
    setCategoryDescription(cat.description || ''); // Isi deskripsi saat edit
    setCategoryDate(cat.date ? new Date(cat.date).toISOString().split('T')[0] : '');
    setCategoryEndDate(cat.endDate ? new Date(cat.endDate).toISOString().split('T')[0] : '');
    setCategoryExternalLink(cat.externalLink || '');
    if (Array.isArray(cat.externalLinks) && cat.externalLinks.length > 0) {
      setCategoryExternalLinks(cat.externalLinks);
    } else if (cat.externalLink) {
      setCategoryExternalLinks([{ label: 'Google Photos', url: cat.externalLink }]);
    } else {
      setCategoryExternalLinks([{ label: 'Day 1', url: '' }]);
    }
    setCategoryPreview(cat.imageUrl || '');
    setCategoryFile(null); // Reset file input
    setActiveGalleryCategory(cat.name);
    setShowCategoryForm(true);
    setSelectedAlbumCategory(cat.category || ''); // Set selected category
  };

  const resetCategoryForm = () => {
    setIsEditingCategory(false);
    setCategoryId(null);
    setCategoryName('');
    setCategoryDescription('');
    setCategoryDate('');
    setCategoryEndDate('');
    setCategoryExternalLink('');
    setCategoryExternalLinks([{ label: 'Day 1', url: '' }]);
    setCategoryFile(null);
    setCategoryPreview('');
    setSelectedAlbumCategory('');
    setActiveGalleryCategory(null);
  };

  // --- ALBUM CATEGORY MANAGEMENT ---
  const handleAlbumCategorySubmit = async (e) => {
    e.preventDefault();
    const trimmedName = currentAlbumCategory.name.trim();
    if (!trimmedName) {
      toast.error("Nama kategori tidak boleh kosong.");
      return;
    }
    setUploading(true);
    try {
      if (isEditingAlbumCategory) {
        const oldCategory = albumCategories.find(cat => cat.id === currentAlbumCategory.id);
        const oldName = oldCategory?.name;
        const nameChanged = oldName && oldName !== trimmedName;

        await updateDoc(doc(db, 'album_categories', currentAlbumCategory.id), {
          name: trimmedName
        });

        if (nameChanged && oldName) {
          toast.info(`Menyelaraskan album kategori ${trimmedName}...`);
          const q = query(collection(db, 'galeri_kategori'), where('category', '==', oldName));
          const querySnapshot = await getDocs(q);

          if (!querySnapshot.empty) {
            const batch = writeBatch(db);
            querySnapshot.docs.forEach((albumDoc) => {
              batch.update(albumDoc.ref, { category: trimmedName });
            });
            await batch.commit();
            toast.success(`Berhasil menyelaraskan ${querySnapshot.size} album.`);
          }
        }
        toast.success("Kategori berhasil diperbarui!");
      } else {
        await addDoc(collection(db, 'album_categories'), {
          name: trimmedName,
          createdAt: new Date().toISOString()
        });
        toast.success("Kategori baru berhasil ditambahkan!");
      }
      setShowAlbumCategoryModal(false);
      setCurrentAlbumCategory({ id: '', name: '' });
      fetchAlbumCategories();
    } catch (error) {
      console.error("Error saving album category:", error);
      toast.error("Gagal menyimpan kategori.");
    } finally {
      setUploading(false);
    }
  };

  const handleDeleteAlbumCategory = async (id) => {
    showConfirmationModal('Hapus Kategori?', 'Apakah Anda yakin? Album yang menggunakan kategori ini tidak akan terhapus, namun kategorinya mungkin menjadi tidak valid.', async () => {
      try {
        await deleteDoc(doc(db, 'album_categories', id));
        toast.success("Kategori berhasil dihapus.");
        fetchAlbumCategories();
      } catch (error) {
        toast.error("Gagal menghapus kategori.");
      }
    });
  };
  const handleToggleCategoryVisibility = async (category) => {
    const categoryRef = doc(db, 'galeri_kategori', category.id);
    const newVisibility = category.isVisible === false ? true : false; // Toggle the value
    try {
      await updateDoc(categoryRef, { isVisible: newVisibility });
      toast.success(`Kategori "${category.name}" sekarang ${newVisibility ? 'terlihat' : 'disembunyikan'}.`);
      fetchGalleryCategories(); // Re-fetch to update UI
    } catch (err) {
      toast.error("Gagal mengubah visibilitas kategori.");
      console.error(err);
    }
  };


  // Drag and Drop Handlers
  const handleGalleryDragStart = (e, index) => {
    setDraggedGalleryItem(galleryCategories[index]);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleGalleryDragOver = (e, index) => {
    e.preventDefault();
    const draggedOverItem = galleryCategories[index];

    if (draggedGalleryItem === draggedOverItem) {
      return;
    }

    let items = galleryCategories.filter(item => item !== draggedGalleryItem);
    items.splice(index, 0, draggedGalleryItem);

    setGalleryCategories(items);
    setIsGalleryOrderChanged(true);
  };

  const handleGalleryDragEnd = () => {
    setDraggedGalleryItem(null);
  };

  const handleSaveGalleryOrder = async () => {
    setUploading(true);
    try {
      const batch = writeBatch(db);
      galleryCategories.forEach((cat, index) => {
        const docRef = doc(db, 'galeri_kategori', cat.id);
        batch.update(docRef, { order: index });
      });
      await batch.commit();
      toast.success('Urutan album berhasil disimpan!');
      setIsGalleryOrderChanged(false);
    } catch (error) {
      console.error("Error saving order: ", error);
      toast.error("Gagal menyimpan urutan.");
    } finally {
      setUploading(false);
    }
  };




  const handleDeleteCategory = async (id) => {
    const categoryToDelete = galleryCategories.find(cat => cat.id === id);
    if (!categoryToDelete) {
      toast.error("Album tidak ditemukan.");
      return;
    }

    showConfirmationModal(
      'Hapus Album dan Semua Isinya?',
      `Anda yakin ingin menghapus album "${categoryToDelete.name}"? Semua foto di dalam album ini akan terhapus secara permanen. Aksi ini tidak bisa dibatalkan.`,
      async () => {
        try {
          setUploading(true); // Menampilkan indikator loading

          // 1. Cari semua gambar di dalam album ini
          const imagesQuery = query(collection(db, 'galeri'), where("category", "==", categoryToDelete.name));
          const imagesSnapshot = await getDocs(imagesQuery);

          // 2. Hapus setiap gambar dari Firestore dan Cloudinary
          const deletePromises = imagesSnapshot.docs.map(async (imageDoc) => {
            const imageData = imageDoc.data();
            const publicId = imageData.public_id;

            // Hapus dari Firestore
            await deleteDoc(doc(db, 'galeri', imageDoc.id));

            // Jika ada public_id, hapus juga dari Cloudinary
            if (publicId) {
              const formData = new FormData();
              formData.append('upload_preset', process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
              formData.append('public_id', publicId);
              // Panggilan API ini memerlukan konfigurasi khusus di Cloudinary untuk mengizinkan penghapusan dari sisi klien.
              // Ini kurang aman. Solusi terbaik adalah menggunakan backend/cloud function.
              // Untuk saat ini, kita asumsikan ini diizinkan untuk kemudahan.
              // Jika gagal, setidaknya data di Firestore sudah terhapus.
              try {
                await fetch(`https://api.cloudinary.com/v1_1/${process.env.REACT_APP_CLOUDINARY_CLOUD_NAME}/image/destroy`, { method: 'POST', body: formData });
              } catch (cloudinaryError) {
                console.warn(`Gagal menghapus gambar dari Cloudinary (public_id: ${publicId}). Mungkin perlu dihapus manual.`, cloudinaryError);
              }
            }
          });
          await Promise.all(deletePromises);

          // 3. Setelah semua gambar terhapus, hapus dokumen album itu sendiri
          await deleteDoc(doc(db, 'galeri_kategori', id));

          toast.success(`Album "${categoryToDelete.name}" dan semua isinya berhasil dihapus.`);
          fetchGalleryCategories(); // Muat ulang daftar album

        } finally {
          setUploading(false); // Sembunyikan indikator loading
        }
      });
  };



  const handleLogout = async () => {
    showConfirmationModal('Konfirmasi Logout', 'Apakah Anda yakin ingin keluar dari Admin Panel?', async () => {
      try {
        await signOut(auth);
        // Titipkan pesan di sessionStorage agar tidak hilang saat redirect
        sessionStorage.setItem('logoutMessage', 'Logout berhasil!');
        navigate('/admin');
      } catch (error) {
        console.error("Logout gagal:", error);
        toast.error("Logout gagal. Coba lagi.");
      }
    });
  };

  // --- FUNGSI UNTUK MENGAMBIL THUMBNAIL DARI URL ---
  const fetchThumbnailFromUrl = async (url) => {
    if (!url) {
      toast.warn("Silakan masukkan URL terlebih dahulu.");
      return;
    }
    toast.info("Mencoba mengambil gambar unggulan...");
    setUploading(true);

    let thumbnailUrl = '';

    try {
      // YouTube
      if (url.includes('youtube.com') || url.includes('youtu.be')) {
        const videoIdMatch = url.match(/(?:v=|\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
        if (videoIdMatch && videoIdMatch[1]) {
          thumbnailUrl = `https://img.youtube.com/vi/${videoIdMatch[1]}/maxresdefault.jpg`;
        }
      }
      // Instagram & TikTok (menggunakan oEmbed)
      else if (url.includes('instagram.com') || url.includes('tiktok.com')) {
        const platform = url.includes('instagram.com') ? 'instagram' : 'tiktok';
        const oembedUrl = platform === 'instagram'
          ? `https://graph.facebook.com/v19.0/instagram_oembed?url=${encodeURIComponent(url)}&access_token=${process.env.REACT_APP_FACEBOOK_OEMBED_TOKEN}`
          : `https://www.tiktok.com/oembed?url=${encodeURIComponent(url)}`;

        const response = await fetch(oembedUrl);
        if (!response.ok) throw new Error(`Gagal mengambil data oEmbed dari ${platform}`);
        const data = await response.json();
        thumbnailUrl = data.thumbnail_url;
      }

      if (!thumbnailUrl) {
        throw new Error("Tidak dapat menemukan gambar unggulan dari URL yang diberikan.");
      }

      // Ambil gambar dari URL thumbnail dan jadikan File object menggunakan proxy Cloudflare Worker
      const proxyUrl = `${process.env.REACT_APP_CORS_PROXY_URL}?url=${encodeURIComponent(thumbnailUrl)}`;
      const imageResponse = await fetch(proxyUrl);
      if (!imageResponse.ok) throw new Error("Gagal mengunduh gambar unggulan.");

      const blob = await imageResponse.blob();
      const fileName = `thumbnail-${Date.now()}.jpg`;
      const imageFile = new File([blob], fileName, { type: blob.type });

      // Set state untuk preview dan file
      setBeritaFile(imageFile);
      setBeritaPreview(URL.createObjectURL(imageFile));
      setCurrentBerita(prev => ({ ...prev, image: URL.createObjectURL(imageFile) })); // Tambahkan baris ini
      toast.success("Gambar unggulan berhasil diambil!");

    } catch (err) {
      console.error("Error fetching thumbnail:", err);
      let errorMessage = err.message || "Terjadi kesalahan saat mengambil gambar.";
      if (err.message.includes('instagram')) {
        errorMessage = "Gagal mengambil gambar dari Instagram. Pastikan URL valid dan publik.";
      }
      toast.error(errorMessage);
    } finally {
      setUploading(false);
    }
  };

  // --- FUNGSI UNTUK BERITA (CRUD) ---
  const handleBeritaSubmit = async (e) => {
    e.preventDefault();
    if (!currentBerita.title || !currentBerita.content || !currentBerita.excerpt) {
      setError("Judul, Kutipan, dan Konten berita tidak boleh kosong.");
      return;
    }
    setUploading(true);
    setError('');
    setSuccessMessage('');

    let imageUrl = currentBerita.image || ''; // Pertahankan gambar lama jika tidak ada file baru
    let publicId = currentBerita.public_id || '';

    try {
      // Jika ada file baru di-upload
      if (beritaFile) {
        try {
          const data = await uploadCroppedImage(beritaFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
          imageUrl = data.secure_url;
          publicId = data.public_id;
        } catch (error) {
          console.error("Upload failed in handleBeritaSubmit:", error);
          toast.error("Gagal mengupload gambar berita. Silakan coba lagi.");
          setUploading(false);
          return;
        }
      }

      const beritaData = {
        title: currentBerita.title,
        excerpt: currentBerita.excerpt,
        content: currentBerita.content,
        image: imageUrl,
        public_id: publicId,
        instagramLink: currentBerita.instagramLink || '',
        videoUrl: currentBerita.videoUrl || '',
        tiktokLink: currentBerita.tiktokLink || '',
        linkedGallery: currentBerita.linkedGallery || '',
        titleAlignment: currentBerita.titleAlignment || 'left',
        titleColor: currentBerita.titleColor || '#2563eb',
        contentAlignment: currentBerita.contentAlignment || 'left', // Memastikan field ini disimpan
        slug: createSlug(currentBerita.title),
        category: currentBerita.category || '', // Simpan kategori
        lastUpdated: new Date().toISOString(),
        status: currentBerita.status || 'draft',
        author: 'Admin Sekolah',
        // Tambahkan logika tanggal langsung di sini
        date: currentBerita.date
          ? new Date(currentBerita.date).toISOString()
          : (isEditingBerita ? currentBerita.originalDate : new Date().toISOString())
      };

      if (isEditingBerita) {
        // Update dokumen yang ada
        const docRef = doc(db, 'berita', beritaId);
        await updateDoc(docRef, {
          ...beritaData
        });
        toast.success('Berita berhasil diperbarui.');
      } else {
        // Tambah dokumen baru
        await addDoc(collection(db, 'berita'), beritaData);
        toast.success('Berita berhasil ditambahkan.');
      }

      resetBeritaForm();
      fetchBerita();

    } catch (err) {
      toast.error('Gagal menyimpan berita. Coba lagi.'); console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const handleEditBerita = (berita) => {
    setIsEditingBerita(true);
    setShowBeritaForm(true);
    setBeritaId(berita.id);

    // Format tanggal untuk input type="date" (YYYY-MM-DD)
    const originalDate = berita.date ? new Date(berita.date).toISOString().split('T')[0] : '';

    setCurrentBerita({
      ...berita,
      date: originalDate, // Untuk ditampilkan di form
      originalDate: berita.date, // Simpan ISO string asli untuk update
      status: berita.status || 'draft', // Default ke draft jika tidak ada
      titleAlignment: berita.titleAlignment || 'left', // Default ke rata kiri
      titleColor: berita.titleColor || '#2563eb',
      contentAlignment: berita.contentAlignment || 'left'
    });
    setBeritaPreview(berita.image); // FIX: Tampilkan preview gambar yang sedang diedit
  };

  const handleDeleteBerita = async (id, public_id) => {
    showConfirmationModal('Hapus Berita?', 'Anda yakin ingin menghapus berita ini? Aksi ini tidak bisa dibatalkan.', async () => {
      try {
        await deleteDoc(doc(db, 'berita', id));
        toast.success('Berita berhasil dihapus.');
        fetchBerita();
      } catch (err) {
        toast.error('Gagal menghapus berita.');
        console.error(err);
      }
    });
  };

  const resetBeritaForm = () => {
    setIsEditingBerita(false);
    setBeritaId(null);
    setCurrentBerita({ title: '', content: '', excerpt: '', image: '', imagePath: '', instagramLink: '', videoUrl: '', tiktokLink: '', status: 'draft', linkedGallery: '', titleAlignment: 'left', titleColor: '#2563eb', contentAlignment: 'left', category: '' });
    setBeritaFile(null);
    setBeritaPreview('');
    const form = document.getElementById('berita-form');
    setShowBeritaForm(false);
    if (form) form.reset();
  };

  // --- SITEMAP GENERATOR ---
  const handleGenerateSitemap = async () => {
    setUploading(true);
    try {
      toast.info("Sedang membuat sitemap...");

      // 1. Fetch Static & Dynamic Page Data
      // Berita
      const beritaQuery = query(collection(db, 'berita'), where("status", "==", "published"));
      const beritaSnapshot = await getDocs(beritaQuery);
      const beritaList = beritaSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      // Galeri
      const galleryQuery = query(collection(db, 'galeri'));
      const gallerySnapshot = await getDocs(galleryQuery);
      const galleryList = gallerySnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      // Kategori Galeri (untuk halaman album)
      const galleryCatQuery = query(collection(db, 'galeri_kategori'), where("isVisible", "==", true));
      const galleryCatSnapshot = await getDocs(galleryCatQuery);
      const galleryCats = galleryCatSnapshot.docs.map(doc => doc.data());

      // Prestasi
      const prestasiQuery = query(collection(db, 'prestasi'));
      const prestasiSnapshot = await getDocs(prestasiQuery);
      const prestasiList = prestasiSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      // Jurusan
      const majorsQuery = query(collection(db, 'majors'));
      const majorsSnapshot = await getDocs(majorsQuery);
      const majorsList = majorsSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));

      // 2. Fetch Page Content for Hero Images
      const homePageDoc = await getDoc(doc(db, 'pageContent', 'homePage'));
      const homeData = homePageDoc.exists() ? homePageDoc.data() : {};
      const homeImages = homeData.heroImages || [];

      const kesiswaanDoc = await getDoc(doc(db, 'unitKerja', 'kesiswaan'));
      const kesiswaanData = kesiswaanDoc.exists() ? kesiswaanDoc.data() : {};

      const kurikulumDoc = await getDoc(doc(db, 'unitKerja', 'kurikulum'));
      const kurikulumData = kurikulumDoc.exists() ? kurikulumDoc.data() : {};

      const baseUrl = "https://smkpariwisatasumbangsih.sch.id";

      let sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9"
        xmlns:image="http://www.google.com/schemas/sitemap-image/1.1">
`;

      // Helper to add URL entry
      const addUrl = (loc, images = [], changefreq = 'monthly', priority = '0.8') => {
        sitemap += `  <url>
    <loc>${baseUrl}${loc}</loc>
    <changefreq>${changefreq}</changefreq>
    <priority>${priority}</priority>
`;
        images.forEach(img => {
          if (img && img.url) {
            sitemap += `    <image:image>
      <image:loc>${img.url}</image:loc>
      ${img.title ? `<image:title>${img.title.replace(/&/g, '&amp;')}</image:title>` : ''}
    </image:image>
`;
          } else if (typeof img === 'string') {
            sitemap += `    <image:image>
      <image:loc>${img}</image:loc>
    </image:image>
`;
          }
        });
        sitemap += `  </url>
`;
      };

      // --- Static Pages ---
      // Home
      addUrl('/', homeImages.map(img => ({ url: img.url, title: 'SMK Pariwisata Sumbangsih' })), 'daily', '1.0');

      // Tentang Kami
      const tentangKamiDoc = await getDoc(doc(db, 'pageContent', 'tentangKami'));
      const tentangKamiData = tentangKamiDoc.exists() ? tentangKamiDoc.data() : {};
      const tentangKamiImages = [];
      if (tentangKamiData.heroImage) tentangKamiImages.push(tentangKamiData.heroImage);
      if (tentangKamiData.kepsekImage) tentangKamiImages.push(tentangKamiData.kepsekImage);
      addUrl('/tentang-kami', tentangKamiImages, 'monthly', '0.8');

      // Unit Kerja
      addUrl('/kurikulum', [kurikulumData.wakaImageUrl, kurikulumData.imageUrl].filter(Boolean), 'monthly', '0.8');
      addUrl('/kesiswaan', [kesiswaanData.wakaImageUrl, kesiswaanData.imageUrl].filter(Boolean), 'monthly', '0.8');

      // --- Dynamic Pages ---
      // Jurusan
      addUrl('/jurusan', [], 'monthly', '0.9');
      majorsList.forEach(major => {
        addUrl(`/jurusan/${major.id}`, [major.image], 'monthly', '0.8');
      });

      // Berita
      addUrl('/berita', [], 'daily', '0.9');
      beritaList.forEach(item => {
        addUrl(`/berita/${item.slug}`, [item.image], 'weekly', '0.8');
      });

      // Galeri Album
      addUrl('/galeri', [], 'weekly', '0.9');
      galleryCats.forEach(cat => {
        // Find images for this category to include in the album page entry? 
        // Usually album page shows thumbnails. Let's add at least one "cover" image if possible.
        const coverImg = galleryList.find(g => g.category === cat.name);
        addUrl(`/galeri/${cat.slug}`, coverImg ? [coverImg.url] : [], 'weekly', '0.8');
      });

      // Prestasi
      addUrl('/prestasi', prestasiList.map(p => ({ url: p.image, title: p.title })), 'weekly', '0.8');

      // Lainnya
      addUrl('/ekstrakurikuler', [], 'monthly', '0.8');
      addUrl('/spmb', [], 'monthly', '0.9');
      addUrl('/kontak', [], 'yearly', '0.7');


      sitemap += `</urlset>`;

      // Download file
      const blob = new Blob([sitemap], { type: "application/xml" });
      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "sitemap.xml";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      toast.success("Sitemap berhasil dibuat dan diunduh! Silakan upload ke hosting/folder public.");

    } catch (err) {
      console.error("Gagal membuat sitemap:", err);
      toast.error("Gagal membuat sitemap.");
    } finally {
      setUploading(false);
    }
  };

  const handleSettingsSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);
    setError('');
    setSuccessMessage('');
    try {
      await setDoc(doc(db, "settings", "siteConfig"), siteSettings);
      toast.success("Pengaturan berhasil disimpan!");
    } catch (err) {
      toast.error("Gagal menyimpan pengaturan.");
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const handleAddNewBerita = () => {
    resetBeritaForm();
    setShowBeritaForm(true);
  };

  const handleToggleBeritaStatus = async (berita) => {
    const newStatus = berita.status === 'published' ? 'draft' : 'published';
    const confirmationMessage = `Yakin ingin mengubah status berita "${berita.title}" menjadi "${newStatus}"?`;

    showConfirmationModal('Ubah Status Berita?', confirmationMessage, async () => {
      const docRef = doc(db, 'berita', berita.id);
      try {
        await updateDoc(docRef, { status: newStatus });
        toast.success(`Status berita berhasil diubah menjadi ${newStatus}.`);
        fetchBerita(); // Refresh daftar berita
      } catch (err) {
        toast.error('Gagal mengubah status berita.');
      }
    });
  };



  const handleTentangKamiSubmit = async (e) => {
    e.preventDefault();
    setUploading(true);
    setError('');
    setSuccessMessage('');
    try {
      // Menggunakan setDoc dengan { merge: true } agar tidak menimpa field lain seperti URL gambar
      await setDoc(doc(db, "pageContent", "tentangKami"), tentangKamiContent, { merge: true });
      toast.success("Konten 'Tentang Kami' berhasil diperbarui.");
    } catch (err) {
      toast.error("Gagal menyimpan konten.");
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const resetStaffForm = () => {
    setIsEditingStaff(false);
    setStaffId(null);
    setCurrentStaff({ name: '', role: '', type: 'pendidik', image: '', public_id: '', order: 0 });
    setStaffFile(null);
    setStaffPreview('');
    setShowStaffForm(false);
    const form = document.getElementById('staff-form');
    if (form) form.reset();
  };

  const handleStaffSubmit = async (e) => {
    e.preventDefault();
    if (!currentStaff.name || !currentStaff.role) {
      setError("Nama dan Jabatan tidak boleh kosong.");
      return;
    }
    setUploading(true);
    setError('');
    setSuccessMessage('');

    let imageUrl = currentStaff.image || '';
    let publicId = currentStaff.public_id || '';

    try {
      if (staffFile) {
        try {
          const data = await uploadCroppedImage(staffFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
          imageUrl = data.secure_url;
          publicId = data.public_id;
        } catch (error) {
          console.error("Upload failed in handleStaffSubmit:", error);
          toast.error("Gagal mengupload foto staf. Silakan coba lagi.");
          setUploading(false);
          return;
        }
      }

      // Ensure imageUrl is never undefined (Double check)
      const finalImageUrl = imageUrl || '';
      const finalPublicId = publicId || '';

      const staffData = {
        name: currentStaff.name,
        role: currentStaff.role,
        type: currentStaff.type,
        image: finalImageUrl,
        public_id: finalPublicId,
        order: Number(currentStaff.order) || 0,
      };

      console.log("Submitting Staff Data:", staffData); // Debug log  };

      if (isEditingStaff) {
        await updateDoc(doc(db, 'staff', staffId), staffData);
        toast.success('Data staf berhasil diperbarui.');
      } else {
        await addDoc(collection(db, 'staff'), staffData);
        toast.success('Staf baru berhasil ditambahkan.');
      }

      resetStaffForm();
      fetchStaff();
    } catch (err) {
      toast.error('Gagal menyimpan data staf.');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const handleEditStaff = (staff) => {
    setIsEditingStaff(true);
    setShowStaffForm(true);
    setStaffId(staff.id);
    setCurrentStaff({ name: staff.name, role: staff.role, type: staff.type, image: staff.image, public_id: staff.public_id || '', order: staff.order || 0 });
    setStaffPreview(staff.image);
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll ke atas untuk melihat form
  };

  const handleDeleteStaff = async (id) => {
    showConfirmationModal('Hapus Staf?', 'Anda yakin ingin menghapus data staf ini?', async () => {
      await deleteDoc(doc(db, 'staff', id));
      toast.success('Data staf berhasil dihapus.');
      fetchStaff();
    });
  };

  const resetPublicFacilityForm = () => {
    setIsEditingPublicFacility(false);
    setPublicFacilityId(null);
    setCurrentPublicFacility({ title: '', description: '', image: '', public_id: '', order: 0 });
    setPublicFacilityFile(null);
    setPublicFacilityPreview('');
    setShowPublicFacilityForm(false);
    const form = document.getElementById('public-facility-form');
    if (form) form.reset();
  };

  const handlePublicFacilitySubmit = async (e) => {
    e.preventDefault();
    if (!currentPublicFacility.title || !currentPublicFacility.description) {
      setError("Judul dan Deskripsi tidak boleh kosong.");
      return;
    }
    setUploading(true);
    setError('');
    setSuccessMessage('');

    let imageUrl = currentPublicFacility.image || '';
    let publicId = currentPublicFacility.public_id || '';

    try {
      if (publicFacilityFile) {
        try {
          const data = await uploadCroppedImage(publicFacilityFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
          imageUrl = data.secure_url;
          publicId = data.public_id;
        } catch (error) {
          console.error("Upload failed in handlePublicFacilitySubmit:", error);
          toast.error("Gagal mengupload gambar fasilitas publik. Silakan coba lagi.");
          setUploading(false);
          return;
        }
      }

      const facilityData = {
        title: currentPublicFacility.title,
        description: currentPublicFacility.description,
        image: imageUrl,
        public_id: publicId,
        order: Number(currentPublicFacility.order) || 0,
      };

      if (isEditingPublicFacility) {
        await updateDoc(doc(db, 'publicFacilities', publicFacilityId), facilityData); // FIX: Menggunakan nama koleksi yang benar
        toast.success('Data ruang publik berhasil diperbarui.');
      } else {
        await addDoc(collection(db, 'publicFacilities'), facilityData); // FIX: Menggunakan nama koleksi yang benar
        toast.success('Ruang publik baru berhasil ditambahkan.');
      }

      resetPublicFacilityForm();
      fetchPublicFacilities();
    } catch (err) {
      toast.error('Gagal menyimpan data ruang publik.');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };




  const handleEditPublicFacility = (facility) => {
    setIsEditingPublicFacility(true);
    setShowPublicFacilityForm(true);
    setPublicFacilityId(facility.id);
    setCurrentPublicFacility({ title: facility.title, description: facility.description, image: facility.image, public_id: facility.public_id || '', order: facility.order || 0 });
    setPublicFacilityPreview(facility.image); // FIX: Tampilkan preview gambar yang sedang diedit
  };

  const handleDeletePublicFacility = async (id) => {
    showConfirmationModal('Hapus Ruang Publik?', 'Anda yakin ingin menghapus data ruang publik ini?', async () => {
      await deleteDoc(doc(db, 'publicFacilities', id)); // FIX: Menggunakan nama koleksi yang benar
      toast.success('Data ruang publik berhasil dihapus.');
      fetchPublicFacilities();
    });
  };

  const resetAcademicFacilityForm = () => {
    setIsEditingAcademicFacility(false);
    setAcademicFacilityId(null);
    setCurrentAcademicFacility({ title: '', description: '', image: '', public_id: '', order: 0 });
    setAcademicFacilityFile(null);
    setAcademicFacilityPreview('');
    setShowAcademicFacilityForm(false);
    const form = document.getElementById('academic-facility-form');
    if (form) form.reset();
  };

  const handleAcademicFacilitySubmit = async (e) => {
    e.preventDefault();
    if (!currentAcademicFacility.title || !currentAcademicFacility.description) {
      setError("Judul dan Deskripsi tidak boleh kosong.");
      return;
    }
    setUploading(true);
    setError('');
    setSuccessMessage('');

    let imageUrl = currentAcademicFacility.image || '';
    let publicId = currentAcademicFacility.public_id || '';

    try {
      if (academicFacilityFile) {
        try {
          const data = await uploadCroppedImage(academicFacilityFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
          imageUrl = data.secure_url;
          publicId = data.public_id;
        } catch (error) {
          console.error("Upload failed in handleAcademicFacilitySubmit:", error);
          toast.error("Gagal mengupload gambar fasilitas akademik. Silakan coba lagi.");
          setUploading(false);
          return;
        }
      }

      const facilityData = {
        title: currentAcademicFacility.title,
        description: currentAcademicFacility.description,
        image: imageUrl,
        public_id: publicId,
        order: Number(currentAcademicFacility.order) || 0,
        fullDescription: currentAcademicFacility.fullDescription || '',
        linkedGallery: currentAcademicFacility.linkedGallery || '',
      };

      if (isEditingAcademicFacility) {
        await updateDoc(doc(db, 'academicFacilities', academicFacilityId), facilityData);
        setSuccessMessage('Data fasilitas akademik berhasil diperbarui.');
      } else {
        await addDoc(collection(db, 'academicFacilities'), facilityData);
        setSuccessMessage('Fasilitas akademik baru berhasil ditambahkan.');
      }

      resetAcademicFacilityForm();
      fetchAcademicFacilities();
    } catch (err) {
      setError('Gagal menyimpan data pengembangan akademik.');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const handleEditAcademicFacility = (facility) => {
    setIsEditingAcademicFacility(true);
    setShowAcademicFacilityForm(true);
    setAcademicFacilityId(facility.id);
    setCurrentAcademicFacility({
      title: facility.title,
      description: facility.description,
      image: facility.image,
      public_id: facility.public_id || '',
      order: facility.order || 0,
      fullDescription: facility.fullDescription || '',
      linkedGallery: facility.linkedGallery || ''
    });
    setAcademicFacilityPreview(facility.image); // FIX: Tampilkan preview gambar yang sedang diedit
  };

  const handleDeleteAcademicFacility = async (id) => {
    showConfirmationModal('Hapus Fasilitas?', 'Anda yakin ingin menghapus data fasilitas pengembangan akademik ini?', async () => {
      await deleteDoc(doc(db, 'academicFacilities', id));
      setSuccessMessage('Data pengembangan akademik berhasil dihapus.');
      fetchAcademicFacilities();
    });
  };

  const resetMajorForm = () => {
    setIsEditingMajor(false);
    setMajorId(null);
    setCurrentMajor({ title: '', description: '', image: '', public_id: '', order: 0, fullDescription: '', linkedGallery: '', careerProspects: [] });
    setCareerProspects([{ title: '', description: '' }]);
    setMajorFile(null);
    setMajorPreview('');
    setShowMajorForm(false);
    const form = document.getElementById('major-form');
    if (form) form.reset();
  };

  const handleMajorSubmit = async (e) => {
    e.preventDefault();
    if (!currentMajor.title || !currentMajor.description) {
      setError("Judul dan Deskripsi tidak boleh kosong.");
      return;
    }
    setUploading(true);
    setError('');
    setSuccessMessage('');

    let imageUrl = currentMajor.image || '';
    let publicId = currentMajor.public_id || '';

    try {
      if (majorFile) {
        try {
          const data = await uploadCroppedImage(majorFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
          imageUrl = data.secure_url;
          publicId = data.public_id;
        } catch (error) {
          console.error("Upload failed in handleMajorSubmit:", error);
          toast.error("Gagal mengupload gambar jurusan. Silakan coba lagi.");
          setUploading(false);
          return;
        }
      }

      const majorData = {
        title: currentMajor.title,
        description: currentMajor.description,
        image: imageUrl,
        public_id: publicId,
        order: Number(currentMajor.order) || 0,
        fullDescription: currentMajor.fullDescription || '',
        linkedGallery: currentMajor.linkedGallery || '',
        careerProspects: careerProspects.filter(p => p.title.trim() !== ''), // Hanya simpan prospek yang terisi
      };

      if (isEditingMajor) {
        await updateDoc(doc(db, 'majors', majorId), majorData);
        setSuccessMessage('Data program keahlian berhasil diperbarui.');
      } else {
        await addDoc(collection(db, 'majors'), majorData);
        setSuccessMessage('Program keahlian baru berhasil ditambahkan.');
      }

      resetMajorForm();
      fetchMajors();
    } catch (err) {
      setError('Gagal menyimpan data program keahlian.');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const handleEditMajor = (major) => {
    setIsEditingMajor(true);
    setShowMajorForm(true);
    setMajorId(major.id);
    setCurrentMajor(major);
    setCareerProspects(major.careerProspects && major.careerProspects.length > 0 ? major.careerProspects : [{ title: '', description: '' }]);
    setMajorPreview(major.image);
  };

  const handleDeleteMajor = async (id) => {
    showConfirmationModal('Hapus Program Keahlian?', 'Anda yakin ingin menghapus data program keahlian ini?', async () => {
      await deleteDoc(doc(db, 'majors', id));
      setSuccessMessage('Data program keahlian berhasil dihapus.');
      fetchMajors();
    });
  };


  const resetEkstrakurikulerForm = () => {
    setIsEditingEkstrakurikuler(false);
    setEkstrakurikulerId(null);
    setCurrentEkstrakurikuler({ title: '', description: '', image: '', public_id: '', order: 0 });
    setEkstrakurikulerFile(null);
    setEkstrakurikulerPreview('');
    setShowEkstrakurikulerForm(false);
    const form = document.getElementById('ekstrakurikuler-form');
    if (form) form.reset();
  };

  const handleEkstrakurikulerSubmit = async (e) => {
    e.preventDefault();
    if (!currentEkstrakurikuler.title || !currentEkstrakurikuler.description) {
      setError("Judul dan Deskripsi tidak boleh kosong.");
      return;
    }
    setUploading(true);
    setError('');
    setSuccessMessage('');

    let imageUrl = currentEkstrakurikuler.image || '';
    let publicId = currentEkstrakurikuler.public_id || '';

    try {
      if (ekstrakurikulerFile) {
        try {
          const data = await uploadCroppedImage(ekstrakurikulerFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
          imageUrl = data.secure_url;
          publicId = data.public_id;
        } catch (error) {
          console.error("Upload failed in handleEkstrakurikulerSubmit:", error);
          toast.error("Gagal mengupload gambar ekstrakurikuler. Silakan coba lagi.");
          setUploading(false);
          return;
        }
      }

      const ekstrakurikulerData = {
        title: currentEkstrakurikuler.title,
        description: currentEkstrakurikuler.description,
        image: imageUrl,
        public_id: publicId,
        order: Number(currentEkstrakurikuler.order) || 0,
      };

      if (isEditingEkstrakurikuler) {
        await updateDoc(doc(db, 'ekstrakurikuler', ekstrakurikulerId), ekstrakurikulerData);
        setSuccessMessage('Data ekstrakurikuler berhasil diperbarui.');
      } else {
        await addDoc(collection(db, 'ekstrakurikuler'), ekstrakurikulerData);
        setSuccessMessage('Ekstrakurikuler baru berhasil ditambahkan.');
      }

      resetEkstrakurikulerForm();
      fetchEkstrakurikuler();
    } catch (err) {
      setError('Gagal menyimpan data ekstrakurikuler.');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const handleEditEkstrakurikuler = (item) => {
    setIsEditingEkstrakurikuler(true);
    setShowEkstrakurikulerForm(true);
    setEkstrakurikulerId(item.id);
    setCurrentEkstrakurikuler({ title: item.title, description: item.description, image: item.image, public_id: item.public_id || '', order: item.order || 0 });
    setEkstrakurikulerPreview(item.image); // FIX: Tampilkan preview gambar yang sedang diedit
  };

  const handleDeleteEkstrakurikuler = async (id) => {
    if (window.confirm('Yakin ingin menghapus data ekstrakurikuler ini?')) {
      await deleteDoc(doc(db, 'ekstrakurikuler', id));
      setSuccessMessage('Data ekstrakurikuler berhasil dihapus.');
      fetchEkstrakurikuler();
    }
  };

  // --- FUNGSI UNTUK MITRA INDUSTRI ---
  const resetMitraForm = () => {
    setIsEditingMitra(false);
    setMitraId(null);
    setCurrentMitra({ name: '', website: '', logoUrl: '', public_id: '', order: 0, category: 'Hotel' });
    setMitraFile(null);
    setMitraPreview('');
    setShowMitraForm(false);
    const form = document.getElementById('mitra-form');
    if (form) form.reset();
  };

  const handleMitraSubmit = async (e) => {
    e.preventDefault();
    if (!currentMitra.name) {
      setError("Nama Mitra tidak boleh kosong.");
      return;
    }
    setUploading(true);
    setError('');
    setSuccessMessage('');

    let imageUrl = currentMitra.logoUrl || '';
    let publicId = currentMitra.public_id || '';

    try {
      if (mitraFile) {
        try {
          const data = await uploadCroppedImage(mitraFile, process.env.REACT_APP_CLOUDINARY_UPLOAD_PRESET);
          imageUrl = data.secure_url;
          publicId = data.public_id;
        } catch (error) {
          console.error("Upload failed in handleMitraSubmit:", error);
          toast.error("Gagal mengupload logo mitra. Silakan coba lagi.");
          setUploading(false);
          return;
        }
      }

      const mitraData = {
        name: currentMitra.name,
        website: currentMitra.website,
        logoUrl: imageUrl || '',
        public_id: publicId || '',
        order: Number(currentMitra.order) || 0,
        category: currentMitra.category || 'Hotel',
      };

      if (isEditingMitra) {
        await updateDoc(doc(db, 'mitraIndustri', mitraId), mitraData);
        setSuccessMessage('Data mitra berhasil diperbarui.');
      } else {
        await addDoc(collection(db, 'mitraIndustri'), mitraData);
        setSuccessMessage('Mitra baru berhasil ditambahkan.');
      }

      resetMitraForm();
      fetchMitra();
    } catch (err) {
      setError('Gagal menyimpan data mitra.');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const handleEditMitra = (item) => {
    setIsEditingMitra(true);
    setShowMitraForm(true);
    setMitraId(item.id);
    setCurrentMitra({ name: item.name, website: item.website || '', logoUrl: item.logoUrl, public_id: item.public_id || '', order: item.order || 0, category: item.category || 'Hotel' });
    setMitraPreview(item.logoUrl);
  };

  const handleDeleteMitra = async (id) => {
    showConfirmationModal('Hapus Mitra?', 'Anda yakin ingin menghapus data mitra ini?', async () => {
      await deleteDoc(doc(db, 'mitraIndustri', id));
      setSuccessMessage('Data mitra berhasil dihapus.');
      fetchMitra();
    });
  };

  // --- FUNGSI UNTUK SHORT VIDEOS (CRUD) ---
  const resetShortVideoForm = () => {
    setIsEditingShortVideo(false);
    setShortVideoId(null);
    setCurrentShortVideo({ title: '', url: '', public_id: '', order: 0 });
    setShowShortVideoForm(false);
  };

  const handleShortVideoSubmit = async (e) => {
    e.preventDefault();
    if (!currentShortVideo.url) {
      setError("URL Video tidak boleh kosong.");
      return;
    }
    setUploading(true);
    setError('');
    setSuccessMessage('');

    try {
      const videoData = {
        ...currentShortVideo,
        date: serverTimestamp(),
        // Simple heuristic to remove query params if needed, or let component handle it
        url: currentShortVideo.url.trim()
      };

      if (isEditingShortVideo) {
        const docRef = doc(db, 'shortVideos', shortVideoId);
        await updateDoc(docRef, videoData);
        setSuccessMessage('Video berhasil diperbarui.');
      } else {
        await addDoc(collection(db, 'shortVideos'), videoData);
        setSuccessMessage('Video baru berhasil ditambahkan.');
      }

      resetShortVideoForm();
      fetchShortVideos();
    } catch (err) {
      setError('Gagal menyimpan data video.');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const handleEditShortVideo = (item) => {
    setIsEditingShortVideo(true);
    setShowShortVideoForm(true);
    setShortVideoId(item.id);
    setCurrentShortVideo(item);
  };

  const handleDeleteShortVideo = async (id) => {
    showConfirmationModal('Hapus Video?', 'Anda yakin ingin menghapus video ini?', async () => {
      await deleteDoc(doc(db, 'shortVideos', id));
      toast.success('Video berhasil dihapus.');
      fetchShortVideos();
    });
  };

  const handleAddNewShortVideo = () => {
    resetShortVideoForm();
    setShowShortVideoForm(true);
  };

  // --- FUNGSI UNTUK YOUTUBE VIDEOS (HORIZONTAL) ---
  const resetYoutubeVideoForm = () => {
    setIsEditingYoutubeVideo(false);
    setYoutubeVideoId(null);
    setCurrentYoutubeVideo({ title: '', url: '', public_id: '', order: 0 });
    setShowYoutubeVideoForm(false);
  };

  const handleYoutubeVideoSubmit = async (e) => {
    e.preventDefault();
    if (!currentYoutubeVideo.url) {
      setError("URL Video tidak boleh kosong.");
      return;
    }
    setUploading(true);
    setError('');
    setSuccessMessage('');

    try {
      const videoData = {
        ...currentYoutubeVideo,
        date: serverTimestamp(),
        url: currentYoutubeVideo.url.trim()
      };

      if (isEditingYoutubeVideo) {
        const docRef = doc(db, 'youtubeVideos', youtubeVideoId);
        await updateDoc(docRef, videoData);
        setSuccessMessage('Video Youtube berhasil diperbarui.');
      } else {
        await addDoc(collection(db, 'youtubeVideos'), videoData);
        setSuccessMessage('Video Youtube baru berhasil ditambahkan.');
      }

      resetYoutubeVideoForm();
      fetchYoutubeVideos();
    } catch (err) {
      setError('Gagal menyimpan data video.');
      console.error(err);
    } finally {
      setUploading(false);
    }
  };

  const handleEditYoutubeVideo = (item) => {
    setIsEditingYoutubeVideo(true);
    setShowYoutubeVideoForm(true);
    setYoutubeVideoId(item.id);
    setCurrentYoutubeVideo(item);
  };

  const handleDeleteYoutubeVideo = async (id) => {
    showConfirmationModal('Hapus Video?', 'Anda yakin ingin menghapus video ini?', async () => {
      await deleteDoc(doc(db, 'youtubeVideos', id));
      toast.success('Video berhasil dihapus.');
      fetchYoutubeVideos();
    });
  };

  const handleAddNewYoutubeVideo = () => {
    resetYoutubeVideoForm();
    setShowYoutubeVideoForm(true);
  };

  const handleAddNewMitra = () => {
    resetMitraForm();
    setShowMitraForm(true);
  };

  // --- FUNGSI UNTUK PENGATURAN KONTAK SPMB ---
  const handleSpmbContactChange = (index, field, value) => {
    setSiteSettings(prevSettings => {
      const newContacts = [...(prevSettings.spmbWhatsappNumbers || [])];
      newContacts[index] = { ...newContacts[index], [field]: value };
      return {
        ...prevSettings,
        spmbWhatsappNumbers: newContacts
      };
    });
  };

  const addSpmbContact = () => {
    setSiteSettings(prevSettings => ({
      ...prevSettings,
      spmbWhatsappNumbers: [...(prevSettings.spmbWhatsappNumbers || []), { name: '', number: '' }]
    }));
  };

  const removeSpmbContact = (index) => {
    setSiteSettings(prevSettings => ({
      ...prevSettings,
      spmbWhatsappNumbers: (prevSettings.spmbWhatsappNumbers || []).filter((_, i) => i !== index)
    }));
  };

  const handleAddNewPublicFacility = () => {
    resetPublicFacilityForm();
    setShowPublicFacilityForm(true);
  };

  const handleAddNewAcademicFacility = () => {
    resetAcademicFacilityForm();
    setShowAcademicFacilityForm(true);
  };

  const handleAddNewEkstrakurikuler = () => {
    resetEkstrakurikulerForm();
    setShowEkstrakurikulerForm(true);
  };

  const handleAddNewStaff = () => {
    resetStaffForm();
    setShowStaffForm(true);
  };

  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
    localStorage.setItem('activeAdminTab', tabName); // Tetap simpan tab aktif
    // Otomatis tutup sidebar di mobile saat tab dipilih
    if (window.innerWidth <= 768) {
      setIsSidebarOpen(false);
    }
  };

  const handleDropdownClick = (dropdownName) => {
    setOpenDropdown(prev => (prev === dropdownName ? '' : dropdownName));
  };

  // Fungsi untuk menangani klik pada item dropdown
  const handleDropdownItemClick = (tabName) => {
    handleTabClick(tabName);
  };

  return (
    <div className="admin-dashboard">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <ConfirmationModal
        isOpen={confirmModalState.isOpen}
        onClose={closeConfirmationModal}
        onConfirm={handleConfirmAction}
        title={confirmModalState.title}
        message={confirmModalState.message}
      />

      {/* Mobile Overlay only when open on mobile */}
      {isSidebarOpen && window.innerWidth <= 768 && <div className="sidebar-overlay" onClick={() => setIsSidebarOpen(false)}></div>}

      <aside className={`admin-sidebar ${isSidebarOpen ? 'open' : 'collapsed'}`}>
        <div className="admin-sidebar-header">
          <img src={logo} alt="Logo" />
          <h2>Admin Panel</h2>
        </div>
        <nav className="admin-nav">
          <div className="admin-nav-group">
            <button onClick={() => handleTabClick('dashboard')} className={activeTab === 'dashboard' ? 'active' : ''} title="Dashboard">
              <FaThLarge /> <span>Dashboard</span>
            </button>
            <h3 className="admin-nav-title">Manajemen Konten</h3>
            <button onClick={() => handleTabClick('berita')} className={activeTab === 'berita' ? 'active' : ''} title="Kelola Berita">
              <FaNewspaper /> <span>Kelola Berita</span>
            </button>
            {/* Dropdown Unit Kerja */}
            <div className="admin-nav-dropdown">
              <button onClick={() => handleDropdownClick('unitKerja')} className={`dropdown-toggle ${openDropdown === 'unitKerja' ? 'active' : ''}`} title="Unit Kerja">
                <FaUsers /> <span>Unit Kerja</span> <FaChevronDown className={`chevron-icon ${openDropdown === 'unitKerja' ? 'open' : ''}`} />
              </button>
              <div className={`admin-nav-dropdown-content ${openDropdown === 'unitKerja' ? 'open' : ''}`}>
                <button onClick={() => handleDropdownItemClick('kesiswaan')} className={activeTab === 'kesiswaan' ? 'active' : ''} title="Wakasek Kesiswaan"><span>Wakasek Kesiswaan</span></button>
                <button onClick={() => handleDropdownItemClick('kurikulum')} className={activeTab === 'kurikulum' ? 'active' : ''} title="Wakasek Kurikulum"><span>Wakasek Kurikulum</span></button>
              </div>
            </div>


            <button onClick={() => handleTabClick('agenda')} className={activeTab === 'agenda' ? 'active' : ''} title="Agenda Sekolah">
              <FaCalendarAlt /> <span>Agenda Sekolah</span>
            </button>
            <h3 className="admin-nav-title">Manajemen Galeri</h3>
            <button onClick={() => handleTabClick('galeri')} className={activeTab === 'galeri' ? 'active' : ''} title="Kelola Galeri">
              <FaImages /> <span>Kelola Galeri</span>
            </button>
            <button onClick={() => handleTabClick('program-keahlian')} className={activeTab === 'program-keahlian' ? 'active' : ''} title="Program Keahlian">
              <FaChalkboardTeacher /> <span>Program Keahlian</span>
            </button>
            <button onClick={() => handleTabClick('pengembangan-akademik')} className={activeTab === 'pengembangan-akademik' ? 'active' : ''} title="Fasilitas Akademik">
              <FaLandmark /> <span>Fasilitas Akademik</span>
            </button>
            <button onClick={() => handleTabClick('ruang-publik')} className={activeTab === 'ruang-publik' ? 'active' : ''} title="Ruang Publik">
              <FaLandmark /> <span>Ruang Publik</span>
            </button>
            <button onClick={() => handleTabClick('ekstrakurikuler')} className={activeTab === 'ekstrakurikuler' ? 'active' : ''} title="Ekstrakurikuler">
              <FaChalkboardTeacher /> <span>Ekstrakurikuler</span>
            </button>
            <button onClick={() => handleTabClick('mitra-industri')} className={activeTab === 'mitra-industri' ? 'active' : ''} title="Mitra Industri">
              <FaHandshake /> <span>Mitra Industri</span>
            </button>
            <button onClick={() => handleTabClick('video-shorts')} className={activeTab === 'video-shorts' ? 'active' : ''} title="Video Shorts">
              <FaMobileAlt /> <span>Video Shorts</span>
            </button>
            <button onClick={() => handleTabClick('video-youtube')} className={activeTab === 'video-youtube' ? 'active' : ''} title="Video Youtube">
              <FaYoutube /> <span>Video Youtube</span>
            </button>
          </div>
          <button onClick={() => handleTabClick('prestasi')} className={activeTab === 'prestasi' ? 'active' : ''} title="Kelola Prestasi">
            <FaTrophy /> <span>Kelola Prestasi</span>
          </button>
          <button onClick={() => handleTabClick('alumni-lulus')} className={activeTab === 'alumni-lulus' ? 'active' : ''} title="Alumni Lulus">
            <FaGraduationCap /> <span>Alumni Lulus</span>
          </button>
          <button onClick={() => handleTabClick('testimoni-alumni')} className={activeTab === 'testimoni-alumni' ? 'active' : ''} title="Testimoni Alumni">
            <FaQuoteRight /> <span>Testimoni Alumni</span>
          </button>
          <div className="admin-nav-group">
            <h3 className="admin-nav-title">Manajemen Halaman</h3>
            <button onClick={() => handleTabClick('halamanutama')} className={activeTab === 'halamanutama' ? 'active' : ''} title="Halaman Utama">
              <FaThLarge /> <span>Halaman Utama</span>
            </button>
            <button onClick={() => handleTabClick('tentang-kami')} className={activeTab === 'tentang-kami' ? 'active' : ''} title="Tentang Kami">
              <FaInfoCircle /> <span>Tentang Kami</span>
            </button>
            <button onClick={() => handleTabClick('spmb')} className={activeTab === 'spmb' ? 'active' : ''} title="Halaman SPMB">
              <FaNewspaper /> <span>Halaman SPMB</span>
            </button>
          </div>
          <div className="admin-nav-group">
            <h3 className="admin-nav-title">Administrasi</h3>
            <button onClick={() => handleTabClick('staf')} className={activeTab === 'staf' ? 'active' : ''} title="Kelola Staf">
              <FaUsers /> <span>Kelola Staf</span>
            </button>
            <button onClick={() => handleTabClick('pesan')} className={activeTab === 'pesan' ? 'active' : ''} title="Pesan Masuk">
              <FaEnvelope /> <span>Pesan Masuk</span>
            </button>
            <button onClick={() => handleTabClick('pengaturan')} className={activeTab === 'pengaturan' ? 'active' : ''} title="Pengaturan Situs">
              <FaCog /> <span>Pengaturan Situs</span>
            </button>
          </div>
        </nav>
        <div className="admin-sidebar-footer">
          <a href="/" target="_blank" rel="noopener noreferrer" className="sidebar-link" title="Lihat Situs">
            <FaExternalLinkAlt /> <span>Lihat Situs</span>
          </a>
          <button onClick={handleLogout} className="logout-button" title="Logout">
            <FaSignOutAlt /> <span>Logout</span>
          </button>
        </div>
      </aside>

      <main className={`admin-main-content ${isSidebarOpen ? 'sidebar-open' : ''}`}>
        <header className="admin-header">
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <button className="sidebar-toggle" onClick={() => setIsSidebarOpen(!isSidebarOpen)}>
              <FaBars />
            </button>
            <span>{siteSettings.siteName || "SMK Pariwisata Sumbangsih"}</span>
          </div>

        </header>

        {error && <p className="submit-status error" style={{ marginBottom: '20px' }}>{error}</p>}
        {successMessage && <p className="submit-status success" style={{ marginBottom: '20px' }}>{successMessage}</p>}

        {false && (
          <div className="admin-section dashboard-overview">
            <h2 style={{ marginBottom: '24px', fontSize: '1.8rem', color: '#1a1a1a' }}>
              {getGreeting()}, Admin!
            </h2>

            {/* Stats Grid */}
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))', gap: '24px', marginBottom: '32px' }}>

              <div className="stat-card" style={{ background: '#fff', padding: '24px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', display: 'flex', alignItems: 'center', gap: '20px' }}>
                <div style={{ width: '60px', height: '60px', borderRadius: '12px', background: '#e6f7ff', color: '#1890ff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.8rem' }}>
                  <FaEnvelope />
                </div>
                <div>
                  <h3 style={{ margin: 0, fontSize: '2rem', color: '#333' }}>{dashboardStats.unreadPesanCount}</h3>
                  <p style={{ margin: 0, color: '#888', fontSize: '0.9rem' }}>Pesan Baru</p>
                </div>
              </div>

              <div className="stat-card" style={{ background: '#fff', padding: '24px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', display: 'flex', alignItems: 'center', gap: '20px' }}>
                <div style={{ width: '60px', height: '60px', borderRadius: '12px', background: '#e6ffed', color: '#52c41a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.8rem' }}>
                  <FaNewspaper />
                </div>
                <div>
                  <h3 style={{ margin: 0, fontSize: '2rem', color: '#333' }}>{dashboardStats.beritaCount}</h3>
                  <p style={{ margin: 0, color: '#888', fontSize: '0.9rem' }}>Total Berita</p>
                </div>
              </div>

              <div className="stat-card" style={{ background: '#fff', padding: '24px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', display: 'flex', alignItems: 'center', gap: '20px' }}>
                <div style={{ width: '60px', height: '60px', borderRadius: '12px', background: '#fff7e6', color: '#fa8c16', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.8rem' }}>
                  <FaImages />
                </div>
                <div>
                  <h3 style={{ margin: 0, fontSize: '2rem', color: '#333' }}>{dashboardStats.galleryCount}</h3>
                  <p style={{ margin: 0, color: '#888', fontSize: '0.9rem' }}>Total Foto</p>
                </div>
              </div>

              <div className="stat-card" style={{ background: '#fff', padding: '24px', borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)', display: 'flex', alignItems: 'center', gap: '20px' }}>
                <div style={{ width: '60px', height: '60px', borderRadius: '12px', background: '#fff1f0', color: '#f5222d', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.8rem' }}>
                  <FaTrophy />
                </div>
                <div>
                  <h3 style={{ margin: 0, fontSize: '2rem', color: '#333' }}>{dashboardStats.prestasiCount}</h3>
                  <p style={{ margin: 0, color: '#888', fontSize: '0.9rem' }}>Prestasi</p>
                </div>
              </div>

            </div>

            {/* Quick Actions */}
            <h3 style={{ marginBottom: '16px', color: '#555', fontSize: '1.1rem' }}>Akses Cepat</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '16px', marginBottom: '40px' }}>
              <button onClick={() => handleTabClick('berita')} className="quick-action-btn" style={{ background: '#fff', border: '1px solid #eee', padding: '20px', borderRadius: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', cursor: 'pointer', transition: 'all 0.2s' }}>
                <FaPlus style={{ fontSize: '1.5rem', color: '#1890ff' }} />
                <span style={{ fontWeight: '500', color: '#333' }}>Buat Berita Baru</span>
              </button>
              <button onClick={() => handleTabClick('galeri')} className="quick-action-btn" style={{ background: '#fff', border: '1px solid #eee', padding: '20px', borderRadius: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', cursor: 'pointer', transition: 'all 0.2s' }}>
                <FaImages style={{ fontSize: '1.5rem', color: '#fa8c16' }} />
                <span style={{ fontWeight: '500', color: '#333' }}>Upload Foto Galeri</span>
              </button>
              <button onClick={() => handleTabClick('pesan')} className="quick-action-btn" style={{ background: '#fff', border: '1px solid #eee', padding: '20px', borderRadius: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', cursor: 'pointer', transition: 'all 0.2s' }}>
                <FaEnvelope style={{ fontSize: '1.5rem', color: '#52c41a' }} />
                <span style={{ fontWeight: '500', color: '#333' }}>Cek Pesan Masuk</span>
              </button>
              <button onClick={() => handleTabClick('video-shorts')} className="quick-action-btn" style={{ background: '#fff', border: '1px solid #eee', padding: '20px', borderRadius: '10px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px', cursor: 'pointer', transition: 'all 0.2s' }}>
                <FaMobileAlt style={{ fontSize: '1.5rem', color: '#722ed1' }} />
                <span style={{ fontWeight: '500', color: '#333' }}>Upload Shorts/TikTok</span>
              </button>
            </div>

            {/* Recent Activity Feed */}
            <h3 style={{ marginBottom: '16px', color: '#555', fontSize: '1.1rem' }}>Aktivitas Terkini</h3>
            <ul className="recent-activity-list">
              {recentActivity.length > 0 ? (
                recentActivity.map((activity, index) => (
                  <li key={`${activity.type}-${activity.id || index}`} className="activity-item">
                    <div className="activity-icon" style={{ background: activity.type === 'berita' ? '#f6ffed' : '#e6f7ff' }}>
                      {activity.icon}
                    </div>
                    <div className="activity-content">
                      <h4>{activity.title}</h4>
                      <p>{activity.desc}</p>
                    </div>
                    <span className="activity-time">
                      {activity.time.toLocaleDateString('id-ID', { day: 'numeric', month: 'short' })}
                    </span>
                  </li>
                ))
              ) : (
                <li className="activity-item" style={{ justifyContent: 'center', color: '#999' }}>Belum ada aktivitas terkini.</li>
              )}
            </ul>

          </div>
        )}

        {activeTab === 'video-shorts' && (
          <div className="admin-section">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2>Kelola Video Shorts & TikTok</h2>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <div className="view-toggle" style={{ display: 'flex', background: '#f5f5f5', borderRadius: '8px', padding: '4px' }}>
                  <button
                    onClick={() => setShortsViewMode('list')}
                    className={shortsViewMode === 'list' ? 'active' : ''}
                    title="List View"
                    style={{
                      border: 'none',
                      background: shortsViewMode === 'list' ? '#fff' : 'transparent',
                      boxShadow: shortsViewMode === 'list' ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
                      color: shortsViewMode === 'list' ? 'var(--primary-color)' : '#888',
                      padding: '8px',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <FaList />
                  </button>
                  <button
                    onClick={() => setShortsViewMode('grid')}
                    className={shortsViewMode === 'grid' ? 'active' : ''}
                    title="Grid View"
                    style={{
                      border: 'none',
                      background: shortsViewMode === 'grid' ? '#fff' : 'transparent',
                      boxShadow: shortsViewMode === 'grid' ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
                      color: shortsViewMode === 'grid' ? 'var(--primary-color)' : '#888',
                      padding: '8px',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <FaThLarge />
                  </button>
                </div>
                <button className="add-button" onClick={handleAddNewShortVideo}>
                  <FaPlus /> Tambah Video
                </button>
              </div>
            </div>

            {showShortVideoForm && (
              <div className="admin-modal-overlay">
                <div className="admin-modal-content">
                  <div className="admin-modal-header">
                    <h3>{isEditingShortVideo ? 'Edit Video Shorts' : 'Tambah Video Shorts'}</h3>
                    <button type="button" className="admin-modal-close" onClick={resetShortVideoForm}>&times;</button>
                  </div>

                  <form onSubmit={handleShortVideoSubmit} className="modern-form">
                    <div className="admin-modal-body">
                      <div className="form-group">
                        <label>Judul (Opsional)</label>
                        <input
                          type="text"
                          value={currentShortVideo.title}
                          onChange={(e) => setCurrentShortVideo({ ...currentShortVideo, title: e.target.value })}
                          placeholder="Judul video..."
                          autoFocus
                        />
                      </div>

                      <div className="form-group">
                        <label>URL Video (YouTube Short / TikTok)</label>
                        <input
                          type="text"
                          value={currentShortVideo.url}
                          onChange={(e) => setCurrentShortVideo({ ...currentShortVideo, url: e.target.value })}
                          placeholder="Contoh: https://youtube.com/shorts/... atau https://tiktok.com/..."
                          required
                        />
                        <small className="form-note">Paste link lengkap dari YouTube Shorts atau TikTok.</small>
                      </div>
                    </div>

                    <div className="admin-modal-footer">
                      <button type="button" onClick={resetShortVideoForm} className="cancel-button">
                        Batal
                      </button>
                      <button type="submit" disabled={uploading} className="save-button">
                        {uploading ? 'Menyimpan...' : 'Simpan'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {shortsViewMode === 'list' ? (
              <div className="admin-table-container">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th style={{ width: '100px' }}>Preview</th>
                      <th>Judul Video</th>
                      <th>Platform</th>
                      <th>URL</th>
                      <th>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {shortVideosList.map((video) => {
                      const isYoutube = video.url.includes('youtube') || video.url.includes('youtu.be');


                      const getYoutubeId = (url) => {
                        if (!url) return null;
                        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
                        const match = url.match(regExp);
                        return (match && match[2].length === 11) ? match[2] : null;
                      };

                      const videoId = isYoutube ? getYoutubeId(video.url) : null;
                      const thumbnailUrl = videoId ? `https://img.youtube.com/vi/${videoId}/mqdefault.jpg` : null;

                      return (
                        <tr key={video.id}>
                          <td>
                            {isYoutube && thumbnailUrl ? (
                              <img
                                src={thumbnailUrl}
                                alt="Thumb"
                                style={{
                                  width: '40px', // Mobile ratio mostly vertical, but keep square/small
                                  height: '60px',
                                  objectFit: 'cover',
                                  borderRadius: '4px',
                                  border: '1px solid #eee'
                                }}
                                onError={(e) => {
                                  e.target.onerror = null;
                                  e.target.style.display = 'none';
                                  e.target.nextSibling.style.display = 'flex';
                                }}
                              />
                            ) : null}
                            <div style={{
                              width: '40px',
                              height: '60px',
                              background: '#eee',
                              borderRadius: '4px',
                              display: (isYoutube && thumbnailUrl) ? 'none' : 'flex',
                              alignItems: 'center',
                              justifyContent: 'center'
                            }}>
                              {isYoutube ? (
                                <FaYoutube style={{ color: '#ccc', fontSize: '1.2rem' }} />
                              ) : (
                                <FaMobileAlt style={{ color: '#ccc', fontSize: '1.2rem' }} /> // Placeholder for TikTok
                              )}
                            </div>
                          </td>
                          <td>
                            <span>{video.title || 'Tanpa Judul'}</span>
                          </td>
                          <td>
                            <span className={`video-badge ${isYoutube ? 'youtube' : 'tiktok'}`} style={{ fontSize: '0.7rem', padding: '2px 6px' }}>
                              {isYoutube ? 'YouTube' : 'TikTok'}
                            </span>
                          </td>
                          <td>
                            <a href={video.url} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-color)', textDecoration: 'none', maxWidth: '200px', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {video.url}
                            </a>
                          </td>
                          <td>
                            <div className="action-buttons" style={{ display: 'flex', gap: '8px' }}>
                              <button
                                onClick={() => handleEditShortVideo(video)}
                                className="icon-btn edit"
                                title="Edit"
                                style={{
                                  background: '#e3f2fd',
                                  color: '#1976d2',
                                  border: 'none',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                }}
                                onMouseOver={(e) => { e.currentTarget.style.background = '#bbdefb'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                                onMouseOut={(e) => { e.currentTarget.style.background = '#e3f2fd'; e.currentTarget.style.transform = 'translateY(0)'; }}
                              >
                                <FaPencilAlt />
                              </button>
                              <button
                                onClick={() => handleDeleteShortVideo(video.id)}
                                className="icon-btn delete"
                                title="Hapus"
                                style={{
                                  background: '#ffebee',
                                  color: '#d32f2f',
                                  border: 'none',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                }}
                                onMouseOver={(e) => { e.currentTarget.style.background = '#ffcdd2'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                                onMouseOut={(e) => { e.currentTarget.style.background = '#ffebee'; e.currentTarget.style.transform = 'translateY(0)'; }}
                              >
                                <FaTrash />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                    {shortVideosList.length === 0 && (
                      <tr>
                        <td colSpan="5" style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
                          Belum ada video shorts yang ditambahkan.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="video-manager-grid">
                {shortVideosList.map((video) => {
                  let embedUrl = null;
                  const isYoutube = video.url.includes('youtube') || video.url.includes('youtu.be');
                  const isTiktok = video.url.includes('tiktok');

                  if (isYoutube) {
                    const videoId = video.url.split('/shorts/')[1]?.split('?')[0] || video.url.split('v=')[1]?.split('&')[0];
                    if (videoId) embedUrl = `https://www.youtube.com/embed/${videoId}`;
                  } else if (isTiktok) {
                    const videoId = video.url.split('/video/')[1]?.split('?')[0];
                    if (videoId) embedUrl = `https://www.tiktok.com/embed/v2/${videoId}`;
                  }

                  return (
                    <div key={video.id} className="video-card">
                      <div className="video-card-header">
                        <h4>{video.title || 'Tanpa Judul'}</h4>
                        <span className={`video-badge ${isYoutube ? 'youtube' : 'tiktok'}`}>
                          {isYoutube ? 'YouTube' : 'TikTok'}
                        </span>
                      </div>

                      <div className="video-card-preview vertical">
                        {embedUrl ? (
                          <iframe src={embedUrl} title="Preview" loading="lazy"></iframe>
                        ) : (
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#fff' }}>No Preview</div>
                        )}
                        <div className="video-card-overlay"></div>
                      </div>

                      <div className="video-card-footer">
                        <button onClick={() => window.open(video.url, '_blank')} className="card-action-btn link" title="Buka Link">
                          <FaExternalLinkAlt />
                        </button>
                        <button onClick={() => handleEditShortVideo(video)} className="card-action-btn edit" title="Edit">
                          <FaPencilAlt />
                        </button>
                        <button onClick={() => handleDeleteShortVideo(video.id)} className="card-action-btn delete" title="Hapus">
                          <FaTrash />
                        </button>
                      </div>
                    </div>
                  );
                })}

                {shortVideosList.length === 0 && (
                  <div className="empty-state" style={{ gridColumn: '1/-1' }}>
                    <div className="empty-state-icon"><FaMobileAlt /></div>
                    <p>Belum ada video shorts yang ditambahkan.</p>
                    <button className="add-button" onClick={handleAddNewShortVideo} style={{ marginTop: '15px' }}>
                      <FaPlus /> Tambah Sekarang
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}

        {/* End of Video Shorts Section */}

        {activeTab === 'video-youtube' && (
          <div className="admin-section">
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
              <h2>Kelola Video Youtube</h2>
              <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                <div className="view-toggle" style={{ display: 'flex', background: '#f5f5f5', borderRadius: '8px', padding: '4px' }}>
                  <button
                    onClick={() => setYoutubeViewMode('list')}
                    className={youtubeViewMode === 'list' ? 'active' : ''}
                    title="List View"
                    style={{
                      border: 'none',
                      background: youtubeViewMode === 'list' ? '#fff' : 'transparent',
                      boxShadow: youtubeViewMode === 'list' ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
                      color: youtubeViewMode === 'list' ? 'var(--primary-color)' : '#888',
                      padding: '8px',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <FaList />
                  </button>
                  <button
                    onClick={() => setYoutubeViewMode('grid')}
                    className={youtubeViewMode === 'grid' ? 'active' : ''}
                    title="Grid View"
                    style={{
                      border: 'none',
                      background: youtubeViewMode === 'grid' ? '#fff' : 'transparent',
                      boxShadow: youtubeViewMode === 'grid' ? '0 2px 4px rgba(0,0,0,0.1)' : 'none',
                      color: youtubeViewMode === 'grid' ? 'var(--primary-color)' : '#888',
                      padding: '8px',
                      borderRadius: '6px',
                      cursor: 'pointer',
                      display: 'flex',
                      alignItems: 'center'
                    }}
                  >
                    <FaThLarge />
                  </button>
                </div>
                <button className="add-button" onClick={handleAddNewYoutubeVideo}>
                  <FaPlus /> Tambah Video
                </button>
              </div>
            </div>

            {showYoutubeVideoForm && (
              <div className="admin-modal-overlay">
                <div className="admin-modal-content">
                  <div className="admin-modal-header">
                    <h3>{isEditingYoutubeVideo ? 'Edit Video Youtube' : 'Tambah Video Youtube'}</h3>
                    <button type="button" className="admin-modal-close" onClick={resetYoutubeVideoForm}>&times;</button>
                  </div>

                  <form onSubmit={handleYoutubeVideoSubmit} className="modern-form">
                    <div className="admin-modal-body">
                      <div className="form-group">
                        <label>Judul (Opsional)</label>
                        <input
                          type="text"
                          value={currentYoutubeVideo.title}
                          onChange={(e) => setCurrentYoutubeVideo({ ...currentYoutubeVideo, title: e.target.value })}
                          placeholder="Judul video..."
                          autoFocus
                        />
                      </div>

                      <div className="form-group">
                        <label>URL Video (YouTube)</label>
                        <input
                          type="text"
                          value={currentYoutubeVideo.url}
                          onChange={(e) => setCurrentYoutubeVideo({ ...currentYoutubeVideo, url: e.target.value })}
                          placeholder="https://www.youtube.com/watch?v=..."
                          required
                        />
                        <small className="form-note">Paste link lengkap video YouTube.</small>
                      </div>
                    </div>

                    <div className="admin-modal-footer">
                      <button type="button" onClick={resetYoutubeVideoForm} className="cancel-button">
                        Batal
                      </button>
                      <button type="submit" disabled={uploading} className="save-button">
                        {uploading ? 'Menyimpan...' : 'Simpan'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {youtubeViewMode === 'list' ? (
              <div className="admin-table-container">
                <table className="admin-table">
                  <thead>
                    <tr>
                      <th style={{ width: '100px' }}>Preview</th>
                      <th>Judul Video</th>
                      <th>URL</th>
                      <th>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {youtubeVideosList.map((video) => {
                      const url = video.videoUrl || video.url;

                      const getYoutubeId = (url) => {
                        if (!url) return null;
                        const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
                        const match = url.match(regExp);
                        return (match && match[2].length === 11) ? match[2] : null;
                      };

                      const videoId = getYoutubeId(url);
                      const thumbnailUrl = videoId ? `https://img.youtube.com/vi/${videoId}/mqdefault.jpg` : null;

                      return (
                        <tr key={video.id}>
                          <td>
                            {thumbnailUrl ? (
                              <img
                                src={thumbnailUrl}
                                alt="Thumb"
                                style={{ width: '80px', height: '60px', objectFit: 'cover', borderRadius: '4px' }}
                              />
                            ) : (
                              <div style={{ width: '80px', height: '60px', background: '#eee', borderRadius: '4px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <FaYoutube style={{ color: '#ccc' }} />
                              </div>
                            )}
                          </td>
                          <td>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                              <span>{video.title || 'Tanpa Judul'}</span>
                            </div>
                          </td>
                          <td>
                            <a href={url} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary-color)', textDecoration: 'none', maxWidth: '300px', display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                              {url}
                            </a>
                          </td>
                          <td>
                            <div className="action-buttons" style={{ display: 'flex', gap: '8px' }}>
                              <button
                                onClick={() => handleEditYoutubeVideo(video)}
                                className="icon-btn edit"
                                title="Edit"
                                style={{
                                  background: '#e3f2fd',
                                  color: '#1976d2',
                                  border: 'none',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                }}
                                onMouseOver={(e) => { e.currentTarget.style.background = '#bbdefb'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                                onMouseOut={(e) => { e.currentTarget.style.background = '#e3f2fd'; e.currentTarget.style.transform = 'translateY(0)'; }}
                              >
                                <FaPencilAlt />
                              </button>
                              <button
                                onClick={() => handleDeleteYoutubeVideo(video.id)}
                                className="icon-btn delete"
                                title="Hapus"
                                style={{
                                  background: '#ffebee',
                                  color: '#d32f2f',
                                  border: 'none',
                                  borderRadius: '8px',
                                  padding: '8px 12px',
                                  cursor: 'pointer',
                                  transition: 'all 0.2s ease',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
                                }}
                                onMouseOver={(e) => { e.currentTarget.style.background = '#ffcdd2'; e.currentTarget.style.transform = 'translateY(-2px)'; }}
                                onMouseOut={(e) => { e.currentTarget.style.background = '#ffebee'; e.currentTarget.style.transform = 'translateY(0)'; }}
                              >
                                <FaTrash />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                    {youtubeVideosList.length === 0 && (
                      <tr>
                        <td colSpan="4" style={{ textAlign: 'center', padding: '20px', color: '#888' }}>
                          Belum ada video Youtube yang ditambahkan.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="video-manager-grid">
                {youtubeVideosList.map((video) => {
                  let embedUrl = null;
                  const url = video.videoUrl || video.url;
                  try {
                    const urlObj = new URL(url);
                    if (urlObj.hostname === 'youtu.be') {
                      embedUrl = `https://www.youtube.com/embed/${urlObj.pathname.slice(1)}`;
                    } else if (urlObj.hostname.includes('youtube.com')) {
                      if (urlObj.pathname.includes('/embed/')) {
                        embedUrl = `https://www.youtube.com/embed/${urlObj.pathname.split('/embed/')[1]}`;
                      } else {
                        const v = urlObj.searchParams.get('v');
                        if (v) embedUrl = `https://www.youtube.com/embed/${v}`;
                      }
                    }
                  } catch (e) {
                    console.error("Invalid URL in admin preview", e);
                  }

                  return (
                    <div key={video.id} className="video-card">
                      <div className="video-card-header">
                        <h4>{video.title || 'Tanpa Judul'}</h4>
                        <span className="video-badge youtube">YouTube</span>
                      </div>

                      <div className="video-card-preview" style={{ paddingTop: '56.25%' }}>
                        {embedUrl ? (
                          <iframe src={embedUrl} title="Preview" loading="lazy"></iframe>
                        ) : (
                          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#fff' }}>No Preview</div>
                        )}
                        <div className="video-card-overlay"></div>
                      </div>

                      <div className="video-card-footer">
                        <button onClick={() => window.open(url, '_blank')} className="card-action-btn link" title="Buka Link">
                          <FaExternalLinkAlt />
                        </button>
                        <button onClick={() => handleEditYoutubeVideo(video)} className="card-action-btn edit" title="Edit">
                          <FaPencilAlt />
                        </button>
                        <button onClick={() => handleDeleteYoutubeVideo(video.id)} className="card-action-btn delete" title="Hapus">
                          <FaTrash />
                        </button>
                      </div>
                    </div>
                  );
                })}

                {youtubeVideosList.length === 0 && (
                  <div className="empty-state" style={{ gridColumn: '1/-1' }}>
                    <div className="empty-state-icon"><FaYoutube /></div>
                    <p>Belum ada video Youtube yang ditambahkan.</p>
                    <button className="add-button" onClick={handleAddNewYoutubeVideo} style={{ marginTop: '15px' }}>
                      <FaPlus /> Tambah Sekarang
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
        )}



        {/* End of Video Youtube Section */}
        {activeTab === 'halamanutama' && (
          <div className="admin-section">
            <h2 style={{ marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '15px' }}>Kelola Halaman Utama</h2>

            <div className="admin-modal-body two-col">
              <div className="form-col">


                <div className="form-box" style={{ marginTop: '20px' }}>
                  <h3>Latar Belakang CTA</h3>
                  <div className="upload-options">
                    <label htmlFor="cta-bg-upload" className="file-upload-label">Pilih & Potong</label>
                    <input id="cta-bg-upload" type="file" onChange={(e) => handleFileChangeWithCrop(e, 'ctaBg', undefined)} accept="image/*" style={{ display: 'none' }} />
                    <label htmlFor="cta-bg-full" className="file-upload-label alt">Full Image</label>
                    <input id="cta-bg-full" type="file" onChange={(e) => handleFullPageImageSelect(e, setCtaBgPreview)} accept="image/*" style={{ display: 'none' }} />
                    <button className="upload-trigger-btn" onClick={() => handlePageImageUpload('homePage', 'ctaBgUrl')} disabled={uploading || !file}>
                      {uploading ? 'Mengunggah...' : 'Upload'}
                    </button>
                    {ctaBgPreview && (
                      <button className="action-btn delete" onClick={() => handleDeletePageImage('homePage', 'ctaBgUrl')} disabled={uploading} title="Hapus Gambar"><FaTrash /></button>
                    )}
                  </div>
                  {ctaBgPreview ? (
                    <div className="image-preview-container" style={{ marginTop: '15px' }}>
                      <img src={ctaBgPreview} alt="Preview CTA" className="image-preview" />
                    </div>
                  ) : (
                    <p style={{ color: '#888', fontStyle: 'italic', marginTop: '10px' }}>Belum ada gambar latar belakang.</p>
                  )}
                </div>
              </div>
            </div>

            {/* Hero Slider Section - Separated from the two-col layout for better spacing */}
            <div className="admin-modal-body" style={{ marginTop: '24px', display: 'block' }}>
              <div className="form-box full-width">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                    <h3>Hero Slider</h3>
                    <span style={{ fontSize: '0.8rem', color: '#666', background: '#f0f0f0', padding: '4px 8px', borderRadius: '12px' }}>
                      {heroImages.length} Slide
                    </span>
                  </div>
                  <div className="upload-options" style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', alignItems: 'center' }}>
                    <button
                      type="button"
                      onClick={() => setShowAddHeroLinkModal(true)}
                      className="action-btn secondary small"
                      style={{ display: 'flex', alignItems: 'center', gap: '6px', cursor: 'pointer' }}
                      title="Tambah Slide dari Link Google Drive, Video, atau GIF"
                    >
                      <FaLink /> Tambah via URL / Link
                    </button>

                    <label htmlFor="hero-upload-crop" className="add-button small" title="Tambah & Potong" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                      <FaPlus /> Tambah Slide
                    </label>
                    <input id="hero-upload-crop" type="file" onChange={(e) => handleFileChangeWithCrop(e, 'hero', 16 / 9)} accept="image/*" style={{ display: 'none' }} />

                    <label htmlFor="hero-upload-full" className="action-btn secondary small" title="Tambah Full" style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '6px', margin: 0 }}>
                      <FaImages /> Upload Full
                    </label>
                    <input id="hero-upload-full" type="file" onChange={handleFullHeroImageUpload} accept="image/*" style={{ display: 'none' }} />
                  </div>
                </div>

                {/* Pengaturan Durasi Geser Otomatis (Autoplay) */}
                <div style={{
                  background: '#f8fafc',
                  border: '1px solid #e2e8f0',
                  borderRadius: '8px',
                  padding: '12px 16px',
                  marginBottom: '20px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  flexWrap: 'wrap',
                  gap: '12px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <FaClock style={{ color: '#0284c7', fontSize: '1.2rem' }} />
                    <div>
                      <strong style={{ fontSize: '0.9rem', color: '#1e293b' }}>Durasi Slide Otomatis:</strong>
                      <p style={{ margin: 0, fontSize: '0.8rem', color: '#64748b' }}>Waktu jeda antar-slide berganti secara otomatis (dalam detik)</p>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <input
                      type="number"
                      min="2"
                      max="60"
                      step="1"
                      value={heroSlideDuration}
                      onChange={(e) => setHeroSlideDuration(e.target.value)}
                      style={{
                        width: '80px',
                        padding: '6px 10px',
                        borderRadius: '6px',
                        border: '1px solid #cbd5e1',
                        fontSize: '0.9rem',
                        textAlign: 'center'
                      }}
                    />
                    <span style={{ fontSize: '0.9rem', color: '#475569' }}>detik</span>
                    <button
                      type="button"
                      onClick={handleSaveHeroSlideDuration}
                      disabled={isSavingHeroDuration}
                      className="add-button small"
                      style={{ padding: '6px 14px', margin: 0 }}
                    >
                      {isSavingHeroDuration ? 'Menyimpan...' : 'Simpan Durasi'}
                    </button>
                  </div>
                </div>

                <div className="resource-grid" style={{ gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px' }}>
                  {heroImages.map((image, index) => {
                    const isVid = image.mediaType === 'video' || (image.url && image.url.match(/\.(mp4|webm|ogg|mov)(\?.*)?$/i));
                    const isYT = image.mediaType === 'youtube' || (image.url && (image.url.includes('youtube.com') || image.url.includes('youtu.be')));
                    const isDrive = image.mediaType === 'drive' || (image.url && (image.url.includes('drive.google.com') || image.url.includes('docs.google.com')));
                    
                    let ytThumb = null;
                    if (isYT && image.url) {
                      const ytMatch = image.url.match(/(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=|shorts\/)|youtu\.be\/)([^"&?/\s]{11})/);
                      if (ytMatch && ytMatch[1]) {
                        ytThumb = `https://img.youtube.com/vi/${ytMatch[1]}/hqdefault.jpg`;
                      }
                    }

                    return (
                    <div key={image.id || index} className="resource-card" style={{ marginBottom: '0', position: 'relative', overflow: 'hidden', border: '1px solid #eaeaea', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                      <div className="resource-card-image-container" style={{ paddingTop: '56.25%', background: '#000' }}>
                        {isVid ? (
                          <video
                            src={image.url}
                            muted
                            playsInline
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }}
                          />
                        ) : (
                          <img
                            src={isYT && ytThumb ? ytThumb : (isDrive && image.url.includes('drive.google.com') ? `https://lh3.googleusercontent.com/d/${(image.url.match(/(?:file\/d\/|open\?id=|uc\?(?:export=download&)?id=)([a-zA-Z0-9_-]{25,})/) || [])[1] || ''}` : image.url)}
                            alt={`Slide ${index + 1}`}
                            className="resource-card-image"
                          />
                        )}
                        <div style={{
                          position: 'absolute',
                          top: '10px',
                          left: '10px',
                          background: 'rgba(0,0,0,0.65)',
                          color: '#fff',
                          padding: '4px 8px',
                          borderRadius: '4px',
                          fontSize: '0.75rem',
                          fontWeight: '600',
                          display: 'flex',
                          alignItems: 'center',
                          gap: '5px'
                        }}>
                          #{index + 1}
                          {isVid && <span style={{ background: '#e11d48', padding: '2px 5px', borderRadius: '3px', fontSize: '0.65rem' }}>VIDEO</span>}
                          {isYT && <span style={{ background: '#ff0000', padding: '2px 5px', borderRadius: '3px', fontSize: '0.65rem' }}>YOUTUBE</span>}
                          {isDrive && <span style={{ background: '#0284c7', padding: '2px 5px', borderRadius: '3px', fontSize: '0.65rem' }}>G-DRIVE</span>}
                        </div>
                      </div>

                      <div className="card-controls" style={{
                        padding: '12px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        background: '#fff',
                        borderTop: '1px solid #f0f0f0'
                      }}>
                        {/* Pengaturan Durasi Khusus untuk Slide ini */}
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px', fontSize: '0.85rem' }}>
                          <span style={{ color: '#475569', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <FaClock style={{ color: '#0284c7' }} /> Durasi:
                          </span>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <input
                              type="number"
                              min="2"
                              max="120"
                              placeholder={heroSlideDuration.toString()}
                              defaultValue={image.duration || ''}
                              onBlur={(e) => handleUpdateSlideDuration(index, e.target.value)}
                              onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                  e.target.blur();
                                }
                              }}
                              style={{
                                width: '65px',
                                padding: '4px 6px',
                                borderRadius: '4px',
                                border: '1px solid #cbd5e1',
                                textAlign: 'center',
                                fontSize: '0.85rem'
                              }}
                              title="Masukkan durasi dalam detik (misal: 15 untuk video, 5 untuk foto). Kosongkan jika ingin mengikuti durasi global."
                            />
                            <span style={{ color: '#64748b' }}>dtk</span>
                          </div>
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                          <div className="move-controls" style={{ display: 'flex', gap: '4px' }}>
                            <button
                              type="button"
                              disabled={index === 0}
                              onClick={() => handleMoveHeroImage(index, 'up')}
                              className="icon-btn"
                              style={{
                                border: '1px solid #ddd',
                                background: index === 0 ? '#f5f5f5' : '#fff',
                                cursor: index === 0 ? 'not-allowed' : 'pointer',
                                color: index === 0 ? '#ccc' : '#555',
                                padding: '6px',
                                borderRadius: '4px',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                width: '32px', height: '32px'
                              }}
                              title="Geser ke Awal"
                            >
                              <FaChevronLeft />
                            </button>
                            <button
                              type="button"
                              disabled={index === heroImages.length - 1}
                              onClick={() => handleMoveHeroImage(index, 'down')}
                              className="icon-btn"
                              style={{
                                border: '1px solid #ddd',
                                background: index === heroImages.length - 1 ? '#f5f5f5' : '#fff',
                                cursor: index === heroImages.length - 1 ? 'not-allowed' : 'pointer',
                                color: index === heroImages.length - 1 ? '#ccc' : '#555',
                                padding: '6px',
                                borderRadius: '4px',
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                                width: '32px', height: '32px'
                              }}
                              title="Geser ke Akhir"
                            >
                              <FaChevronRight />
                            </button>
                          </div>

                          <button
                            className="action-btn delete small"
                            onClick={() => handleDeleteHeroImage(image)}
                            title="Hapus Slide"
                            style={{
                              background: '#fff1f0',
                              color: '#ff4d4f',
                              border: '1px solid #ffccc7',
                              fontSize: '0.85rem',
                              padding: '6px 12px'
                            }}
                          >
                            <FaTrash /> Hapus
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
                  {heroImages.length === 0 && (
                    <div className="empty-state" style={{ gridColumn: '1/-1', border: '2px dashed #ddd', borderRadius: '12px', padding: '40px' }}>
                      <div className="empty-state-icon" style={{ fontSize: '2.5rem', color: '#ccc', marginBottom: '10px' }}><FaImages /></div>
                      <p>Belum ada slide gambar.</p>
                      <p style={{ fontSize: '0.85rem', color: '#888' }}>Tambahkan gambar untuk banner halaman utama.</p>
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Modal Tambah Slide via URL / Link */}
            {showAddHeroLinkModal && (
              <div className="modal-overlay" onClick={() => setShowAddHeroLinkModal(false)}>
                <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '520px', width: '90%', padding: '24px' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px' }}>
                    <h3 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <FaLink style={{ color: '#0284c7' }} /> Tambah Slide via URL / Link
                    </h3>
                    <button
                      type="button"
                      onClick={() => setShowAddHeroLinkModal(false)}
                      style={{ background: 'none', border: 'none', fontSize: '1.2rem', cursor: 'pointer', color: '#666' }}
                    >
                      <FaTimes />
                    </button>
                  </div>

                  <form onSubmit={handleAddHeroMediaUrl}>
                    <div className="form-group" style={{ marginBottom: '16px' }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '0.9rem' }}>
                        URL Video / GIF / Gambar:
                      </label>
                      <input
                        type="url"
                        placeholder="Contoh: https://drive.google.com/file/d/... atau link .mp4 / .gif"
                        value={heroMediaUrlInput}
                        onChange={(e) => setHeroMediaUrlInput(e.target.value)}
                        required
                        style={{
                          width: '100%',
                          padding: '10px 12px',
                          border: '1px solid #cbd5e1',
                          borderRadius: '8px',
                          fontSize: '0.9rem'
                        }}
                      />
                    </div>

                    <div className="form-group" style={{ marginBottom: '16px' }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '0.9rem' }}>
                        Jenis Media:
                      </label>
                      <select
                        value={heroMediaTypeInput}
                        onChange={(e) => setHeroMediaTypeInput(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '10px 12px',
                          border: '1px solid #cbd5e1',
                          borderRadius: '8px',
                          fontSize: '0.9rem'
                        }}
                      >
                        <option value="auto">Deteksi Otomatis (Drive / YouTube / Video / Gambar)</option>
                        <option value="drive_video">Google Drive (Video)</option>
                        <option value="youtube">YouTube Video</option>
                        <option value="video">Direct Video (.mp4, .webm, dll.)</option>
                        <option value="image">Gambar / GIF</option>
                      </select>
                    </div>
                    <div className="form-group" style={{ marginBottom: '16px' }}>
                      <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '0.9rem' }}>
                        Durasi Slide Ini (Detik) - <em>Opsional</em>:
                      </label>
                      <input
                        type="number"
                        min="2"
                        max="120"
                        placeholder={`Mengikuti durasi default (${heroSlideDuration} detik)`}
                        value={heroMediaDurationInput}
                        onChange={(e) => setHeroMediaDurationInput(e.target.value)}
                        style={{
                          width: '100%',
                          padding: '10px 12px',
                          border: '1px solid #cbd5e1',
                          borderRadius: '8px',
                          fontSize: '0.9rem'
                        }}
                      />
                    </div>

                    <div style={{
                      background: '#f0f9ff',
                      border: '1px solid #bae6fd',
                      borderRadius: '8px',
                      padding: '12px',
                      marginBottom: '20px',
                      fontSize: '0.82rem',
                      color: '#0369a1',
                      lineHeight: '1.4'
                    }}>
                      <strong>💡 Info Format:</strong>
                      <ul style={{ margin: '6px 0 0 18px', padding: 0 }}>
                        <li><strong>Google Drive:</strong> Cukup salin link share (pastikan akses diset <em>Siapa saja yang memiliki link dapat melihat</em>). Sistem otomatis mengubahnya ke direct stream agar langsung tampil tanpa loading viewer/delay.</li>
                        <li><strong>Direct Video:</strong> Format .mp4 / .webm akan diputar otomatis tanpa audio (autoplay muted).</li>
                        <li><strong>GIF:</strong> Link animasi .gif akan tampil bergerak langsung tanpa delay.</li>
                      </ul>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                      <button
                        type="button"
                        onClick={() => setShowAddHeroLinkModal(false)}
                        className="action-btn secondary"
                      >
                        Batal
                      </button>
                      <button
                        type="submit"
                        disabled={isAddingHeroLink}
                        className="add-button"
                        style={{ margin: 0 }}
                      >
                        {isAddingHeroLink ? 'Menyimpan...' : 'Tambahkan Slide'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </div>
        )
        }

        {/* AGENDA SECTION */}
        {
          activeTab === 'agenda' && (
            <div className="admin-section" style={{ maxWidth: '100%', width: '100%', padding: '0', background: 'transparent', boxShadow: 'none' }}>
              <h2 style={{ marginBottom: '24px', fontSize: '1.8rem', color: 'var(--admin-text)', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px' }}>
                <FaCalendarAlt style={{ color: '#1890ff' }} /> Agenda & Kalender Sekolah
              </h2>
              <AgendaManager />
            </div>
          )
        }

        {
          activeTab === 'galeri' && (
            <div className="admin-section" style={{ maxWidth: '100%', width: '100%', padding: '0', background: 'transparent', boxShadow: 'none' }}>
              <div className="gallery-management-layout" style={{ display: 'block' }}>

                {/* Grid / Form View Logic */}
                {showCategoryForm || activeGalleryCategory ? (
                  /* --- FORM VIEW (Create / Edit) --- */
                  <div className="admin-card" style={{ background: '#fff', borderRadius: '12px', padding: '30px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', gap: '10px' }}>
                      <button
                        onClick={() => {
                          setShowCategoryForm(false);
                          setActiveGalleryCategory(null);
                          resetCategoryForm();
                        }}
                        style={{ background: 'none', border: '1px solid #ddd', borderRadius: '50%', width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', color: '#555' }}
                      >
                        <FaChevronLeft />
                      </button>
                      <h3 style={{ margin: 0, color: '#333' }}>{isEditingCategory ? 'Edit Album' : 'Buat Album Baru'}</h3>
                    </div>

                    <form onSubmit={(e) => {
                      // Wraps handleCategorySubmit to ensure state is reset after
                      e.preventDefault();
                      handleCategorySubmit(e);
                      // Note: handleCategorySubmit is async and we updated it to close form on success across the file 
                      // But if we want to be sure UI reacts immediately we rely on that function's state updates.
                    }} className="modern-form">

                      {/* Metadata Fields (Name, Dates, etc) */}
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', marginBottom: '20px' }}>
                        <div className="form-group">
                          <label style={{ fontWeight: '600', marginBottom: '8px', display: 'block' }}>Nama Album</label>
                          <input
                            type="text"
                            placeholder="Contoh: Kegiatan HUT RI"
                            value={categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                            required
                            style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '6px' }}
                          />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2', background: '#f8fafc', padding: '16px', borderRadius: '10px', border: '1px solid #e2e8f0' }}>
                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                            <label style={{ fontWeight: '700', color: '#1e293b', margin: 0, display: 'flex', alignItems: 'center', gap: '6px' }}>
                              <FaExternalLinkAlt style={{ color: '#2563eb' }} /> Link Dokumentasi / Google Photos (Multi-Link)
                            </label>
                            <button
                              type="button"
                              onClick={handleAddCategoryExternalLink}
                              style={{
                                background: '#3b82f6', color: '#fff', border: 'none',
                                padding: '6px 14px', borderRadius: '6px', cursor: 'pointer',
                                fontSize: '0.85rem', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '6px'
                              }}
                            >
                              <FaPlus /> Tambah Link
                            </button>
                          </div>
                          
                          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                            {categoryExternalLinks.map((item, index) => (
                              <div key={index} style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                                <input
                                  type="text"
                                  placeholder="Nama/Label (e.g. Day 1, Google Photos)"
                                  value={item.label}
                                  onChange={(e) => handleUpdateCategoryExternalLink(index, 'label', e.target.value)}
                                  style={{ width: '180px', padding: '8px 12px', border: '1px solid #cbd5e1', borderRadius: '6px', background: '#fff' }}
                                />
                                <input
                                  type="url"
                                  placeholder="https://photos.app.goo.gl/..."
                                  value={item.url}
                                  onChange={(e) => handleUpdateCategoryExternalLink(index, 'url', e.target.value)}
                                  style={{ flex: 1, padding: '8px 12px', border: '1px solid #cbd5e1', borderRadius: '6px', background: '#fff' }}
                                />
                                {categoryExternalLinks.length > 1 && (
                                  <button
                                    type="button"
                                    onClick={() => handleRemoveCategoryExternalLink(index)}
                                    style={{
                                      background: '#fef2f2', color: '#ef4444', border: '1px solid #fca5a5',
                                      padding: '8px 10px', borderRadius: '6px', cursor: 'pointer', display: 'flex', alignItems: 'center'
                                    }}
                                    title="Hapus Link"
                                  >
                                    <FaTrash />
                                  </button>
                                )}
                              </div>
                            ))}
                          </div>
                          <small style={{ color: '#64748b', marginTop: '8px', display: 'block' }}>
                            Tips: Anda bisa menambahkan beberapa link seperti Day 1, Day 2, dan Day 3 untuk album ini.
                          </small>
                        </div>
                        <div className="form-group">
                          <label style={{ fontWeight: '600', marginBottom: '8px', display: 'block' }}>Kategori Album</label>
                          <select
                            value={selectedAlbumCategory}
                            onChange={(e) => setSelectedAlbumCategory(e.target.value)}
                            style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '6px' }}
                          >
                            <option value="">-- Pilih Kategori --</option>
                            <option value="Umum">Umum</option>
                            {albumCategories.map(cat => (
                              <option key={cat.id} value={cat.name}>{cat.name}</option>
                            ))}
                          </select>
                        </div>
                        <div className="form-group">
                          <label style={{ fontWeight: '600', marginBottom: '8px', display: 'block' }}>Tanggal Mulai</label>
                          <input
                            type="date"
                            value={categoryDate}
                            onChange={(e) => setCategoryDate(e.target.value)}
                            style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '6px' }}
                          />
                        </div>
                        <div className="form-group">
                          <label style={{ fontWeight: '600', marginBottom: '8px', display: 'block' }}>Tanggal Selesai</label>
                          <input
                            type="date"
                            value={categoryEndDate}
                            onChange={(e) => setCategoryEndDate(e.target.value)}
                            style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '6px' }}
                          />
                        </div>
                        <div className="form-group" style={{ gridColumn: 'span 2' }}>
                          <label style={{ fontWeight: '600', marginBottom: '8px', display: 'block' }}>Deskripsi</label>
                          <textarea
                            placeholder="Deskripsi singkat..."
                            value={categoryDescription}
                            onChange={(e) => setCategoryDescription(e.target.value)}
                            style={{ width: '100%', padding: '10px', border: '1px solid #ddd', borderRadius: '6px', minHeight: '80px' }}
                          />
                        </div>
                      </div>

                      {/* Cover Image Section */}
                      <div className="form-group" style={{ background: '#f9f9f9', padding: '20px', borderRadius: '8px', border: '1px dashed #ddd' }}>
                        <label style={{ fontWeight: '600', marginBottom: '12px', display: 'block' }}>Cover Image</label>
                        <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start' }}>
                          {categoryPreview ? (
                            <img src={categoryPreview} alt="Cover Preview" style={{ width: '150px', height: '100px', objectFit: 'cover', borderRadius: '6px', border: '1px solid #eee' }} />
                          ) : (
                            <div style={{ width: '150px', height: '100px', background: '#eee', borderRadius: '6px', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#999' }}>No Image</div>
                          )}
                          <div style={{ flex: 1 }}>
                            <input
                              type="file"
                              accept="image/*"
                              onChange={(e) => {
                                if (e.target.files && e.target.files[0]) {
                                  setCategoryFile(e.target.files[0]);
                                  setCategoryPreview(URL.createObjectURL(e.target.files[0]));
                                }
                              }}
                              style={{ width: '100%', padding: '8px', background: '#fff', border: '1px solid #ddd', borderRadius: '6px' }}
                            />
                            <small style={{ display: 'block', marginTop: '8px', color: '#666' }}>Upload gambar cover baru untuk mengganti yang lama.</small>
                          </div>
                        </div>
                      </div>

                      <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '24px', gap: '12px' }}>
                        <button
                          type="button"
                          onClick={() => {
                            setShowCategoryForm(false);
                            setActiveGalleryCategory(null);
                            resetCategoryForm();
                          }}
                          style={{ padding: '10px 20px', borderRadius: '6px', border: '1px solid #ddd', background: '#fff', cursor: 'pointer' }}
                        >
                          Batal
                        </button>
                        <button type="submit" disabled={uploading} className="save-button" style={{ padding: '10px 24px', borderRadius: '6px', background: '#1890ff', color: '#fff', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px' }}>
                          {uploading ? 'Menyimpan...' : <><FaSave /> Simpan Album</>}
                        </button>
                      </div>
                    </form>
                  </div>
                ) : (
                  /* --- GRID VIEW (List of Albums) --- */
                  <div className="gallery-grid-view">
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '24px' }}>
                      <h3 style={{ margin: 0, color: '#333' }}>Daftar Album Galeri</h3>
                      <div style={{ display: 'flex', gap: '12px' }}>
                        <button
                          onClick={() => {
                            resetCategoryForm();
                            setShowCategoryForm(true);
                            setIsEditingCategory(false);
                          }}
                          style={{
                            background: '#10b981', color: '#fff',
                            border: 'none', padding: '10px 20px', borderRadius: '8px',
                            cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600',
                            boxShadow: '0 2px 5px rgba(16, 185, 129, 0.2)'
                          }}
                        >
                          <FaPlus /> Buat Album Baru
                        </button>
                        <button
                          onClick={() => setShowAlbumCategoryModal(true)}
                          style={{
                            background: '#fff', color: '#555', border: '1px solid #d9d9d9',
                            padding: '10px 20px', borderRadius: '8px',
                            cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600'
                          }}
                        >
                          <FaList /> Kelola Kategori
                        </button>
                      </div>

                      {isGalleryOrderChanged && (
                        <button
                          onClick={handleSaveGalleryOrder}
                          disabled={uploading}
                          style={{
                            background: '#3b82f6', color: '#fff',
                            border: 'none', padding: '10px 20px', borderRadius: '8px',
                            cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontWeight: '600',
                            boxShadow: '0 2px 5px rgba(59, 130, 246, 0.2)',
                            opacity: uploading ? 0.7 : 1
                          }}
                        >
                          <FaSave /> {uploading ? 'Menyimpan...' : 'Simpan Urutan'}
                        </button>
                      )}
                    </div>

                    <div style={{ display: 'flex', gap: '15px', marginBottom: '20px', flexWrap: 'wrap' }}>
                      <div style={{ flex: '1 1 300px', position: 'relative' }}>
                        <FaSearch style={{ position: 'absolute', left: '12px', top: '50%', transform: 'translateY(-50%)', color: '#94a3b8' }} />
                        <input
                          type="text"
                          placeholder="Cari album..."
                          value={gallerySearchQuery}
                          onChange={(e) => setGallerySearchQuery(e.target.value)}
                          style={{
                            width: '100%', padding: '10px 10px 10px 35px', borderRadius: '8px',
                            border: '1px solid #e2e8f0', outline: 'none'
                          }}
                        />
                      </div>
                      <select
                        value={gallerySelectedCategory}
                        onChange={(e) => { setGallerySelectedCategory(e.target.value); setGalleryCurrentPage(1); }}
                        style={{ padding: '10px', borderRadius: '8px', border: '1px solid #e2e8f0', cursor: 'pointer' }}
                      >
                        <option value="Semua">Semua Kategori</option>
                        <option value="Umum">Umum</option>
                        {albumCategories.map(cat => (
                          <option key={cat.id} value={cat.name}>{cat.name}</option>
                        ))}
                      </select>
                      <select
                        value={gallerySelectedYear}
                        onChange={(e) => { setGallerySelectedYear(e.target.value); setGalleryCurrentPage(1); }}
                        style={{ padding: '10px', borderRadius: '8px', border: '1px solid #e2e8f0', cursor: 'pointer' }}
                      >
                        <option value="Semua Tahun">Semua Tahun</option>
                        {[...new Set(galleryCategories.map(cat => cat.date ? new Date(cat.date).getFullYear().toString() : null).filter(y => y))].sort((a, b) => b - a).map(year => (
                          <option key={year} value={year}>{year}</option>
                        ))}
                      </select>
                    </div>

                    {/* Visibility Filter Pills */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', flexWrap: 'wrap' }}>
                      <span style={{ fontSize: '0.85rem', color: '#64748b', fontWeight: '600' }}>Status:</span>
                      {[{ label: 'Semua', value: 'Semua' }, { label: '👁 Visible', value: 'Visible' }, { label: '🚫 Hidden', value: 'Hidden' }].map(opt => (
                        <button
                          key={opt.value}
                          onClick={() => { setGalleryVisibilityFilter(opt.value); setGalleryCurrentPage(1); }}
                          style={{
                            padding: '7px 16px',
                            borderRadius: '20px',
                            border: '1.5px solid',
                            borderColor: galleryVisibilityFilter === opt.value ? '#3b82f6' : '#e2e8f0',
                            background: galleryVisibilityFilter === opt.value ? '#eff6ff' : '#fff',
                            color: galleryVisibilityFilter === opt.value ? '#2563eb' : '#64748b',
                            cursor: 'pointer',
                            fontWeight: '600',
                            fontSize: '0.85rem',
                            transition: 'all 0.2s'
                          }}
                        >
                          {opt.label}
                        </button>
                      ))}
                    </div>

                    {/* Computed filtered + paginated list */}
                    {(() => {
                      const filteredGalleryCats = galleryCategories.filter(cat => {
                        const matchesSearch = cat.name.toLowerCase().includes(gallerySearchQuery.toLowerCase());
                        const catYear = cat.date ? new Date(cat.date).getFullYear().toString() : null;
                        const matchesYear = gallerySelectedYear === 'Semua Tahun' || catYear === gallerySelectedYear;
                        const matchesCategory = gallerySelectedCategory === 'Semua' ||
                          (gallerySelectedCategory === 'Umum' && (!cat.category || cat.category === 'Umum')) ||
                          cat.category === gallerySelectedCategory;
                        const matchesVisibility =
                          galleryVisibilityFilter === 'Semua' ||
                          (galleryVisibilityFilter === 'Visible' && cat.isVisible !== false) ||
                          (galleryVisibilityFilter === 'Hidden' && cat.isVisible === false);
                        return matchesSearch && matchesYear && matchesCategory && matchesVisibility;
                      });

                      const usePagination = filteredGalleryCats.length > 50;
                      const totalPages = usePagination ? Math.ceil(filteredGalleryCats.length / GALLERY_ITEMS_PER_PAGE) : 1;
                      const safeCurrentPage = Math.min(galleryCurrentPage, totalPages || 1);
                      const paginatedCats = usePagination
                        ? filteredGalleryCats.slice((safeCurrentPage - 1) * GALLERY_ITEMS_PER_PAGE, safeCurrentPage * GALLERY_ITEMS_PER_PAGE)
                        : filteredGalleryCats;
                      const startItem = usePagination ? (safeCurrentPage - 1) * GALLERY_ITEMS_PER_PAGE + 1 : 1;
                      const endItem = usePagination ? Math.min(safeCurrentPage * GALLERY_ITEMS_PER_PAGE, filteredGalleryCats.length) : filteredGalleryCats.length;

                      return (
                        <>
                          {/* Count info */}
                          {filteredGalleryCats.length > 0 && (
                            <div style={{ fontSize: '0.85rem', color: '#64748b', marginBottom: '16px', marginTop: '24px', padding: '0 10px' }}>
                              Menampilkan <strong>{usePagination ? `${startItem}–${endItem}` : filteredGalleryCats.length}</strong> dari <strong>{filteredGalleryCats.length}</strong> album
                              {galleryVisibilityFilter !== 'Semua' && <span style={{ marginLeft: '8px', padding: '2px 8px', background: galleryVisibilityFilter === 'Visible' ? '#dcfce7' : '#fee2e2', borderRadius: '12px', color: galleryVisibilityFilter === 'Visible' ? '#166534' : '#991b1b', fontSize: '0.8rem', fontWeight: '700' }}>{galleryVisibilityFilter}</span>}
                            </div>
                          )}

                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '30px', padding: '10px' }}>
                            {paginatedCats.map((cat, index) => (
                        <div
                          key={cat.id}
                          draggable
                          onDragStart={(e) => handleGalleryDragStart(e, index)}
                          onDragOver={(e) => handleGalleryDragOver(e, index)}
                          onDragEnd={handleGalleryDragEnd}
                          style={{
                            background: '#fff',
                            borderRadius: '16px',
                            border: '1px solid #f0f0f0',
                            overflow: 'hidden',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.03)',
                            transition: 'all 0.3s ease',
                            display: 'flex',
                            flexDirection: 'column',
                            position: 'relative',
                            cursor: 'grab'
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'translateY(-5px)';
                            e.currentTarget.style.boxShadow = '0 12px 30px rgba(0,0,0,0.08)';
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'translateY(0)';
                            e.currentTarget.style.boxShadow = '0 4px 20px rgba(0,0,0,0.03)';
                          }}
                        >
                          {/* Card Image */}
                          <div style={{ height: '180px', overflow: 'hidden', position: 'relative', background: '#f8f9fa' }}>
                            {cat.imageUrl ? (
                              <img src={cat.imageUrl} alt={cat.name} style={{ width: '100%', height: '100%', objectFit: 'cover', transition: 'transform 0.5s' }} />
                            ) : (
                              <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#cbd5e1' }}>
                                <FaImages style={{ fontSize: '3rem' }} />
                              </div>
                            )}
                            {/* Status Badge */}
                            <div style={{ position: 'absolute', top: '12px', right: '12px' }}>
                              <div style={{
                                background: 'rgba(255,255,255,0.95)',
                                padding: '6px 12px',
                                borderRadius: '30px',
                                fontSize: '0.75rem',
                                fontWeight: '700',
                                color: cat.isVisible ? '#10b981' : '#ef4444',
                                boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                display: 'flex', alignItems: 'center', gap: '6px',
                                backdropFilter: 'blur(4px)'
                              }}>
                                {cat.isVisible ? <FaEye style={{ fontSize: '0.9em' }} /> : <FaEyeSlash style={{ fontSize: '0.9em' }} />}
                                {cat.isVisible ? 'VISIBLE' : 'HIDDEN'}
                              </div>
                            </div>
                          </div>

                          {/* Card Content */}
                          <div style={{ padding: '24px', flex: 1, display: 'flex', flexDirection: 'column' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', fontSize: '0.85rem', color: '#64748b', marginBottom: '8px', width: '100%' }}>
                              <FaCalendarAlt />
                              <span>{cat.date ? new Date(cat.date).toLocaleDateString('id-ID', { day: 'numeric', month: 'long', year: 'numeric' }) : '-'}</span>
                            </div>

                            {/* Category Badge */}
                            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '8px' }}>
                              <span style={{
                                padding: '4px 10px',
                                background: '#f1f5f9',
                                color: '#64748b',
                                borderRadius: '12px',
                                fontSize: '0.75rem',
                                fontWeight: '700',
                                textTransform: 'uppercase'
                              }}>
                                {cat.category || 'Umum'}
                              </span>
                            </div>

                            <h4 style={{ margin: '0 0 8px 0', fontSize: '1.25rem', color: '#1e293b', fontWeight: '700', lineHeight: '1.4' }}>{cat.name}</h4>

                            {/* External Link Chip */}
                            {cat.externalLink && (
                              <div style={{ marginBottom: '16px' }}>
                                <a
                                  href={cat.externalLink}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    display: 'inline-flex', alignItems: 'center', gap: '6px',
                                    padding: '4px 10px', background: '#eff6ff',
                                    color: '#2563eb', borderRadius: '6px',
                                    fontSize: '0.75rem', fontWeight: '600', textDecoration: 'none'
                                  }}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <FaExternalLinkAlt style={{ fontSize: '0.8em' }} /> Google Photos
                                </a>
                              </div>
                            )}

                            <p style={{ margin: '0 0 20px 0', fontSize: '0.9rem', color: '#64748b', lineHeight: '1.6', flex: 1, display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>
                              {cat.description || <span style={{ fontStyle: 'italic', opacity: 0.7 }}>Tidak ada deskripsi album.</span>}
                            </p>

                            {/* Action Bar */}
                            <div style={{ display: 'flex', gap: '8px', borderTop: '1px solid #f1f5f9', paddingTop: '16px' }}>
                              <button
                                onClick={() => {
                                  setActiveGalleryCategory(cat.name);
                                  handleEditCategory(cat);
                                  setShowCategoryForm(true);
                                }}
                                title="Edit Album"
                                style={{ flex: 1, background: '#fff', border: '1px solid #e2e8f0', padding: '10px', borderRadius: '8px', color: '#334155', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s', fontWeight: '600', fontSize: '0.9rem' }}
                                onMouseEnter={(e) => { e.currentTarget.style.background = '#f8fafc'; e.currentTarget.style.borderColor = '#cbd5e1'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                              >
                                <FaPencilAlt style={{ marginRight: '6px' }} /> Edit
                              </button>

                              <button
                                onClick={() => handleToggleCategoryVisibility(cat)}
                                title={cat.isVisible ? "Sembunyikan Album" : "Tampilkan Album"}
                                style={{ width: '42px', height: '42px', background: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px', color: cat.isVisible ? '#f59e0b' : '#10b981', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s', fontSize: '1.1rem' }}
                                onMouseEnter={(e) => { e.currentTarget.style.background = '#fffbeb'; e.currentTarget.style.borderColor = '#fcd34d'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                              >
                                {cat.isVisible ? <FaEyeSlash /> : <FaEye />}
                              </button>

                              <button
                                onClick={() => handleDeleteCategory(cat.id)}
                                title="Hapus Album"
                                style={{ width: '42px', height: '42px', background: '#fff', border: '1px solid #e2e8f0', borderRadius: '8px', color: '#ef4444', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'all 0.2s', fontSize: '1rem' }}
                                onMouseEnter={(e) => { e.currentTarget.style.background = '#fef2f2'; e.currentTarget.style.borderColor = '#fca5a5'; }}
                                onMouseLeave={(e) => { e.currentTarget.style.background = '#fff'; e.currentTarget.style.borderColor = '#e2e8f0'; }}
                              >
                                <FaTrash />
                              </button>
                            </div>
                          </div>
                        </div>
                            ))}

                            {filteredGalleryCats.length === 0 && (
                              <div style={{ gridColumn: '1 / -1', textAlign: 'center', padding: '60px', background: '#f9f9f9', borderRadius: '12px', color: '#888' }}>
                                <FaImages style={{ fontSize: '3rem', marginBottom: '16px', opacity: 0.3 }} />
                                <p>{galleryCategories.length === 0 ? 'Belum ada album galeri. Silakan buat album baru.' : 'Tidak ada album yang sesuai filter.'}</p>
                              </div>
                            )}
                          </div>

                          {/* Pagination Controls — hanya muncul jika >50 album */}
                          {usePagination && (
                            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px', marginTop: '32px', flexWrap: 'wrap' }}>
                              <button
                                onClick={() => setGalleryCurrentPage(p => Math.max(1, p - 1))}
                                disabled={safeCurrentPage === 1}
                                style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e2e8f0', background: safeCurrentPage === 1 ? '#f1f5f9' : '#fff', cursor: safeCurrentPage === 1 ? 'not-allowed' : 'pointer', color: safeCurrentPage === 1 ? '#94a3b8' : '#334155', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '6px' }}
                              >
                                <FaChevronLeft style={{ fontSize: '0.75rem' }} /> Prev
                              </button>

                              {Array.from({ length: totalPages }, (_, i) => i + 1)
                                .filter(page => page === 1 || page === totalPages || Math.abs(page - safeCurrentPage) <= 2)
                                .reduce((acc, page, idx, arr) => {
                                  if (idx > 0 && page - arr[idx - 1] > 1) acc.push('...');
                                  acc.push(page);
                                  return acc;
                                }, [])
                                .map((item, idx) =>
                                  item === '...' ? (
                                    <span key={`ellipsis-${idx}`} style={{ padding: '8px 4px', color: '#94a3b8' }}>...</span>
                                  ) : (
                                    <button
                                      key={item}
                                      onClick={() => setGalleryCurrentPage(item)}
                                      style={{ width: '38px', height: '38px', borderRadius: '8px', border: '1.5px solid', borderColor: safeCurrentPage === item ? '#3b82f6' : '#e2e8f0', background: safeCurrentPage === item ? '#3b82f6' : '#fff', color: safeCurrentPage === item ? '#fff' : '#334155', cursor: 'pointer', fontWeight: '700', fontSize: '0.9rem' }}
                                    >
                                      {item}
                                    </button>
                                  )
                                )
                              }

                              <button
                                onClick={() => setGalleryCurrentPage(p => Math.min(totalPages, p + 1))}
                                disabled={safeCurrentPage === totalPages}
                                style={{ padding: '8px 16px', borderRadius: '8px', border: '1px solid #e2e8f0', background: safeCurrentPage === totalPages ? '#f1f5f9' : '#fff', cursor: safeCurrentPage === totalPages ? 'not-allowed' : 'pointer', color: safeCurrentPage === totalPages ? '#94a3b8' : '#334155', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '6px' }}
                              >
                                Next <FaChevronRight style={{ fontSize: '0.75rem' }} />
                              </button>
                            </div>
                          )}
                        </>
                      );
                    })()}
                  </div>
                )}

                {/* Modal Kelola Kategori Album (NEW) */}
                {showAlbumCategoryModal && (
                  <div className="admin-modal-overlay">
                    <div className="admin-modal-content" style={{ maxWidth: '500px' }}>
                      <div className="admin-modal-header">
                        <h3>Kelola Kategori Album</h3>
                        <button type="button" className="admin-modal-close" onClick={() => {
                          setShowAlbumCategoryModal(false);
                          setIsEditingAlbumCategory(false);
                          setCurrentAlbumCategory({ id: '', name: '' });
                        }}>&times;</button>
                      </div>
                      <div className="admin-modal-body">
                        <form onSubmit={handleAlbumCategorySubmit} className="compact-form" style={{ marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #eee' }}>
                          <div className="form-group">
                            <label htmlFor="album-category-name">Nama Kategori</label>
                            <div style={{ display: 'flex', gap: '8px' }}>
                              <input
                                type="text"
                                id="album-category-name"
                                placeholder="Contoh: Kegiatan Sekolah"
                                value={currentAlbumCategory.name}
                                onChange={(e) => setCurrentAlbumCategory({ ...currentAlbumCategory, name: e.target.value })}
                                required
                                style={{ flex: 1 }}
                              />
                              <button type="submit" disabled={uploading} className="save-button small" style={{ whiteSpace: 'nowrap' }}>
                                {uploading ? '...' : (isEditingAlbumCategory ? 'Update' : 'Tambah')}
                              </button>
                            </div>
                          </div>
                          {isEditingAlbumCategory && (
                            <div style={{ textAlign: 'right' }}>
                              <button type="button" onClick={() => {
                                setIsEditingAlbumCategory(false);
                                setCurrentAlbumCategory({ id: '', name: '' });
                              }} className="cancel-button small" style={{ marginTop: '5px' }}>Batal Edit</button>
                            </div>
                          )}
                        </form>

                        <div className="category-list">
                          <h4 style={{ fontSize: '1rem', marginBottom: '10px' }}>Daftar Kategori</h4>
                          {albumCategories.length > 0 ? (
                            <ul style={{ listStyle: 'none', padding: 0 }}>
                              {albumCategories.map(cat => (
                                <li key={cat.id} className="category-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', borderBottom: '1px solid #f0f0f0' }}>
                                  <span style={{ fontWeight: '500' }}>{cat.name}</span>
                                  <div className="actions" style={{ display: 'flex', gap: '8px' }}>
                                    <button className="icon-btn edit" onClick={() => {
                                      setCurrentAlbumCategory({ id: cat.id, name: cat.name });
                                      setIsEditingAlbumCategory(true);
                                    }} title="Edit" style={{ background: '#e6f7ff', color: '#1890ff', border: 'none', borderRadius: '4px', padding: '6px' }}><FaPencilAlt /></button>
                                    <button className="icon-btn delete" onClick={() => handleDeleteAlbumCategory(cat.id)} title="Hapus" style={{ background: '#fff1f0', color: '#ff4d4f', border: 'none', borderRadius: '4px', padding: '6px' }}><FaTrash /></button>
                                  </div>
                                </li>
                              ))}
                            </ul>
                          ) : (
                            <p className="empty-text" style={{ color: '#999', fontStyle: 'italic', textAlign: 'center' }}>Belum ada kategori album.</p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              </div>
            </div>
          )
        }

        {
          activeTab === 'berita' && (
            <div className="admin-section">
              <div className='gallery-main-content' style={{ width: '100%', padding: '0' }}>
                <div className="table-header">
                  <h2>Daftar Berita</h2>
                  <div className="search-controls">
                    <div className="search-wrapper">
                      <FaSearch className="search-icon" />
                      <input
                        type="text"
                        placeholder="Cari judul berita..."
                        className="modern-search-input"
                        value={beritaSearchTerm}
                        onChange={(e) => setBeritaSearchTerm(e.target.value)}
                      />
                      {beritaSearchTerm && (
                        <button className="search-clear-btn" onClick={() => setBeritaSearchTerm('')}>
                          &times;
                        </button>
                      )}
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: '10px' }}>
                    <button className="action-btn secondary" onClick={() => setShowBeritaCategoryModal(true)} style={{ background: '#fff', border: '1px solid #d9d9d9', color: '#555', display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 16px', borderRadius: '4px', cursor: 'pointer' }}>
                      <FaList /> Kelola Kategori
                    </button>
                    <button className="add-button" onClick={handleAddNewBerita}><FaPlus /> Tambah Berita</button>
                  </div>
                </div>

                <div className="modern-table-container">
                  <table className="modern-table">
                    <thead>
                      <tr>
                        <th width="80">Gambar</th>
                        <th>Judul</th>
                        <th>Tanggal</th>
                        <th>Kategori</th>
                        <th>Status</th>
                        <th>Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentBeritaItems.map(berita => (
                        <tr key={berita.id}>
                          <td>
                            <img src={berita.image || 'https://via.placeholder.com/60'} alt="Thumb" style={{ width: '60px', height: '40px', objectFit: 'cover', borderRadius: '4px' }} />
                          </td>
                          <td style={{ fontWeight: 500 }}>{berita.title}</td>
                          <td>{new Date(berita.date).toLocaleDateString('id-ID')}</td>
                          <td><span className="resource-badge info">{berita.category || 'Umum'}</span></td>
                          <td>
                            <span className={`resource-badge ${berita.status === 'published' ? 'success' : 'warning'}`}>
                              {berita.status === 'published' ? 'Published' : 'Draft'}
                            </span>
                          </td>
                          <td className='actions'>
                            <a href={`/berita/${berita.slug}?preview=true`} target="_blank" rel="noopener noreferrer" className="action-btn view" title="Pratinjau"><FaExternalLinkAlt /></a>
                            <button className="action-btn toggle" onClick={() => handleToggleBeritaStatus(berita)} title={berita.status === 'published' ? 'Jadikan Draft' : 'Publikasikan'}>
                              {berita.status === 'published' ? <FaToggleOff /> : <FaToggleOn />}
                            </button>
                            <button className="action-btn edit" onClick={() => handleEditBerita(berita)} title="Edit"><FaPencilAlt /></button>
                            <button className="action-btn delete" onClick={() => handleDeleteBerita(berita.id, berita.public_id)} title="Hapus"><FaTrash /></button>
                          </td>
                        </tr>
                      ))}
                      {currentBeritaItems.length === 0 && (
                        <tr>
                          <td colSpan="6" style={{ textAlign: 'center', padding: '30px', color: '#888' }}>
                            Tidak ada berita ditemukan.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                {pageNumbersBerita.length > 1 && (
                  <div className="pagination-container">
                    <ul className="modern-pagination">
                      {pageNumbersBerita.map(number => (
                        <li key={number} className={beritaCurrentPage === number ? 'active' : ''}>
                          <button onClick={() => paginateBerita(number)}>{number}</button>
                        </li>
                      ))}
                    </ul>

                    {/* Modal Kelola Kategori Berita */}
                    {showBeritaCategoryModal && (
                      <div className="admin-modal-overlay">
                        <div className="admin-modal-content" style={{ maxWidth: '500px' }}>
                          <div className="admin-modal-header">
                            <h3>Kelola Kategori Berita</h3>
                            <button type="button" className="admin-modal-close" onClick={() => setShowBeritaCategoryModal(false)}>&times;</button>
                          </div>
                          <div className="admin-modal-body">
                            <form onSubmit={handleBeritaCategorySubmit} className="compact-form" style={{ marginBottom: '20px', paddingBottom: '20px', borderBottom: '1px solid #eee' }}>
                              <div className="form-group">
                                <label htmlFor="berita-category-name">Nama dan Warna Kategori</label>
                                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                                  <input type="color" value={beritaCategoryColor} onChange={(e) => setBeritaCategoryColor(e.target.value)} style={{ width: '40px', height: '40px', padding: '0', border: 'none', borderRadius: '4px', cursor: 'pointer' }} title="Pilih Warna Kategori" />
                                  <input type="text" id="berita-category-name" placeholder="Contoh: Prestasi Siswa" value={beritaCategoryName} onChange={(e) => setBeritaCategoryName(e.target.value)} required style={{ flex: 1 }} />
                                  <button type="submit" disabled={uploading} className="save-button small" style={{ whiteSpace: 'nowrap' }}>{uploading ? '...' : (isEditingBeritaCategory ? 'Update' : 'Tambah')}</button>
                                </div>
                              </div>
                              {isEditingBeritaCategory && (
                                <div style={{ textAlign: 'right' }}>
                                  <button type="button" onClick={resetBeritaCategoryForm} className="cancel-button small" style={{ marginTop: '5px' }}>Batal Edit</button>
                                </div>
                              )}
                            </form>

                            <div className="category-list">
                              <h4 style={{ fontSize: '1rem', marginBottom: '10px' }}>Daftar Kategori</h4>
                              {beritaCategories.length > 0 ? (
                                <ul style={{ listStyle: 'none', padding: 0 }}>
                                  {beritaCategories.map(cat => (
                                    <li key={cat.id} className="category-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px', borderBottom: '1px solid #f0f0f0' }}>
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                        <div style={{ width: '15px', height: '15px', borderRadius: '50%', backgroundColor: cat.color || '#3498db' }}></div>
                                        <span style={{ fontWeight: '500' }}>{cat.name}</span>
                                      </div>
                                      <div className="actions" style={{ display: 'flex', gap: '8px' }}>
                                        <button className="icon-btn edit" onClick={() => handleEditBeritaCategory(cat)} title="Edit" style={{ background: '#e6f7ff', color: '#1890ff', border: 'none', borderRadius: '4px', padding: '6px' }}><FaPencilAlt /></button>
                                        <button className="icon-btn delete" onClick={() => handleDeleteBeritaCategory(cat.id)} title="Hapus" style={{ background: '#fff1f0', color: '#ff4d4f', border: 'none', borderRadius: '4px', padding: '6px' }}><FaTrash /></button>
                                      </div>
                                    </li>
                                  ))}
                                </ul>
                              ) : (
                                <p className="empty-text" style={{ color: '#999', fontStyle: 'italic', textAlign: 'center' }}>Belum ada kategori.</p>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                    )}
                  </div>
                )}

              </div>
            </div>
          )}



        {
          showBeritaForm && (
            <div className="admin-modal-overlay">
              <div className="admin-modal-content wide">
                <div className="admin-modal-header">
                  <h3>{isEditingBerita ? 'Edit Berita' : 'Tambah Berita Baru'}</h3>
                  <button type="button" className="admin-modal-close" onClick={() => setShowBeritaForm(false)}>&times;</button>
                </div>

                <form onSubmit={handleBeritaSubmit} className="modern-form">
                  <div className="admin-modal-body news-layout">
                    <div className="news-main-column">
                      <div className="form-group">
                        <label htmlFor="berita-title">Judul Berita</label>
                        <input
                          type="text"
                          id="berita-title"
                          value={currentBerita.title}
                          onChange={(e) => setCurrentBerita({ ...currentBerita, title: e.target.value })}
                          required
                          autoFocus
                          spellCheck={false}
                          style={{
                            fontSize: '1.1rem',
                            fontWeight: '800',
                            color: currentBerita.titleColor || '#0f172a',
                            transition: 'color 0.2s ease'
                          }}
                        />
                      </div>

                      <div className="form-group">
                        <label htmlFor="berita-excerpt">Kutipan Singkat (Excerpt)</label>
                        <textarea id="berita-excerpt" rows="2" value={currentBerita.excerpt} onChange={(e) => setCurrentBerita({ ...currentBerita, excerpt: e.target.value })} required spellCheck={false}></textarea>
                        <small className="form-text text-muted">Akan ditampilkan di kartu preview berita.</small>
                      </div>

                      <div className="form-group" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                        <label>Isi Berita Lengkap</label>
                        <ReactQuill
                          theme="snow"
                          value={currentBerita.content}
                          onChange={(content) => setCurrentBerita({ ...currentBerita, content: content })}
                          spellCheck={false}
                          modules={{
                            toolbar: [
                              [{ 'header': [1, 2, 3, 4, false] }],
                              [{ 'lineheight': ['1.0', '1.25', '1.5', '1.75', '2.0'] }],
                              [
                                { 
                                  'color': [
                                    false, '#000000', '#0f172a', '#1e293b', '#475569', '#64748b', '#ffffff',
                                    '#dc2626', '#ef4444', '#ea580c', '#d97706', '#16a34a', '#2563eb', '#4338ca', '#7c3aed'
                                  ] 
                                }, 
                                { 
                                  'background': [
                                    false, '#ffffff', '#fef08a', '#bbf7d0', '#bfdbfe', '#ddd6fe', '#fecdd3', '#ffedd5', '#e2e8f0', '#f1f5f9'
                                  ] 
                                }
                              ],
                              ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                              [{ 'align': [] }],
                              [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                              ['link', 'image'],
                              ['clean']
                            ]
                          }}
                          formats={[
                            'header', 'lineheight',
                            'color', 'background',
                            'bold', 'italic', 'underline', 'strike', 'blockquote',
                            'align',
                            'list', 'bullet', 'indent',
                            'link', 'image'
                          ]}
                          style={{ height: '380px', marginBottom: '50px', flex: 1 }}
                        />

                        {/* Floating Image Control Toolbar */}
                        {selectedEditorImage && (
                          <div
                            className="image-floating-toolbar"
                            style={{
                              position: 'absolute',
                              top: `${imageToolbarPos.top}px`,
                              left: `${imageToolbarPos.left}px`,
                              zIndex: 99999,
                              background: '#0f172a',
                              color: '#fff',
                              padding: '6px 14px',
                              borderRadius: '30px',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '8px',
                              boxShadow: '0 10px 25px rgba(0,0,0,0.35)',
                              fontSize: '0.75rem',
                              fontWeight: '700'
                            }}
                            onClick={(e) => e.stopPropagation()}
                            onMouseDown={(e) => e.preventDefault()}
                          >
                            <span style={{ color: '#94a3b8' }}>Ukuran:</span>
                            {['25%', '50%', '75%', '100%'].map(size => (
                              <button
                                key={size}
                                type="button"
                                onMouseDown={(e) => e.preventDefault()}
                                onClick={() => {
                                  selectedEditorImage.style.width = size;
                                  selectedEditorImage.style.height = 'auto';
                                }}
                                style={{
                                  background: selectedEditorImage.style.width === size ? '#2563eb' : 'rgba(255,255,255,0.15)',
                                  color: '#fff',
                                  border: 'none',
                                  padding: '3px 8px',
                                  borderRadius: '12px',
                                  cursor: 'pointer',
                                  fontSize: '0.75rem',
                                  fontWeight: '700'
                                }}
                              >
                                {size}
                              </button>
                            ))}
                            <span style={{ color: '#94a3b8', marginLeft: '4px' }}>Posisi:</span>
                            <button
                              type="button"
                              title="Rata Kiri (Wrap Text)"
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => {
                                selectedEditorImage.style.float = 'left';
                                selectedEditorImage.style.display = 'inline';
                                selectedEditorImage.style.margin = '6px 20px 16px 0';
                              }}
                              style={{ background: 'rgba(255,255,255,0.15)', color: '#fff', border: 'none', padding: '3px 8px', borderRadius: '12px', cursor: 'pointer' }}
                            >
                              ⬅️ Kiri
                            </button>
                            <button
                              type="button"
                              title="Rata Tengah"
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => {
                                selectedEditorImage.style.float = 'none';
                                selectedEditorImage.style.display = 'block';
                                selectedEditorImage.style.margin = '16px auto';
                              }}
                              style={{ background: 'rgba(255,255,255,0.15)', color: '#fff', border: 'none', padding: '3px 8px', borderRadius: '12px', cursor: 'pointer' }}
                            >
                              ⏹️ Tengah
                            </button>
                            <button
                              type="button"
                              title="Rata Kanan (Wrap Text)"
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => {
                                selectedEditorImage.style.float = 'right';
                                selectedEditorImage.style.display = 'inline';
                                selectedEditorImage.style.margin = '6px 0 16px 20px';
                              }}
                              style={{ background: 'rgba(255,255,255,0.15)', color: '#fff', border: 'none', padding: '3px 8px', borderRadius: '12px', cursor: 'pointer' }}
                            >
                              ➡️ Kanan
                            </button>
                            <button
                              type="button"
                              title="Hapus Gambar"
                              onMouseDown={(e) => e.preventDefault()}
                              onClick={() => {
                                selectedEditorImage.remove();
                                setSelectedEditorImage(null);
                              }}
                              style={{ background: '#ef4444', color: '#fff', border: 'none', padding: '3px 8px', borderRadius: '12px', cursor: 'pointer', marginLeft: '4px' }}
                            >
                              🗑️
                            </button>
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="news-sidebar-column">
                      <div className="sidebar-panel">
                        <h4>Publikasi</h4>
                        <div className="form-group">
                          <label htmlFor="berita-status">Status</label>
                          <select id="berita-status" value={currentBerita.status || 'draft'} onChange={(e) => setCurrentBerita({ ...currentBerita, status: e.target.value })}>
                            <option value="draft">Draft</option>
                            <option value="published">Published</option>
                          </select>
                        </div>
                        <div className="form-group">
                          <label htmlFor="berita-date">Tanggal</label>
                          <input
                            type="date"
                            id="berita-date"
                            value={currentBerita.date || ''}
                            onChange={(e) => setCurrentBerita({ ...currentBerita, date: e.target.value })}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="berita-category">Kategori</label>
                          <select id="berita-category" value={currentBerita.category || ''} onChange={(e) => setCurrentBerita({ ...currentBerita, category: e.target.value })} required>
                            <option value="" disabled>Pilih Kategori</option>
                            {beritaCategories.map(cat => (
                              <option key={cat.id} value={cat.name}>{cat.name}</option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="sidebar-panel">
                        <h4>Tampilan</h4>
                        <div className="form-group">
                          <label>Perataan Judul</label>
                          <div className="alignment-options small">
                            {['left', 'center', 'justify'].map(align => (
                              <label key={align} className={`radio-label ${currentBerita.titleAlignment === align ? 'selected' : ''}`} title={align}>
                                <input type="radio" name="titleAlignment" value={align} checked={currentBerita.titleAlignment === align} onChange={(e) => setCurrentBerita({ ...currentBerita, titleAlignment: e.target.value })} />
                                <span style={{ textTransform: 'capitalize' }}>{align}</span>
                              </label>
                            ))}
                          </div>
                        </div>
                        <div className="form-group" style={{ marginTop: '14px' }}>
                          <label style={{ fontWeight: '600', marginBottom: '6px', display: 'block' }}>Warna Judul Berita</label>
                          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <input
                              type="color"
                              value={currentBerita.titleColor || '#2563eb'}
                              onChange={(e) => setCurrentBerita({ ...currentBerita, titleColor: e.target.value })}
                              style={{ width: '38px', height: '38px', padding: 0, border: 'none', borderRadius: '8px', cursor: 'pointer', background: 'transparent' }}
                            />
                            <input
                              type="text"
                              value={currentBerita.titleColor || '#2563eb'}
                              onChange={(e) => setCurrentBerita({ ...currentBerita, titleColor: e.target.value })}
                              placeholder="#2563eb"
                              style={{ flex: 1, padding: '6px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontSize: '0.85rem' }}
                            />
                          </div>
                          {/* Color Presets */}
                          <div style={{ display: 'flex', gap: '6px', marginTop: '8px', flexWrap: 'wrap' }}>
                            {[
                              { name: 'Biru Utama', color: '#2563eb' },
                              { name: 'Gelap Slate', color: '#0f172a' },
                              { name: 'Indigo Deep', color: '#4338ca' },
                              { name: 'Hijau Emerald', color: '#059669' },
                              { name: 'Merah Kebangsaan', color: '#dc2626' },
                              { name: 'Ungu Elegant', color: '#7c3aed' }
                            ].map((preset) => (
                              <button
                                key={preset.color}
                                type="button"
                                onClick={() => setCurrentBerita({ ...currentBerita, titleColor: preset.color })}
                                title={preset.name}
                                style={{
                                  width: '24px',
                                  height: '24px',
                                  borderRadius: '50%',
                                  background: preset.color,
                                  border: (currentBerita.titleColor || '#2563eb') === preset.color ? '2px solid #000' : '1px solid #cbd5e1',
                                  cursor: 'pointer',
                                  transition: 'transform 0.15s ease'
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.15)'}
                                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                              />
                            ))}
                          </div>
                          {/* Live Preview Box */}
                          <div style={{
                            marginTop: '10px',
                            padding: '10px 14px',
                            background: '#f8fafc',
                            borderRadius: '8px',
                            border: '1px solid #e2e8f0',
                            fontSize: '0.875rem',
                            fontWeight: '800',
                            color: currentBerita.titleColor || '#2563eb',
                            textAlign: currentBerita.titleAlignment || 'left',
                            transition: 'all 0.2s ease',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap'
                          }}>
                            Live Preview: {currentBerita.title || 'Judul Berita'}
                          </div>
                        </div>
                        <div className="form-group">
                          <label htmlFor="berita-gallery">Album Galeri</label>
                          <select id="berita-gallery" value={currentBerita.linkedGallery || ''} onChange={(e) => setCurrentBerita({ ...currentBerita, linkedGallery: e.target.value })}>
                            <option value="">-- Tidak ada --</option>
                            {galleryCategories.map(cat => (
                              <option key={cat.id} value={cat.slug}>{cat.name}</option>
                            ))}
                          </select>
                        </div>
                      </div>

                      <div className="sidebar-panel">
                        <h4>Media Unggulan</h4>
                        <div className="form-group">
                          <label className="sub-label">Gambar Utama</label>
                          <div className="upload-options vertical">


                            <label htmlFor="berita-file-crop" className="file-upload-label small">Upload & Potong (16:9)</label>
                            <input type="file" id="berita-file-crop" onChange={(e) => handleFileChangeWithCrop(e, 'berita', 16 / 9)} accept="image/*" style={{ display: 'none' }} />

                            <label htmlFor="berita-file-full" className="file-upload-label small" style={{ marginLeft: '5px' }}>Upload Full (Asli)</label>
                            <input type="file" id="berita-file-full" onChange={(e) => handleFullImageUpload(e, 'berita')} accept="image/*" style={{ display: 'none' }} />
                          </div>
                          {(beritaPreview || (isEditingBerita && currentBerita.image)) && (
                            <div className="image-preview-container compact" style={{ marginTop: '10px' }}>
                              <img src={beritaPreview || currentBerita.image} alt="Preview" className="image-preview" />
                            </div>
                          )}
                        </div>

                        <div className="form-group">
                          <label className="sub-label">Video / Social</label>
                          <div className="input-group-compact">
                            <input type="url" placeholder="YouTube URL" value={currentBerita.videoUrl} onChange={(e) => setCurrentBerita({ ...currentBerita, videoUrl: e.target.value })} style={{ fontSize: '0.85rem' }} />
                            <button type="button" onClick={() => fetchThumbnailFromUrl(currentBerita.videoUrl)} disabled={uploading} title="Fetch Thumbnail"><FaImages /></button>
                          </div>
                          <div className="input-group-compact" style={{ marginTop: '5px' }}>
                            <input type="url" placeholder="Instagram URL" value={currentBerita.instagramLink} onChange={(e) => setCurrentBerita({ ...currentBerita, instagramLink: e.target.value })} style={{ fontSize: '0.85rem' }} />
                            <button type="button" onClick={() => fetchThumbnailFromUrl(currentBerita.instagramLink)} disabled={uploading} title="Fetch Thumbnail"><FaImages /></button>
                          </div>
                          <div className="input-group-compact" style={{ marginTop: '5px' }}>
                            <input type="url" placeholder="TikTok URL" value={currentBerita.tiktokLink} onChange={(e) => setCurrentBerita({ ...currentBerita, tiktokLink: e.target.value })} style={{ fontSize: '0.85rem' }} />
                            <button type="button" onClick={() => fetchThumbnailFromUrl(currentBerita.tiktokLink)} disabled={uploading} title="Fetch Thumbnail"><FaImages /></button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="admin-modal-footer">
                    <button type="button" className="cancel-button" onClick={() => setShowBeritaForm(false)}>Batal</button>
                    <button type="submit" disabled={uploading} className="save-button">{uploading ? 'Menyimpan...' : 'Simpan Berita'}</button>
                  </div>
                </form>
              </div>
            </div >
          )
        }


        {
          activeTab === 'ruang-publik' && (
            <div className="admin-section">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2>Kelola Ruang Publik & Fasilitas Umum</h2>
                <button className="add-button" onClick={handleAddNewPublicFacility}>
                  <FaPlus /> Tambah Ruang Publik
                </button>
              </div>

              {showPublicFacilityForm && (
                <div className="admin-modal-overlay">
                  <div className="admin-modal-content">
                    <div className="admin-modal-header">
                      <h3>{isEditingPublicFacility ? 'Edit Ruang Publik' : 'Tambah Ruang Publik Baru'}</h3>
                      <button type="button" className="admin-modal-close" onClick={() => setShowPublicFacilityForm(false)}>&times;</button>
                    </div>

                    <form onSubmit={handlePublicFacilitySubmit} className="modern-form">
                      <div className="admin-modal-body">
                        <div className="form-group">
                          <label htmlFor="public-facility-title">Nama Ruang/Fasilitas</label>
                          <input type="text" id="public-facility-title" value={currentPublicFacility.title} onChange={(e) => setCurrentPublicFacility({ ...currentPublicFacility, title: e.target.value })} required autoFocus />
                        </div>
                        <div className="form-group">
                          <label htmlFor="public-facility-description">Deskripsi</label>
                          <textarea id="public-facility-description" rows="3" value={currentPublicFacility.description} onChange={(e) => setCurrentPublicFacility({ ...currentPublicFacility, description: e.target.value })} required></textarea>
                        </div>
                        <div className="form-group">
                          <label htmlFor="public-facility-order">Urutan Tampilan</label>
                          <input type="number" id="public-facility-order" value={currentPublicFacility.order} onChange={(e) => setCurrentPublicFacility({ ...currentPublicFacility, order: e.target.value })} />
                        </div>
                        <div className="form-group">
                          <label>Gambar</label>
                          <div className="upload-options">
                            <label htmlFor="public-facility-crop" className="file-upload-label">Pilih & Potong (16:9)</label>
                            <input type="file" id="public-facility-crop" onChange={(e) => handleFileChangeWithCrop(e, 'publicFacility', 16 / 9)} accept="image/*" style={{ display: 'none' }} />
                            <label htmlFor="public-facility-full" className="file-upload-label alt">Upload Gambar Penuh</label>
                            <input type="file" id="public-facility-full" onChange={(e) => handleFullImageUpload(e, 'publicFacility')} accept="image/*" style={{ display: 'none' }} />
                          </div>
                          {publicFacilityPreview ? (
                            <div className="image-preview-container" style={{ marginTop: '15px' }}>
                              <img src={publicFacilityPreview} alt="Preview" className="image-preview" style={{ maxHeight: '150px', objectFit: 'cover' }} />
                            </div>
                          ) : isEditingPublicFacility && currentPublicFacility.image && (
                            <div className="image-preview-container" style={{ marginTop: '15px' }}>
                              <img src={currentPublicFacility.image} alt="Gambar Saat Ini" className="image-preview" style={{ maxHeight: '150px', objectFit: 'cover' }} />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="admin-modal-footer">
                        <button type="button" className="cancel-button" onClick={() => setShowPublicFacilityForm(false)}>Batal</button>
                        <button type="submit" disabled={uploading} className="save-button">{uploading ? 'Menyimpan...' : 'Simpan'}</button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              <div className="resource-grid">
                {publicFacilitiesList.map(facility => (
                  <div key={facility.id} className="resource-card">
                    <div className="resource-card-image-container">
                      <img
                        src={facility.image || 'https://via.placeholder.com/300x160'}
                        alt={facility.title}
                        className="resource-card-image"
                      />
                    </div>
                    <div className="resource-card-content">
                      <h4 className="resource-card-title">{facility.title}</h4>
                      <p className="resource-card-subtitle">{facility.description}</p>
                    </div>
                    <div className="resource-card-footer">
                      <button className="card-action-btn edit" onClick={() => handleEditPublicFacility(facility)} title="Edit"><FaPencilAlt /></button>
                      <button className="card-action-btn delete" onClick={() => handleDeletePublicFacility(facility.id)} title="Hapus"><FaTrash /></button>
                    </div>
                  </div>
                ))}

                {publicFacilitiesList.length === 0 && (
                  <div className="empty-state" style={{ gridColumn: '1/-1' }}>
                    <div className="empty-state-icon"><FaLandmark /></div>
                    <p>Belum ada ruang publik yang ditambahkan.</p>
                  </div>
                )}
              </div>
            </div>
          )
        }

        {
          activeTab === 'pengembangan-akademik' && (
            <div className="admin-section">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2>Kelola Fasilitas Akademik</h2>
                <button className="add-button" onClick={handleAddNewAcademicFacility}>
                  <FaPlus /> Tambah Fasilitas
                </button>
              </div>

              {showAcademicFacilityForm && (
                <div className="admin-modal-overlay">
                  <div className="admin-modal-content">
                    <div className="admin-modal-header">
                      <h3>{isEditingAcademicFacility ? 'Edit Fasilitas Akademik' : 'Tambah Fasilitas Akademik'}</h3>
                      <button type="button" className="admin-modal-close" onClick={() => setShowAcademicFacilityForm(false)}>&times;</button>
                    </div>

                    <form onSubmit={handleAcademicFacilitySubmit} className="modern-form">
                      <div className="admin-modal-body">
                        <div className="form-group">
                          <label htmlFor="academic-facility-title">Nama Fasilitas</label>
                          <input type="text" id="academic-facility-title" value={currentAcademicFacility.title} onChange={(e) => setCurrentAcademicFacility({ ...currentAcademicFacility, title: e.target.value })} required autoFocus />
                        </div>
                        <div className="form-group">
                          <label htmlFor="academic-facility-description">Deskripsi Singkat</label>
                          <textarea id="academic-facility-description" rows="2" value={currentAcademicFacility.description} onChange={(e) => setCurrentAcademicFacility({ ...currentAcademicFacility, description: e.target.value })} required></textarea>
                        </div>
                        <div className="form-group">
                          <label htmlFor="academic-facility-full-description">Deskripsi Lengkap</label>
                          <textarea id="academic-facility-full-description" rows="4" value={currentAcademicFacility.fullDescription || ''} onChange={(e) => setCurrentAcademicFacility({ ...currentAcademicFacility, fullDescription: e.target.value })}></textarea>
                        </div>
                        <div className="form-group">
                          <label htmlFor="academic-facility-gallery">Tautkan ke Album Galeri</label>
                          <select id="academic-facility-gallery" value={currentAcademicFacility.linkedGallery || ''} onChange={(e) => setCurrentAcademicFacility({ ...currentAcademicFacility, linkedGallery: e.target.value })}>
                            <option value="">-- Tidak ada galeri tertaut --</option>
                            {galleryCategories.map(cat => (<option key={cat.id} value={cat.slug}>{cat.name}</option>))}
                          </select>
                        </div>
                        <div className="form-group">
                          <label htmlFor="academic-facility-order">Urutan Tampilan</label>
                          <input type="number" id="academic-facility-order" value={currentAcademicFacility.order} onChange={(e) => setCurrentAcademicFacility({ ...currentAcademicFacility, order: e.target.value })} />
                        </div>
                        <div className="form-group">
                          <label>Gambar</label>
                          <div className="upload-options">
                            <label htmlFor="academic-facility-crop" className="file-upload-label">Pilih & Potong (16:9)</label>
                            <input type="file" id="academic-facility-crop" onChange={(e) => handleFileChangeWithCrop(e, 'academicFacility', 16 / 9)} accept="image/*" style={{ display: 'none' }} />
                            <label htmlFor="academic-facility-full" className="file-upload-label alt">Upload Gambar Penuh</label>
                            <input type="file" id="academic-facility-full" onChange={(e) => handleFullImageUpload(e, 'academicFacility')} accept="image/*" style={{ display: 'none' }} />
                          </div>
                          {academicFacilityPreview ? (
                            <div className="image-preview-container" style={{ marginTop: '15px' }}>
                              <img src={academicFacilityPreview} alt="Preview" className="image-preview" style={{ maxHeight: '150px', objectFit: 'cover' }} />
                            </div>
                          ) : isEditingAcademicFacility && currentAcademicFacility.image && (
                            <div className="image-preview-container" style={{ marginTop: '15px' }}>
                              <img src={currentAcademicFacility.image} alt="Gambar Saat Ini" className="image-preview" style={{ maxHeight: '150px', objectFit: 'cover' }} />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="admin-modal-footer">
                        <button type="button" className="cancel-button" onClick={() => setShowAcademicFacilityForm(false)}>Batal</button>
                        <button type="submit" disabled={uploading} className="save-button">{uploading ? 'Menyimpan...' : 'Simpan'}</button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              <div className="resource-grid">
                {academicFacilitiesList.map(facility => (
                  <div key={facility.id} className="resource-card">
                    <div className="resource-card-image-container">
                      <img
                        src={facility.image || 'https://via.placeholder.com/300x160'}
                        alt={facility.title}
                        className="resource-card-image"
                      />
                    </div>
                    <div className="resource-card-content">
                      <h4 className="resource-card-title">{facility.title}</h4>
                      <p className="resource-card-subtitle">{facility.description}</p>
                      {facility.linkedGallery && (
                        <span className="resource-badge info">Galeri: {facility.linkedGallery}</span>
                      )}
                    </div>
                    <div className="resource-card-footer">
                      <button className="card-action-btn edit" onClick={() => handleEditAcademicFacility(facility)} title="Edit"><FaPencilAlt /></button>
                      <button className="card-action-btn delete" onClick={() => handleDeleteAcademicFacility(facility.id)} title="Hapus"><FaTrash /></button>
                    </div>
                  </div>
                ))}

                {academicFacilitiesList.length === 0 && (
                  <div className="empty-state" style={{ gridColumn: '1/-1' }}>
                    <div className="empty-state-icon"><FaLandmark /></div>
                    <p>Belum ada fasilitas akademik yang ditambahkan.</p>
                  </div>
                )}
              </div>
            </div>
          )
        }

        {
          activeTab === 'program-keahlian' && (
            <div className="admin-section">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2>Kelola Program Keahlian</h2>
                <button className="add-button" onClick={() => setShowMajorForm(true)}>
                  <FaPlus /> Tambah Jurusan
                </button>
              </div>

              {showMajorForm && (
                <div className="admin-modal-overlay">
                  <div className="admin-modal-content wide">
                    <div className="admin-modal-header">
                      <h3>{isEditingMajor ? 'Edit Program Keahlian' : 'Tambah Program Keahlian'}</h3>
                      <button type="button" className="admin-modal-close" onClick={resetMajorForm}>&times;</button>
                    </div>

                    <form onSubmit={handleMajorSubmit} className="modern-form">
                      <div className="admin-modal-body">
                        <div className="form-group">
                          <label htmlFor="major-title">Nama Program Keahlian</label>
                          <input type="text" id="major-title" value={currentMajor.title} onChange={(e) => setCurrentMajor({ ...currentMajor, title: e.target.value })} required autoFocus />
                        </div>
                        <div className="form-group">
                          <label htmlFor="major-description">Deskripsi Singkat (Kartu)</label>
                          <textarea id="major-description" rows="2" value={currentMajor.description} onChange={(e) => setCurrentMajor({ ...currentMajor, description: e.target.value })} required></textarea>
                        </div>
                        <div className="form-group" style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                          <label>Deskripsi Lengkap</label>
                          <ReactQuill
                            theme="snow"
                            value={currentMajor.fullDescription || ''}
                            onChange={(content) => setCurrentMajor({ ...currentMajor, fullDescription: content })}
                            modules={{
                              toolbar: [
                                [{ 'header': [1, 2, false] }],
                                ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                                [{ 'align': [] }],
                                [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                                ['link', 'image'],
                                ['clean']
                              ],
                            }}
                            formats={[
                              'header',
                              'bold', 'italic', 'underline', 'strike', 'blockquote',
                              'align',
                              'list', 'bullet', 'indent',
                              'link', 'image'
                            ]}
                            style={{ height: '50vh', minHeight: '400px', marginBottom: '60px', flex: 1 }}
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="major-gallery">Tautkan ke Album Galeri</label>
                          <select id="major-gallery" value={currentMajor.linkedGallery || ''} onChange={(e) => setCurrentMajor({ ...currentMajor, linkedGallery: e.target.value })}>
                            <option value="">-- Tidak ada galeri tertaut --</option>
                            {galleryCategories.map(cat => (<option key={cat.id} value={cat.slug}>{cat.name}</option>))}
                          </select>
                        </div>

                        <div className="form-box">
                          <label style={{ fontWeight: '600', marginBottom: '10px', display: 'block' }}>Prospek Karir</label>
                          {careerProspects.map((prospect, index) => (
                            <div key={index} style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
                              <div style={{ flex: 1 }}>
                                <input type="text" placeholder={`Judul Prospek ${index + 1}`} value={prospect.title} onChange={(e) => {
                                  const newProspects = [...careerProspects];
                                  newProspects[index].title = e.target.value;
                                  setCareerProspects(newProspects);
                                }} style={{ marginBottom: '4px' }} />
                                <input type="text" placeholder={`Deskripsi (opsional)`} value={prospect.description} onChange={(e) => {
                                  const newProspects = [...careerProspects];
                                  newProspects[index].description = e.target.value;
                                  setCareerProspects(newProspects);
                                }} />
                              </div>
                              <button type="button" className="card-action-btn delete" onClick={() => setCareerProspects(careerProspects.filter((_, i) => i !== index))} style={{ height: 'fit-content' }}>&times;</button>
                            </div>
                          ))}
                          <button type="button" className="add-button small" onClick={() => setCareerProspects([...careerProspects, { title: '', description: '' }])} style={{ marginTop: '5px' }}>+ Tambah Prospek</button>
                        </div>

                        <div className="form-group">
                          <label htmlFor="major-order">Urutan Tampilan</label>
                          <input type="number" id="major-order" value={currentMajor.order} onChange={(e) => setCurrentMajor({ ...currentMajor, order: e.target.value })} />
                        </div>
                        <div className="form-group">
                          <label>Gambar Header</label>
                          <div className="upload-options">
                            <label htmlFor="major-crop" className="file-upload-label">Pilih & Potong (16:9)</label>
                            <input type="file" id="major-crop" onChange={(e) => handleFileChangeWithCrop(e, 'major', 16 / 9)} accept="image/*" style={{ display: 'none' }} />
                            <label htmlFor="major-full" className="file-upload-label alt">Upload Gambar Penuh</label>
                            <input type="file" id="major-full" onChange={(e) => handleFullImageUpload(e, 'major')} accept="image/*" style={{ display: 'none' }} />
                          </div>
                          {(majorPreview || (isEditingMajor && currentMajor.image)) && (
                            <div className="image-preview-container" style={{ marginTop: '15px' }}>
                              <img src={majorPreview || currentMajor.image} alt="Preview" className="image-preview" style={{ maxHeight: '150px', objectFit: 'cover' }} />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="admin-modal-footer">
                        <button type="button" className="cancel-button" onClick={resetMajorForm}>Batal</button>
                        <button type="submit" disabled={uploading} className="save-button">{uploading ? 'Menyimpan...' : 'Simpan'}</button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              <div className="resource-grid">
                {majorsList.map(major => (
                  <div key={major.id} className="resource-card">
                    <div className="resource-card-image-container">
                      <img
                        src={major.image || 'https://via.placeholder.com/300x160'}
                        alt={major.title}
                        className="resource-card-image"
                      />
                    </div>
                    <div className="resource-card-content">
                      <h4 className="resource-card-title">{major.title}</h4>
                      <p className="resource-card-subtitle">{major.description}</p>
                      {major.linkedGallery && (
                        <span className="resource-badge info">Galeri: {major.linkedGallery}</span>
                      )}
                    </div>
                    <div className="resource-card-footer">
                      <button className="card-action-btn edit" onClick={() => handleEditMajor(major)} title="Edit"><FaPencilAlt /></button>
                      <button className="card-action-btn delete" onClick={() => handleDeleteMajor(major.id)} title="Hapus"><FaTrash /></button>
                    </div>
                  </div>
                ))}

                {majorsList.length === 0 && (
                  <div className="empty-state" style={{ gridColumn: '1/-1' }}>
                    <div className="empty-state-icon"><FaChalkboardTeacher /></div>
                    <p>Belum ada program keahlian.</p>
                  </div>
                )}
              </div>
            </div>
          )
        }

        {
          activeTab === 'ekstrakurikuler' && (
            <div className="admin-section">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2>Kelola Ekstrakurikuler</h2>
                <button className="add-button" onClick={handleAddNewEkstrakurikuler}>
                  <FaPlus /> Tambah Ekstrakurikuler
                </button>
              </div>

              {showEkstrakurikulerForm && (
                <div className="admin-modal-overlay">
                  <div className="admin-modal-content">
                    <div className="admin-modal-header">
                      <h3>{isEditingEkstrakurikuler ? 'Edit Ekstrakurikuler' : 'Tambah Ekstrakurikuler Baru'}</h3>
                      <button type="button" className="admin-modal-close" onClick={() => setShowEkstrakurikulerForm(false)}>&times;</button>
                    </div>

                    <form onSubmit={handleEkstrakurikulerSubmit} className="modern-form">
                      <div className="admin-modal-body">
                        <div className="form-group">
                          <label htmlFor="ekstrakurikuler-title">Nama Ekstrakurikuler</label>
                          <input type="text" id="ekstrakurikuler-title" value={currentEkstrakurikuler.title} onChange={(e) => setCurrentEkstrakurikuler({ ...currentEkstrakurikuler, title: e.target.value })} required autoFocus />
                        </div>
                        <div className="form-group">
                          <label htmlFor="ekstrakurikuler-description">Deskripsi</label>
                          <textarea id="ekstrakurikuler-description" rows="3" value={currentEkstrakurikuler.description} onChange={(e) => setCurrentEkstrakurikuler({ ...currentEkstrakurikuler, description: e.target.value })} required></textarea>
                        </div>
                        <div className="form-group">
                          <label htmlFor="ekstrakurikuler-order">Urutan Tampilan</label>
                          <input type="number" id="ekstrakurikuler-order" value={currentEkstrakurikuler.order} onChange={(e) => setCurrentEkstrakurikuler({ ...currentEkstrakurikuler, order: e.target.value })} />
                        </div>
                        <div className="form-group">
                          <label>Gambar</label>
                          <div className="upload-options">
                            <label htmlFor="ekstrakurikuler-crop" className="file-upload-label">Pilih & Potong (16:9)</label>
                            <input type="file" id="ekstrakurikuler-crop" onChange={(e) => handleFileChangeWithCrop(e, 'ekstrakurikuler', 16 / 9)} accept="image/*" style={{ display: 'none' }} />
                            <label htmlFor="ekstrakurikuler-full" className="file-upload-label alt">Upload Gambar Penuh</label>
                            <input type="file" id="ekstrakurikuler-full" onChange={(e) => handleFullImageUpload(e, 'ekstrakurikuler')} accept="image/*" style={{ display: 'none' }} />
                          </div>
                          {ekstrakurikulerPreview ? (
                            <div className="image-preview-container" style={{ marginTop: '15px' }}>
                              <img src={ekstrakurikulerPreview} alt="Preview" className="image-preview" style={{ maxHeight: '150px', objectFit: 'cover' }} />
                            </div>
                          ) : isEditingEkstrakurikuler && currentEkstrakurikuler.image && (
                            <div className="image-preview-container" style={{ marginTop: '15px' }}>
                              <img src={currentEkstrakurikuler.image} alt="Gambar Saat Ini" className="image-preview" style={{ maxHeight: '150px', objectFit: 'cover' }} />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="admin-modal-footer">
                        <button type="button" className="cancel-button" onClick={() => setShowEkstrakurikulerForm(false)}>Batal</button>
                        <button type="submit" disabled={uploading} className="save-button">{uploading ? 'Menyimpan...' : 'Simpan'}</button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              <div className="resource-grid">
                {ekstrakurikulerList.map(item => (
                  <div key={item.id} className="resource-card">
                    <div className="resource-card-image-container">
                      <img
                        src={item.image || 'https://via.placeholder.com/300x160'}
                        alt={item.title}
                        className="resource-card-image"
                      />
                    </div>
                    <div className="resource-card-content">
                      <h4 className="resource-card-title">{item.title}</h4>
                      <p className="resource-card-subtitle">{item.description}</p>
                    </div>
                    <div className="resource-card-footer">
                      <button className="card-action-btn edit" onClick={() => handleEditEkstrakurikuler(item)} title="Edit"><FaPencilAlt /></button>
                      <button className="card-action-btn delete" onClick={() => handleDeleteEkstrakurikuler(item.id)} title="Hapus"><FaTrash /></button>
                    </div>
                  </div>
                ))}

                {ekstrakurikulerList.length === 0 && (
                  <div className="empty-state" style={{ gridColumn: '1/-1' }}>
                    <div className="empty-state-icon"><FaChalkboardTeacher /></div>
                    <p>Belum ada kegiatan ekstrakurikuler.</p>
                  </div>
                )}
              </div>
            </div>
          )
        }

        {
          activeTab === 'mitra-industri' && (
            <div className="admin-section">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2>Kelola Mitra Industri</h2>
                <button className="add-button" onClick={handleAddNewMitra}>
                  <FaPlus /> Tambah Mitra
                </button>
              </div>

              {showMitraForm && (
                <div className="admin-modal-overlay">
                  <div className="admin-modal-content">
                    <div className="admin-modal-header">
                      <h3>{isEditingMitra ? 'Edit Mitra Industri' : 'Tambah Mitra Industri'}</h3>
                      <button type="button" className="admin-modal-close" onClick={() => setShowMitraForm(false)}>&times;</button>
                    </div>

                    <form onSubmit={handleMitraSubmit} className="modern-form">
                      <div className="admin-modal-body">
                        <div className="form-group">
                          <label htmlFor="mitra-name">Nama Mitra</label>
                          <input type="text" id="mitra-name" value={currentMitra.name} onChange={(e) => setCurrentMitra({ ...currentMitra, name: e.target.value })} required autoFocus />
                        </div>
                        <div className="form-group">
                          <label htmlFor="mitra-category">Kategori</label>
                          <select id="mitra-category" value={currentMitra.category} onChange={(e) => setCurrentMitra({ ...currentMitra, category: e.target.value })}>
                            <option value="Hotel">Perhotelan</option>
                            <option value="Pariwisata">Pariwisata (UPW)</option>
                          </select>
                        </div>
                        <div className="form-group">
                          <label htmlFor="mitra-website">Website (Opsional)</label>
                          <input type="url" id="mitra-website" value={currentMitra.website} onChange={(e) => setCurrentMitra({ ...currentMitra, website: e.target.value })} placeholder="https://..." />
                        </div>
                        <div className="form-group">
                          <label htmlFor="mitra-order">Urutan Tampilan</label>
                          <input type="number" id="mitra-order" value={currentMitra.order} onChange={(e) => setCurrentMitra({ ...currentMitra, order: e.target.value })} />
                        </div>
                        <div className="form-group">
                          <label>Logo Mitra</label>
                          <div className="upload-options">
                            <label htmlFor="mitra-crop" className="file-upload-label">Pilih & Potong (16:9)</label>
                            <input type="file" id="mitra-crop" onChange={(e) => handleFileChangeWithCrop(e, 'mitra', 16 / 9)} accept="image/*" style={{ display: 'none' }} />
                            <label htmlFor="mitra-full" className="file-upload-label alt">Upload Logo Penuh</label>
                            <input type="file" id="mitra-full" onChange={(e) => handleFullImageUpload(e, 'mitra')} accept="image/*" style={{ display: 'none' }} />
                          </div>
                          {mitraPreview ? (
                            <div className="image-preview-container" style={{ marginTop: '15px' }}>
                              <img src={mitraPreview} alt="Preview Logo" className="image-preview" style={{ maxHeight: '100px', objectFit: 'contain' }} />
                            </div>
                          ) : isEditingMitra && currentMitra.logoUrl && (
                            <img src={currentMitra.logoUrl} alt="Logo Saat Ini" className="image-preview" style={{ maxHeight: '100px', objectFit: 'contain' }} />
                          )}
                        </div>
                      </div>

                      <div className="admin-modal-footer">
                        <button type="button" className="cancel-button" onClick={() => setShowMitraForm(false)}>Batal</button>
                        <button type="submit" disabled={uploading} className="save-button">{uploading ? 'Menyimpan...' : 'Simpan'}</button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              <div className="resource-grid">
                {mitraList.map(item => (
                  <div key={item.id} className="resource-card">
                    <div className="resource-card-image-container" style={{ paddingTop: '50%', backgroundColor: '#fff' }}>
                      <img
                        src={item.logoUrl || 'https://via.placeholder.com/150'}
                        alt={item.name}
                        className="resource-card-image"
                        style={{ objectFit: 'contain', padding: '20px' }}
                      />
                    </div>
                    <div className="resource-card-content">
                      <h4 className="resource-card-title">{item.name}</h4>
                      <span className="resource-badge success">{item.category || 'Mitra'}</span>
                      {item.website && (
                        <div style={{ marginTop: '8px', fontSize: '0.9rem' }}>
                          <a href={item.website} target="_blank" rel="noopener noreferrer" style={{ color: '#1890ff' }}>Kunjungi Website</a>
                        </div>
                      )}
                    </div>
                    <div className="resource-card-footer">
                      <button className="card-action-btn edit" onClick={() => handleEditMitra(item)} title="Edit"><FaPencilAlt /></button>
                      <button className="card-action-btn delete" onClick={() => handleDeleteMitra(item.id)} title="Hapus"><FaTrash /></button>
                    </div>
                  </div>
                ))}

                {mitraList.length === 0 && (
                  <div className="empty-state" style={{ gridColumn: '1/-1' }}>
                    <div className="empty-state-icon"><FaHandshake /></div>
                    <p>Belum ada mitra industri yang ditambahkan.</p>
                  </div>
                )}
              </div>
            </div>
          )
        }

        {/* Dashboard Overview */}
        {
          activeTab === 'dashboard' && (
            <DashboardOverview
              stats={dashboardStats}
              recentActivity={recentActivity}
              greeting={getGreeting()}
              onQuickAction={(action) => {
                if (action === 'add-news') {
                  setActiveTab('berita');
                  setTimeout(() => setShowBeritaForm(true), 100);
                } else if (action === 'manage-gallery') {
                  setActiveTab('galeri');
                } else if (action === 'check-messages') {
                  setActiveTab('pesan');
                } else if (action === 'all-activity') {
                  // Future implementation: View all logs
                  toast.info("Fitur Log Aktivitas lengkap akan segera hadir!");
                }
              }}
            />
          )
        }

        {/* Konten Utama (Staf) */}
        {
          activeTab === 'staf' && (
            <div className="admin-section">
              <div className="table-header">
                <h2>Kelola Guru & Staf</h2>
                <div className="table-controls">
                  <div className="view-mode-toggles">
                    <button
                      className={`view-toggle-btn ${staffViewMode === 'list' ? 'active' : ''}`}
                      onClick={() => setStaffViewMode('list')}
                      title="Tampilan List"
                    >
                      <FaList />
                    </button>
                    <button
                      className={`view-toggle-btn ${staffViewMode === 'grid' ? 'active' : ''}`}
                      onClick={() => setStaffViewMode('grid')}
                      title="Tampilan Grid"
                    >
                      <FaThLarge />
                    </button>
                  </div>
                  <div className="sorting-controls">
                    <select id="staff-sort" value={staffSortBy} onChange={(e) => setStaffSortBy(e.target.value)} className="modern-select">
                      <option value="order">Urutan</option>
                      <option value="type">Tipe</option>
                      <option value="name">Nama</option>
                      <option value="role">Jabatan</option>
                    </select>
                    <button onClick={() => setStaffSortOrder('asc')} disabled={staffSortOrder === 'asc'} className={`sort-btn ${staffSortOrder === 'asc' ? 'active' : ''}`} title="Ascending"><FaSortAlphaDown /></button>
                    <button onClick={() => setStaffSortOrder('desc')} disabled={staffSortOrder === 'desc'} className={`sort-btn ${staffSortOrder === 'desc' ? 'active' : ''}`} title="Descending"><FaSortAlphaUp /></button>
                  </div>
                  <div className="search-controls">
                    <input
                      type="text"
                      placeholder="Cari nama/jabatan..."
                      className="modern-search-input"
                      value={staffSearchTerm}
                      onChange={(e) => setStaffSearchTerm(e.target.value)}
                    />
                  </div>
                  <button className="add-button" onClick={handleAddNewStaff}><FaPlus /> Tambah Staf</button>
                </div>
              </div>

              {showStaffForm && (
                <div className="admin-modal-overlay">
                  <div className="admin-modal-content">
                    <div className="admin-modal-header">
                      <h3>{isEditingStaff ? 'Edit Staf' : 'Tambah Staf Baru'}</h3>
                      <button type="button" className="admin-modal-close" onClick={() => setShowStaffForm(false)}>&times;</button>
                    </div>

                    <form onSubmit={handleStaffSubmit} className="modern-form">
                      <div className="admin-modal-body">
                        <div className="form-group">
                          <label htmlFor="staff-name">Nama Lengkap</label>
                          <input type="text" id="staff-name" value={currentStaff.name} onChange={(e) => setCurrentStaff({ ...currentStaff, name: e.target.value })} required autoFocus />
                        </div>
                        <div className="form-group">
                          <label htmlFor="staff-role">Jabatan</label>
                          <input type="text" id="staff-role" value={currentStaff.role} onChange={(e) => setCurrentStaff({ ...currentStaff, role: e.target.value })} required />
                        </div>

                        <div className="form-row">
                          <div className="form-group half">
                            <label htmlFor="staff-order">Urutan Tampilan</label>
                            <input type="number" id="staff-order" value={currentStaff.order} onChange={(e) => setCurrentStaff({ ...currentStaff, order: Number(e.target.value) })} />
                            <small>Kecil = Tampil Awal</small>
                          </div>
                          <div className="form-group half">
                            <label htmlFor="staff-type">Tipe Staf</label>
                            <select id="staff-type" value={currentStaff.type} onChange={(e) => setCurrentStaff({ ...currentStaff, type: e.target.value })}>
                              <option value="pendidik">Tenaga Pendidik (Guru)</option>
                              <option value="kependidikan">Tenaga Kependidikan (Staf)</option>
                            </select>
                          </div>
                        </div>

                        <div className="form-group">
                          <label>Foto Profil</label>
                          <div className="upload-options">
                            <label htmlFor="staff-file-crop" className="file-upload-label short">Potong (3:4)</label>
                            <input type="file" id="staff-file-crop" onChange={(e) => handleFileChangeWithCrop(e, 'staff', 3 / 4)} accept="image/*" style={{ display: 'none' }} />
                            <label htmlFor="staff-file-full" className="file-upload-label short alt">Full</label>
                            <input type="file" id="staff-file-full" onChange={(e) => handleFullImageUpload(e, 'staff')} accept="image/*" style={{ display: 'none' }} />
                          </div>
                          {(staffPreview || (isEditingStaff && currentStaff.image)) && (
                            <div className="image-preview-container" style={{ marginTop: '10px', width: '100px', height: '100px', margin: '10px auto', borderRadius: '50%', overflow: 'hidden', border: '2px solid #ddd' }}>
                              <img src={staffPreview || currentStaff.image} alt="Preview" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="admin-modal-footer">
                        <button type="button" className="cancel-button" onClick={() => setShowStaffForm(false)}>Batal</button>
                        <button type="submit" disabled={uploading} className="save-button">{uploading ? 'Menyimpan...' : 'Simpan'}</button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              {staffViewMode === 'list' ? (
                <div className="modern-table-container">
                  <table className="modern-table">
                    <thead>
                      <tr>
                        <th width="80">Foto</th>
                        <th>Nama Lengkap</th>
                        <th>Jabatan</th>
                        <th>Tipe</th>
                        <th width="80" className="text-center">Urutan</th>
                        <th width="100" className="text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredStaffList.map(staff => (
                        <tr key={staff.id}>
                          <td>
                            <img
                              src={staff.image || 'https://via.placeholder.com/40'}
                              alt={staff.name}
                              className="table-image-preview"
                              style={{ width: '40px', height: '40px', borderRadius: '50%' }}
                            />
                          </td>
                          <td style={{ fontWeight: 500 }}>{staff.name}</td>
                          <td>{staff.role}</td>
                          <td>
                            <span className={`resource-badge ${staff.type === 'pendidik' ? 'info' : 'default'}`}>
                              {staff.type === 'pendidik' ? 'Guru' : 'Staf'}
                            </span>
                          </td>
                          <td className="text-center">{staff.order}</td>
                          <td>
                            <div className="table-actions" style={{ justifyContent: 'center' }}>
                              <button className="icon-btn edit" onClick={() => handleEditStaff(staff)} title="Edit">
                                <FaPencilAlt />
                              </button>
                              <button className="icon-btn delete" onClick={() => handleDeleteStaff(staff.id)} title="Hapus">
                                <FaTrash />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))}
                      {filteredStaffList.length === 0 && (
                        <tr>
                          <td colSpan="6" className="text-center p-4">Tidak ada data staf ditemukan.</td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="resource-grid compact">
                  {filteredStaffList.map(staff => (
                    <div key={staff.id} className="resource-card staff-card" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', padding: '15px' }}>
                      <img
                        src={staff.image || 'https://via.placeholder.com/80'}
                        alt={staff.name}
                        style={{ width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover', marginRight: '15px', border: '2px solid #f0f0f0' }}
                      />
                      <div style={{ flex: 1 }}>
                        <h4 style={{ margin: '0 0 5px 0', fontSize: '1rem' }}>{staff.name}</h4>
                        <p style={{ margin: 0, fontSize: '0.85rem', color: '#666' }}>{staff.role}</p>
                        <span className={`resource-badge ${staff.type === 'pendidik' ? 'info' : 'default'}`} style={{ fontSize: '0.7rem', marginTop: '5px' }}>
                          {staff.type === 'pendidik' ? 'Guru' : 'Staf'}
                        </span>
                      </div>
                      <div className="actions" style={{ display: 'flex', flexDirection: 'column', gap: '5px' }}>
                        <button className="icon-btn edit" onClick={() => handleEditStaff(staff)} title="Edit"><FaPencilAlt /></button>
                        <button className="icon-btn delete" onClick={() => handleDeleteStaff(staff.id)} title="Hapus"><FaTrash /></button>
                      </div>
                    </div>
                  ))}
                  {filteredStaffList.length === 0 && (
                    <div className="empty-state" style={{ gridColumn: '1/-1' }}>
                      <div className="empty-state-icon"><FaUsers /></div>
                      <p>Tidak ada data staf ditemukan.</p>
                    </div>
                  )}
                </div>
              )}
            </div>
          )
        }

        {
          activeTab === 'pengaturan' && (
            <div className="admin-section">
              <h2 style={{ marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '15px' }}>Pengaturan Situs & Fitur</h2>
              <form onSubmit={handleSettingsSubmit} className="modern-form">
                <div className="admin-modal-body two-col">
                  <div className="form-col">
                    <div className="form-box" style={{ marginBottom: '20px' }}>
                      <h3>Status Website</h3>
                      <div className="form-group" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div>
                          <label style={{ margin: 0, color: '#333' }}>Mode Maintenance</label>
                          <p style={{ margin: 0, fontSize: '0.8rem', color: '#666' }}>
                            Jika aktif, pengunjung akan melihat halaman "Under Maintenance".
                          </p>
                        </div>
                        <div
                          className={`toggle-switch-premium ${siteSettings.isMaintenanceMode ? 'on' : ''}`}
                          onClick={() => setSiteSettings({ ...siteSettings, isMaintenanceMode: !siteSettings.isMaintenanceMode })}
                          title={siteSettings.isMaintenanceMode ? "Matikan Maintenance Mode" : "Aktifkan Maintenance Mode"}
                        ></div>
                      </div>
                    </div>

                    <div className="form-box">
                      <h3>Identitas & Kontak Sekolah</h3>
                      <div className="form-group">
                        <label htmlFor="siteName">Nama Situs</label>
                        <input type="text" id="siteName" value={siteSettings.siteName} onChange={(e) => setSiteSettings({ ...siteSettings, siteName: e.target.value })} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="tagline">Tagline</label>
                        <input type="text" id="tagline" value={siteSettings.tagline} onChange={(e) => setSiteSettings({ ...siteSettings, tagline: e.target.value })} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="contactEmail">Email Kontak</label>
                        <input type="email" id="contactEmail" value={siteSettings.contactEmail} onChange={(e) => setSiteSettings({ ...siteSettings, contactEmail: e.target.value })} />
                      </div>

                      <div className="form-row">
                        <div className="form-group half">
                          <label htmlFor="contactPhone">Telepon (Utama)</label>
                          <input type="text" id="contactPhone" value={siteSettings.contactPhone} onChange={(e) => setSiteSettings({ ...siteSettings, contactPhone: e.target.value })} />
                        </div>
                        <div className="form-group half">
                          <label htmlFor="contactPhone2">Telepon 2</label>
                          <input type="text" id="contactPhone2" value={siteSettings.contactPhone2 || ''} onChange={(e) => setSiteSettings({ ...siteSettings, contactPhone2: e.target.value })} />
                        </div>
                      </div>

                      <div className="form-group">
                        <label htmlFor="address">Alamat Sekolah</label>
                        <textarea id="address" rows="3" value={siteSettings.address || ''} onChange={(e) => setSiteSettings({ ...siteSettings, address: e.target.value })} />
                      </div>

                      <div className="form-group">
                        <label htmlFor="googleMapsUrl">URL Embed Google Maps</label>
                        <input type="text" id="googleMapsUrl" value={siteSettings.googleMapsUrl} onChange={(e) => setSiteSettings({ ...siteSettings, googleMapsUrl: e.target.value })} />
                      </div>

                      <div className="form-group">
                        <label>Social Media & External Links</label>
                        <div className="input-group-compact">
                          <FaInstagram style={{ color: '#E1306C', fontSize: '1.2rem' }} />
                          <input type="url" placeholder="URL Instagram" value={siteSettings.instagramUrl || ''} onChange={(e) => setSiteSettings({ ...siteSettings, instagramUrl: e.target.value })} />
                        </div>
                        <div className="input-group-compact" style={{ marginTop: '10px' }}>
                          <FaExternalLinkAlt style={{ color: '#1890ff', fontSize: '1.1rem' }} />
                          <input type="url" placeholder="Link Pendaftaran SPMB" value={siteSettings.spmbRegistrationLink || ''} onChange={(e) => setSiteSettings({ ...siteSettings, spmbRegistrationLink: e.target.value })} />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="form-col">
                    <div className="form-box">
                      <h3>Kontak WhatsApp SPMB</h3>
                      <p style={{ fontSize: '0.85rem', color: '#666', marginBottom: '15px' }}>Kontak ini akan muncul di widget chat floating.</p>

                      {(siteSettings.spmbWhatsappNumbers || []).map((contact, index) => (
                        <div key={index} className="dynamic-input-group">
                          <div className="dynamic-input-wrapper">
                            <FaUser className="dynamic-input-icon" />
                            <input
                              type="text"
                              className="modern-input with-icon"
                              placeholder="Nama (e.g. Admin)"
                              value={contact.name}
                              onChange={(e) => handleSpmbContactChange(index, 'name', e.target.value)}
                            />
                          </div>
                          <div className="dynamic-input-wrapper">
                            <FaWhatsapp className="dynamic-input-icon" style={{ color: '#25D366' }} />
                            <input
                              type="text"
                              className="modern-input with-icon"
                              placeholder="628..."
                              value={contact.number}
                              onChange={(e) => handleSpmbContactChange(index, 'number', e.target.value)}
                            />
                          </div>
                          <button type="button" onClick={() => removeSpmbContact(index)} className="icon-btn delete" title="Hapus"><FaTimes /></button>
                        </div>
                      ))}
                      <button type="button" onClick={addSpmbContact} className="add-button small" style={{ width: '100%' }}>+ Tambah Kontak WA</button>
                    </div>

                    <div className="admin-section-block form-box" style={{ marginTop: '30px', padding: '25px', backgroundColor: '#fff', border: '1px solid #e2e8f0', borderRadius: '12px', boxShadow: '0 4px 15px rgba(0,0,0,0.03)' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '15px', borderBottom: '1px solid #e2e8f0', paddingBottom: '15px', marginBottom: '20px' }}>
                        <div style={{ background: '#e0f2fe', padding: '12px', borderRadius: '10px', color: '#0ea5e9', display: 'flex' }}>
                           <FaImages size={24} />
                        </div>
                        <div>
                          <h3 style={{ margin: 0, color: '#0f172a', fontSize: '1.25rem', fontWeight: '600' }}>Modal Selamat Datang (Popup)</h3>
                          <p style={{ margin: 0, color: '#64748b', fontSize: '0.85rem', marginTop: '4px' }}>Tampilkan promo, pengumuman, atau poster pertama kali situs dibuka.</p>
                        </div>
                      </div>

                      <div className="form-group" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#f8fafc', padding: '15px', borderRadius: '8px', borderLeft: '4px solid #0ea5e9' }}>
                        <div>
                          <strong style={{ margin: 0, color: '#334155' }}>Aktifkan Popup?</strong>
                          <p style={{ margin: '4px 0 0 0', fontSize: '0.8rem', color: '#64748b' }}>Bila menyala, modal otomatis tampil ke pengunjung.</p>
                        </div>
                        <div
                          className={`toggle-switch-premium ${siteSettings.welcomeModal?.isEnabled ? 'on' : ''}`}
                          onClick={handleToggleWelcomeModal}
                          style={{ cursor: 'pointer', flexShrink: 0 }}
                        />
                      </div>

                      {siteSettings.welcomeModal?.isEnabled && (
                        <div style={{ animation: 'fadeIn 0.4s ease-out' }}>
                          <h4 style={{ color: '#334155', fontSize: '1rem', marginBottom: '15px', marginTop: '20px', paddingBottom: '5px', borderBottom: '1px dashed #cbd5e1' }}>1. Konten Teks Popup (Opsional)</h4>
                          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '15px' }}>
                            <div className="form-group">
                              <label style={{ fontSize: '0.85rem', fontWeight: 600 }}>Judul Induk Alert</label>
                              <input type="text" className="modern-input" placeholder="Misal: Info Pendaftaran Siswa Baru 2026!" 
                                value={siteSettings.welcomeModal?.title || ''} 
                                onChange={(e) => setSiteSettings({ ...siteSettings, welcomeModal: { ...siteSettings.welcomeModal, title: e.target.value } })} 
                                style={{ width: '100%', padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px' }}
                              />
                            </div>
                            <div className="form-group">
                              <label style={{ fontSize: '0.85rem', fontWeight: 600 }}>Pesan Pendek / Deskripsi</label>
                              <textarea className="modern-input" placeholder="Tulis sedikit penjelasan pengumuman..." rows="2"
                                value={siteSettings.welcomeModal?.description || ''} 
                                onChange={(e) => setSiteSettings({ ...siteSettings, welcomeModal: { ...siteSettings.welcomeModal, description: e.target.value } })}
                                style={{ width: '100%', padding: '10px', border: '1px solid #cbd5e1', borderRadius: '6px', resize: 'none' }} 
                              ></textarea>
                            </div>
                          </div>

                          <h4 style={{ color: '#334155', fontSize: '1rem', marginBottom: '15px', marginTop: '25px', paddingBottom: '5px', borderBottom: '1px dashed #cbd5e1' }}>2. Poster Gambar & Aksi Lanjutan</h4>
                          
                          <div className="upload-options" style={{ marginBottom: '15px' }}>
                            <label htmlFor="welcome-poster-full" className="file-upload-label" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', padding: '8px 15px', background: '#ecfdf5', color: '#10b981', border: '1px solid #10b981' }}>
                              <FaPlus size={12} /> Tambah Daftar Poster Utama
                            </label>
                            <input id="welcome-poster-full" type="file" onChange={(e) => {
                              if (e.target.files && e.target.files.length > 0) {
                                handleAddWelcomePoster(e.target.files[0]);
                                e.target.value = null;
                              }
                            }} accept="image/*" style={{ display: 'none' }} />
                          </div>

                          <div className="resource-grid compact" style={{ marginTop: '10px', gridTemplateColumns: '1fr', gap: '15px' }}>
                            {siteSettings.welcomeModal?.posters?.map((poster, index) => {
                              const posterData = typeof poster === 'string' ? { url: poster, id: index } : poster;
                              const totalPosters = siteSettings.welcomeModal.posters.length;
                              const replaceInputId = `replace-poster-${index}`;
                              return (
                              <div key={posterData.id || index} style={{ padding: '15px', display: 'flex', gap: '15px', alignItems: 'flex-start', background: '#f8fafc', borderRadius: '10px', border: '1px solid #e2e8f0', flexWrap: 'wrap', position: 'relative' }}>
                                {/* Nomor urut */}
                                <div style={{ position: 'absolute', top: '-10px', left: '12px', background: '#0ea5e9', color: '#fff', borderRadius: '20px', padding: '2px 10px', fontSize: '0.75rem', fontWeight: 700 }}>Poster #{index + 1}</div>
                                {/* Gambar + kontrol */}
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                                  <div style={{ position: 'relative' }}>
                                    <img src={posterData.url} alt="Poster" style={{ width: '110px', height: '110px', objectFit: 'cover', borderRadius: '8px', border: '2px solid #e2e8f0', boxShadow: '0 2px 8px rgba(0,0,0,0.1)', display: 'block' }} />
                                    <button type="button" onClick={() => handleDeleteWelcomePoster(poster)} title="Hapus Poster" style={{ position: 'absolute', top: '-8px', right: '-8px', background: '#ef4444', color: '#fff', borderRadius: '50%', width: '22px', height: '22px', display: 'flex', alignItems: 'center', justifyContent: 'center', border: 'none', cursor: 'pointer', fontSize: '14px', lineHeight: 1 }}>&times;</button>
                                  </div>
                                  {/* Tombol Ganti Foto */}
                                  <label htmlFor={replaceInputId} style={{ display: 'inline-flex', alignItems: 'center', gap: '5px', padding: '5px 10px', borderRadius: '6px', background: '#eff6ff', color: '#3b82f6', border: '1px solid #bfdbfe', fontSize: '0.78rem', cursor: 'pointer', whiteSpace: 'nowrap' }}>
                                    🔄 Ganti Foto
                                  </label>
                                  <input id={replaceInputId} type="file" accept="image/*" style={{ display: 'none' }} onChange={(e) => { if (e.target.files?.[0]) { handleReplaceWelcomePoster(index, e.target.files[0]); e.target.value = null; } }} />
                                  {/* Tombol Urutan */}
                                  <div style={{ display: 'flex', gap: '5px' }}>
                                    <button type="button" onClick={() => handleReorderWelcomePoster(index, 'up')} disabled={index === 0} title="Pindah ke Atas" style={{ padding: '4px 10px', borderRadius: '5px', border: '1px solid #cbd5e1', background: index === 0 ? '#f1f5f9' : '#fff', color: index === 0 ? '#cbd5e1' : '#475569', cursor: index === 0 ? 'not-allowed' : 'pointer', fontSize: '0.75rem' }}>▲</button>
                                    <button type="button" onClick={() => handleReorderWelcomePoster(index, 'down')} disabled={index === totalPosters - 1} title="Pindah ke Bawah" style={{ padding: '4px 10px', borderRadius: '5px', border: '1px solid #cbd5e1', background: index === totalPosters - 1 ? '#f1f5f9' : '#fff', color: index === totalPosters - 1 ? '#cbd5e1' : '#475569', cursor: index === totalPosters - 1 ? 'not-allowed' : 'pointer', fontSize: '0.75rem' }}>▼</button>
                                  </div>
                                </div>
                                {/* Field input */}
                                <div style={{ flex: 1, minWidth: '220px', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(190px, 1fr))', gap: '12px' }}>
                                  <div className="form-group" style={{ marginBottom: '0' }}>
                                    <label style={{ fontSize: '0.8rem', color: '#64748b', marginBottom: '4px', display: 'block' }}>Label Teks Tombol Aksi</label>
                                    <input
                                      type="text"
                                      placeholder="Misal: Info Lebih Lanjut!"
                                      value={posterData.buttonText || ''}
                                      onChange={(e) => handleWelcomePosterUpdate(index, 'buttonText', e.target.value)}
                                      style={{ fontSize: '0.9rem', padding: '8px 12px', width: '100%', border: '1px solid #cbd5e1', borderRadius: '4px', boxSizing: 'border-box' }}
                                    />
                                  </div>
                                  <div className="form-group" style={{ marginBottom: '0' }}>
                                    <label style={{ fontSize: '0.8rem', color: '#64748b', marginBottom: '4px', display: 'block' }}>Tujuan / URL Bebas</label>
                                    <input
                                      type="text"
                                      placeholder="Misal: https://..."
                                      value={posterData.buttonLink || ''}
                                      onChange={(e) => handleWelcomePosterUpdate(index, 'buttonLink', e.target.value)}
                                      style={{ fontSize: '0.9rem', padding: '8px 12px', width: '100%', border: '1px solid #cbd5e1', borderRadius: '4px', boxSizing: 'border-box' }}
                                    />
                                  </div>
                                  <div className="form-group" style={{ marginBottom: '0', gridColumn: '1 / -1' }}>
                                    <label style={{ fontSize: '0.8rem', color: '#64748b', marginBottom: '4px', display: 'block' }}>Interaksi Saat Poster Diklik</label>
                                    <select
                                      style={{ fontSize: '0.9rem', padding: '8px 12px', width: '100%', border: '1px solid #cbd5e1', borderRadius: '4px', background: '#fff', boxSizing: 'border-box' }}
                                      value={posterData.imageLinkBehavior || 'none'}
                                      onChange={(e) => handleWelcomePosterUpdate(index, 'imageLinkBehavior', e.target.value)}
                                    >
                                      <option value="none">Hanya Foto Murni (Tanpa Aksi Klik)</option>
                                      <option value="openLink">Aktifkan Navigasi Menuju URL di atas</option>
                                    </select>
                                  </div>
                                </div>
                              </div>
                            )})}
                          </div>
                          {(!siteSettings.welcomeModal?.posters || siteSettings.welcomeModal.posters.length === 0) && (
                            <div style={{ textAlign: 'center', padding: '30px', background: '#f8fafc', borderRadius: '8px', border: '1px dashed #cbd5e1', color: '#94a3b8' }}>
                              <FaImages size={30} style={{ marginBottom: '10px', opacity: 0.5 }} />
                              <p style={{ margin: 0 }}>Belum ada grafis terpasang. Unggah poster pertama Anda.</p>
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </div>


                </div>

                <div className="admin-modal-body" style={{ paddingTop: 0 }}>
                  <div className="form-box" style={{ marginTop: '20px' }}>
                    <h3>SEO & Utilitas</h3>
                    <div className="form-group">
                      <label>Sitemap Generator</label>
                      <p style={{ fontSize: '0.9rem', color: '#666', marginBottom: '10px' }}>
                        Buat file <code>sitemap.xml</code> yang lengkap (termasuk gambar) untuk membantu Google mengindeks website Anda lebih baik di Pencarian Gambar.
                      </p>
                      <button
                        type="button"
                        onClick={handleGenerateSitemap}
                        className="action-button"
                        disabled={uploading}
                        style={{ background: '#52c41a', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '4px', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '8px' }}
                      >
                        <FaDownload /> Download Sitemap.xml
                      </button>
                      <p style={{ fontSize: '0.8rem', color: '#999', marginTop: '8px', fontStyle: 'italic' }}>
                        *Setelah didownload, upload file ini ke folder <code>public_html</code> di hosting Anda.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="admin-modal-footer" style={{ marginTop: '20px' }}>
                  <button type="submit" disabled={uploading} className="save-button" style={{ width: '100%', padding: '12px' }}>
                    {uploading ? 'Menyimpan Pengaturan...' : 'Simpan Semua Pengaturan'}
                  </button>
                </div>
              </form>
            </div>
          )
        }

        {
          activeTab === 'tentang-kami' && (
            <div className="admin-section">
              <h2 style={{ marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '15px' }}>Kelola Halaman 'Tentang Kami'</h2>
              <form onSubmit={handleTentangKamiSubmit} className="modern-form">
                <div className="admin-modal-body two-col">
                  <div className="form-col">
                    <div className="form-box">
                      <h3>Konten Teks</h3>
                      <div className="form-group">
                        <label htmlFor="sambutan">Sambutan Kepala Sekolah</label>
                        <textarea id="sambutan" rows="10" value={tentangKamiContent.sambutan_text} onChange={(e) => setTentangKamiContent({ ...tentangKamiContent, sambutan_text: e.target.value })} style={{ fontFamily: 'monospace' }} />
                      </div>
                      <div className="form-row">
                        <div className="form-group half">
                          <label htmlFor="sambutan_nama">Nama Kepala Sekolah</label>
                          <input type="text" id="sambutan_nama" value={tentangKamiContent.sambutan_nama} onChange={(e) => setTentangKamiContent({ ...tentangKamiContent, sambutan_nama: e.target.value })} />
                        </div>
                        <div className="form-group half">
                          <label htmlFor="sambutan_jabatan">Jabatan</label>
                          <input type="text" id="sambutan_jabatan" value={tentangKamiContent.sambutan_jabatan} onChange={(e) => setTentangKamiContent({ ...tentangKamiContent, sambutan_jabatan: e.target.value })} />
                        </div>
                      </div>
                      <div className="form-group">
                        <label htmlFor="visi">Visi</label>
                        <textarea id="visi" rows="3" value={tentangKamiContent.visi} onChange={(e) => setTentangKamiContent({ ...tentangKamiContent, visi: e.target.value })} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="misi">Misi (Pisahkan dengan baris baru)</label>
                        <textarea id="misi" rows="6" value={tentangKamiContent.misi} onChange={(e) => setTentangKamiContent({ ...tentangKamiContent, misi: e.target.value })} style={{ whiteSpace: 'pre-wrap' }} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="sejarah">Sejarah Sekolah</label>
                        <textarea id="sejarah" rows="6" value={tentangKamiContent.sejarah} onChange={(e) => setTentangKamiContent({ ...tentangKamiContent, sejarah: e.target.value })} />
                      </div>
                    </div>
                  </div>

                  <div className="form-col">
                    <div className="form-box">
                      <h3>Foto Kepala Sekolah</h3>
                      <div className="upload-options">
                        <label htmlFor="kepsek-upload" className="file-upload-label">Pilih Foto</label>
                        <input id="kepsek-upload" type="file" onChange={(e) => handleFileChangeWithCrop(e, 'kepsek', undefined)} accept="image/*" style={{ display: 'none' }} />

                        <label htmlFor="kepsek-upload-full" className="file-upload-label alt" style={{ marginLeft: '5px' }}>Full Image</label>
                        <input id="kepsek-upload-full" type="file" onChange={(e) => handleFullTentangKamiImageUpload(e, 'sambutan_imageUrl')} accept="image/*" style={{ display: 'none' }} />

                        <button className="upload-trigger-btn" onClick={() => handlePageImageUpload('tentangKami', 'sambutan_imageUrl')} disabled={uploading || !file}>
                          {uploading ? 'Upload...' : 'Upload Crop'}
                        </button>
                        {kepsekImagePreview && (
                          <button type="button" className="icon-btn delete" onClick={() => handleDeletePageImage('tentangKami', 'sambutan_imageUrl')} disabled={uploading} title="Hapus"><FaTrash /></button>
                        )}
                      </div>
                      {kepsekImagePreview ? (
                        <div className="image-preview-container" style={{ marginTop: '15px' }}>
                          <img src={kepsekImagePreview} alt="Kepsek" className="image-preview" style={{ maxHeight: '200px', objectFit: 'contain' }} />
                        </div>
                      ) : (
                        <p style={{ color: '#888', fontStyle: 'italic', marginTop: '10px' }}>Belum ada foto.</p>
                      )}
                    </div>

                    <div className="form-box" style={{ marginTop: '20px' }}>
                      <h3>Struktur Organisasi</h3>
                      <div className="upload-options">
                        <label htmlFor="org-chart-upload" className="file-upload-label">Pilih Gambar</label>
                        <input id="org-chart-upload" type="file" onChange={(e) => handleFileChangeWithCrop(e, 'orgChart', undefined)} accept="image/*" style={{ display: 'none' }} />

                        <label htmlFor="org-chart-upload-full" className="file-upload-label alt" style={{ marginLeft: '5px' }}>Full Image</label>
                        <input id="org-chart-upload-full" type="file" onChange={(e) => handleFullTentangKamiImageUpload(e, 'organizationChartUrl')} accept="image/*" style={{ display: 'none' }} />

                        <button className="upload-trigger-btn" onClick={() => handlePageImageUpload('tentangKami', 'organizationChartUrl')} disabled={uploading || !file}>
                          {uploading ? 'Upload...' : 'Upload Crop'}
                        </button>
                        {orgChartPreview && (
                          <button type="button" className="icon-btn delete" onClick={() => handleDeletePageImage('tentangKami', 'organizationChartUrl')} disabled={uploading} title="Hapus"><FaTrash /></button>
                        )}
                      </div>
                      {orgChartPreview ? (
                        <div className="image-preview-container" style={{ marginTop: '15px' }}>
                          <img src={orgChartPreview} alt="Struktur Organisasi" className="image-preview" />
                        </div>
                      ) : (
                        <p style={{ color: '#888', fontStyle: 'italic', marginTop: '10px' }}>Belum ada gambar.</p>
                      )}
                    </div>
                  </div>
                </div>

                <div className="admin-modal-footer" style={{ marginTop: '20px' }}>
                  <button type="submit" disabled={uploading} className="save-button" style={{ width: '100%', padding: '12px' }}>
                    {uploading ? 'Menyimpan...' : 'Simpan Perubahan'}
                  </button>
                </div>
              </form>
            </div>
          )
        }

        {
          activeTab === 'spmb' && (
            <div className="admin-section">
              <h2 style={{ marginBottom: '20px', borderBottom: '1px solid #eee', paddingBottom: '15px' }}>Kelola Halaman SPMB</h2>
              <form onSubmit={async (e) => {
                e.preventDefault();
                setUploading(true);
                try {
                  await setDoc(doc(db, "pageContent", "spmbPage"), {
                    introTitle: spmbPageContent.introTitle,
                    introDescription: spmbPageContent.introDescription,
                    brochureLink: spmbPageContent.brochureLink || ''
                  }, { merge: true });
                  toast.success("Konten halaman SPMB berhasil diperbarui!");
                } catch (err) {
                  toast.error("Gagal menyimpan konten.");
                } finally {
                  setUploading(false);
                }
              }} className="modern-form">
                <div className="admin-modal-body two-col">
                  <div className="form-col">
                    <div className="form-box">
                      <h3>Konten Teks & Brosur</h3>
                      <div className="form-group">
                        <label htmlFor="spmb-intro-title">Judul Utama</label>
                        <input type="text" id="spmb-intro-title" value={spmbPageContent.introTitle || ''} onChange={(e) => setSpmbPageContent({ ...spmbPageContent, introTitle: e.target.value })} />
                      </div>
                      <div className="form-group">
                        <label htmlFor="spmb-intro-description">Deskripsi / Paragraf Pembuka</label>
                        <textarea id="spmb-intro-description" rows="5" value={spmbPageContent.introDescription || ''} onChange={(e) => setSpmbPageContent({ ...spmbPageContent, introDescription: e.target.value })} style={{ fontFamily: 'monospace' }}></textarea>
                      </div>
                      <div className="form-group">
                        <label htmlFor="spmb-brochure-link">Link Download Brosur (PDF/Drive)</label>
                        <div className="input-group-compact">
                          <FaFilePdf style={{ color: '#ff4d4f', fontSize: '1.2rem' }} />
                          <input
                            type="url"
                            id="spmb-brochure-link"
                            placeholder="https://..."
                            value={spmbPageContent.brochureLink || ''}
                            onChange={(e) => setSpmbPageContent({ ...spmbPageContent, brochureLink: e.target.value })}
                          />
                        </div>
                      </div>
                      <button type="submit" disabled={uploading} className="save-button small" style={{ marginTop: '10px' }}>
                        {uploading ? 'Menyimpan...' : 'Simpan Teks'}
                      </button>
                    </div>
                  </div>

                  <div className="form-col">
                    <div className="form-box">
                      <h3>Poster Slider SPMB</h3>
                      <div className="upload-options">
                        <label htmlFor="spmb-poster-crop" className="file-upload-label">Pilih Poster (Crop)</label>
                        <input id="spmb-poster-crop" type="file" onChange={(e) => handleFileChangeWithCrop(e, 'spmbPosterCrop', undefined)} accept="image/*" style={{ display: 'none' }} />
                        <label htmlFor="spmb-poster-full" className="file-upload-label alt">Poster Full</label>
                        <input id="spmb-poster-full" type="file" onChange={(e) => handleAddSpmbPoster(e.target.files[0])} accept="image/*" style={{ display: 'none' }} />
                      </div>

                      <div className="resource-grid compact" style={{ marginTop: '15px' }}>
                        {spmbPageContent.spmbPosters && spmbPageContent.spmbPosters.length > 0 ? (
                          spmbPageContent.spmbPosters.map((poster, index) => (
                            <div key={poster.id || index} className="resource-card" style={{ padding: 0 }}>
                              <div className="resource-card-image-container">
                                <img src={poster.url} alt={`Poster ${index + 1}`} className="resource-card-image" />
                              </div>
                              <button type="button" className="card-delete-btn-overlay" onClick={() => handleDeleteSpmbPoster(poster)}>&times;</button>
                            </div>
                          ))
                        ) : (
                          <div className="empty-state" style={{ gridColumn: '1/-1', padding: '20px' }}>
                            <p>Belum ada poster.</p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          )
        }

        {
          activeTab === 'kesiswaan' && (
            <div className="admin-section">
              <h2 className="section-title">Manajemen Halaman Kesiswaan</h2>
              <form onSubmit={handleKesiswaanSubmit} className="modern-form">

                {/* --- 1. Header / Hero Section --- */}
                <div className="admin-card" style={{
                  padding: 0,
                  overflow: 'hidden',
                  borderRadius: '15px',
                  marginBottom: '30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  position: 'relative',
                  height: '300px',
                  backgroundImage: `url(${kesiswaanHeroFile ? URL.createObjectURL(kesiswaanHeroFile) : (kesiswaanContent.imageUrl || 'https://images.unsplash.com/photo-1544967082-d9d25d867d66?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80')})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}>
                  <div style={{
                    position: 'absolute',
                    inset: 0,
                    background: 'rgba(0,0,0,0.4)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white'
                  }}>
                    <h1 style={{ fontSize: '2.5rem', marginBottom: '10px', textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>Waka Kesiswaan</h1>
                    <div style={{ background: 'rgba(255,255,255,0.2)', padding: '5px 15px', borderRadius: '20px', backdropFilter: 'blur(5px)', marginBottom: '20px' }}>
                      Preview Header
                    </div>

                    <label className="btn-upload-trigger">
                      <FaImages style={{ color: '#1890ff' }} /> Ganti Background Header
                      <input
                        type="file"
                        onChange={(e) => {
                          if (e.target.files[0]) setKesiswaanHeroFile(e.target.files[0]);
                        }}
                        accept="image/*"
                        style={{ display: 'none' }}
                      />
                    </label>
                  </div>
                </div>


                {/* --- 2. Profile Section --- */}
                <div className="admin-card" style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0',
                  padding: '40px',
                  background: 'white',
                  borderRadius: '15px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  marginBottom: '40px'
                }}>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '40px' }}>

                    {/* Left: Image */}
                    <div style={{ flex: '1', minWidth: '300px', maxWidth: '350px' }}>
                      <div style={{
                        width: '100%',
                        height: '350px',
                        overflow: 'hidden',
                        borderRadius: '10px',
                        position: 'relative',
                        boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                        marginBottom: '15px'
                      }}>
                        <img
                          src={kesiswaanPreview || kesiswaanContent.wakaImageUrl || "https://ui-avatars.com/api/?name=Waka+Kesiswaan&background=random&size=256"}
                          alt="Waka Kesiswaan"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                        <div style={{
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          right: 0,
                          padding: '10px',
                          background: 'rgba(255,255,255,0.9)',
                          display: 'flex',
                          justifyContent: 'center',
                          gap: '10px'
                        }}>
                          <label htmlFor="kesiswaan-crop" style={{ cursor: 'pointer', color: '#1890ff' }} title="Crop & Upload"><FaImages size={20} /></label>
                          <input type="file" id="kesiswaan-crop" onChange={(e) => handleFileChangeWithCrop(e, 'kesiswaan', 1)} accept="image/*" style={{ display: 'none' }} />

                          <label htmlFor="kesiswaan-full" style={{ cursor: 'pointer', color: '#52c41a' }} title="Full Upload"><FaImages size={20} /></label>
                          <input type="file" id="kesiswaan-full" onChange={(e) => handleFullImageUpload(e, 'kesiswaan')} accept="image/*" style={{ display: 'none' }} />
                        </div>
                      </div>
                      <p style={{ textAlign: 'center', fontSize: '0.8rem', color: '#888' }}>Resolusi disarankan: Portret / Persegi</p>
                    </div>

                    {/* Right: Content Inputs */}
                    <div style={{ flex: '2', minWidth: '300px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      <div className="form-group" style={{ marginBottom: '10px' }}>
                        <label style={{ fontSize: '0.9rem', color: '#888' }}>Nama Lengkap & Gelar</label>
                        <input
                          type="text"
                          value={kesiswaanContent.wakaName}
                          onChange={(e) => setKesiswaanContent({ ...kesiswaanContent, wakaName: e.target.value })}
                          placeholder="Nama Waka, S.Pd."
                          style={{
                            fontSize: '1.8rem',
                            fontWeight: '600',
                            color: '#2c3e50',
                            border: 'none',
                            borderBottom: '2px solid #eee',
                            width: '100%',
                            padding: '5px 0',
                            marginBottom: '5px'
                          }}
                        />
                      </div>

                      <div className="form-group" style={{ marginBottom: '20px' }}>
                        <label style={{ fontSize: '0.9rem', color: '#888' }}>Jabatan</label>
                        <input
                          type="text"
                          value={kesiswaanContent.wakaRole}
                          onChange={(e) => setKesiswaanContent({ ...kesiswaanContent, wakaRole: e.target.value })}
                          style={{
                            fontSize: '1.1rem',
                            fontWeight: '600',
                            color: '#555',
                            border: 'none',
                            borderBottom: '1px solid #eee',
                            width: '100%',
                            padding: '5px 0'
                          }}
                        />
                      </div>

                      <div className="form-group" style={{
                        background: '#f9f9f9',
                        padding: '20px',
                        borderLeft: '4px solid #f39c12',
                        borderRadius: '4px'
                      }}>
                        <label style={{ fontSize: '0.9rem', color: '#888', marginBottom: '10px', display: 'block' }}>Kutipan (Quote)</label>
                        <textarea
                          value={kesiswaanContent.wakaQuote}
                          onChange={(e) => setKesiswaanContent({ ...kesiswaanContent, wakaQuote: e.target.value })}
                          placeholder="Masukkan kutipan..."
                          rows="4"
                          style={{
                            width: '100%',
                            border: 'none',
                            background: 'transparent',
                            fontStyle: 'italic',
                            fontSize: '1rem',
                            color: '#555',
                            resize: 'none',
                            outline: 'none'
                          }}
                        />
                      </div>
                    </div>

                  </div>
                </div>

                {/* --- 3. Visi Misi --- */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '30px', marginBottom: '40px' }}>
                  {/* Visi */}
                  <div className="admin-card" style={{ padding: '30px', borderTop: '4px solid #004d99', borderRadius: '10px', background: 'white', boxShadow: '0 5px 15px rgba(0,0,0,0.05)' }}>
                    <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '1.5rem', marginBottom: '20px' }}>
                      <FaBullseye style={{ color: '#004d99' }} /> Visi
                    </h3>
                    <textarea
                      value={kesiswaanContent.visi}
                      onChange={(e) => setKesiswaanContent({ ...kesiswaanContent, visi: e.target.value })}
                      rows="5"
                      placeholder="Masukkan Visi..."
                      style={{ width: '100%', padding: '15px', borderRadius: '8px', border: '1px solid #ddd', lineHeight: '1.6' }}
                    />
                  </div>

                  {/* Misi */}
                  <div className="admin-card" style={{ padding: '30px', borderTop: '4px solid #004d99', borderRadius: '10px', background: 'white', boxShadow: '0 5px 15px rgba(0,0,0,0.05)' }}>
                    <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '1.5rem', marginBottom: '20px' }}>
                      <FaListUl style={{ color: '#004d99' }} /> Misi
                    </h3>
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                      {kesiswaanContent.misi.map((item, index) => (
                        <li key={index} style={{ marginBottom: '12px', display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                          <span style={{ color: '#f39c12', fontWeight: 'bold', marginTop: '10px' }}>✓</span>
                          <textarea
                            value={item}
                            onChange={(e) => updateKesiswaanItem('misi', index, e.target.value)}
                            rows="2"
                            style={{ flex: 1, padding: '10px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '0.95rem' }}
                          />
                          <button type="button" onClick={() => removeKesiswaanItem('misi', index)} className="btn-admin-icon delete"><FaTrash /></button>
                        </li>
                      ))}
                    </ul>
                    <button type="button" onClick={() => addKesiswaanItem('misi', '')} className="btn-admin-dashed" style={{ marginTop: '10px' }}>
                      <FaPlus /> Tambah Misi
                    </button>
                  </div>
                </div>

                {/* --- 4. Programs --- */}
                <div className="admin-section-block" style={{ marginBottom: '40px' }}>
                  <div className="section-title text-center" style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <h2 style={{ fontSize: '2.2rem', color: '#004d99', marginBottom: '10px' }}>Program Kesiswaan</h2>
                    <p style={{ color: '#666' }}>Kelola daftar program kesiswaan (OSIS, Ekstrakurikuler, dll)</p>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '25px' }}>
                    {kesiswaanContent.programs.map((prog, index) => (
                      <div key={index} style={{
                        background: 'white',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                        borderTop: '4px solid #f39c12',
                        display: 'flex',
                        flexDirection: 'column'
                      }}>
                        {/* Image Area */}
                        {/* Image Area */}
                        <div style={{ padding: '15px 20px 0 20px' }}>
                          <div style={{ height: '180px', background: '#fafafa', position: 'relative', borderRadius: '8px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #eee' }}>
                            {prog.image ? (
                              <img src={prog.image} alt={prog.title} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                            ) : (
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#ccc' }}><FaImages size={40} /></div>
                            )}
                          </div>

                          <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <input
                              type="text"
                              placeholder="Tempel URL Gambar disini..."
                              value={prog.image || ''}
                              onChange={(e) => updateKesiswaanItem('programs', index, { ...prog, image: e.target.value })}
                              style={{ fontSize: '0.8rem', padding: '8px', borderRadius: '4px', border: '1px solid #ddd', width: '100%' }}
                            />
                            <label className="btn-upload-trigger" style={{ width: '100%', justifyContent: 'center', padding: '8px', fontSize: '0.85rem' }}>
                              <FaImages size={14} /> Upload dari Komputer
                              <input type="file" accept="image/*" style={{ display: 'none' }} onChange={(e) => handleProgramImageUpload(index, e, 'kesiswaan')} />
                            </label>
                          </div>
                        </div>

                        {/* Content Area */}
                        <div style={{ padding: '20px', flex: 1, display: 'flex', flexDirection: 'column', gap: '15px' }}>
                          <input
                            type="text"
                            value={prog.title}
                            onChange={(e) => updateKesiswaanItem('programs', index, { ...prog, title: e.target.value })}
                            placeholder="Judul Program"
                            style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#004d99', border: '1px solid #eee', padding: '5px', borderRadius: '4px', width: '100%' }}
                          />
                          <textarea
                            value={prog.description}
                            onChange={(e) => updateKesiswaanItem('programs', index, { ...prog, description: e.target.value })}
                            placeholder="Deskripsi singkat program..."
                            rows="3"
                            style={{ width: '100%', border: '1px solid #eee', padding: '8px', borderRadius: '4px', resize: 'none', color: '#666' }}
                          />
                          <button type="button" onClick={() => removeKesiswaanItem('programs', index)} className="btn-admin-danger" style={{ alignSelf: 'flex-start' }}>
                            <FaTrash /> Hapus
                          </button>
                        </div>
                      </div>
                    ))}

                    {/* Add Card */}
                    <div
                      onClick={() => addKesiswaanItem('programs', { title: 'Program Baru', description: 'Deskripsi program...', image: '' })}
                      style={{
                        background: '#f8f9fa',
                        borderRadius: '12px',
                        border: '2px dashed #ddd',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        minHeight: '300px',
                        cursor: 'pointer',
                        color: '#888',
                        transition: 'all 0.2s'
                      }}
                      className="hover-card-effect"
                    >
                      <FaPlus size={40} style={{ marginBottom: '15px', color: '#004d99' }} />
                      <span style={{ fontSize: '1.1rem', fontWeight: '600' }}>Tambah Program</span>
                    </div>
                  </div>
                </div>

                {/* --- 5. Download Center --- */}
                <div className="admin-section-block" style={{ marginBottom: '40px', background: '#f8f9fa', padding: '40px 20px', borderRadius: '15px' }}>
                  <div className="section-title text-center" style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <h2 style={{ fontSize: '2.2rem', color: '#004d99', marginBottom: '10px' }}>Dokumen Kesiswaan</h2>
                    <button type="button" onClick={() => addKesiswaanItem('documents', { title: '', url: '', date: '', size: '' })} className="btn-admin-secondary" style={{ margin: '0 auto' }}>
                      <FaPlus /> Tambah Dokumen
                    </button>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px' }}>
                    {kesiswaanContent.documents.map((doc, index) => (
                      <div key={index} style={{
                        background: 'white',
                        padding: '20px',
                        borderRadius: '10px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        position: 'relative',
                        borderLeft: '4px solid #f39c12'
                      }}>
                        <button type="button" onClick={() => removeKesiswaanItem('documents', index)} className="btn-admin-icon delete" style={{ position: 'absolute', top: '10px', right: '10px' }}><FaTrash /></button>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '10px' }}>
                          <FaFilePdf style={{ fontSize: '2rem', color: '#e74c3c' }} />
                          <input
                            type="text"
                            value={doc.title}
                            onChange={(e) => updateKesiswaanItem('documents', index, { ...doc, title: e.target.value })}
                            placeholder="Nama Dokumen"
                            style={{ fontWeight: 'bold', border: 'none', borderBottom: '1px solid #eee', padding: '5px', flex: 1 }}
                          />
                        </div>

                        <input
                          type="text"
                          value={doc.url}
                          onChange={(e) => updateKesiswaanItem('documents', index, { ...doc, url: e.target.value })}
                          placeholder="URL Dokumen"
                          style={{ width: '100%', background: '#f9f9f9', border: '1px solid #eee', borderRadius: '4px', padding: '8px', fontSize: '0.8rem' }}
                        />
                      </div>
                    ))}
                  </div>
                </div>

                <div className="form-actions" style={{ position: 'sticky', bottom: '20px', textAlign: 'right', zIndex: 100 }}>
                  <button type="submit" disabled={uploading} className="btn-admin-primary">
                    {uploading ? 'Menyimpan...' : 'Simpan Perubahan'}
                  </button>
                </div>
              </form>
            </div>
          )
        }
        
        {
          activeTab === 'testimoni-alumni' && (
            <div className="admin-section">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2>Kelola Testimoni Alumni</h2>
                <button className="add-button" onClick={() => setShowTestimoniForm(true)}>
                  <FaPlus /> Tambah Testimoni
                </button>
              </div>

              {showTestimoniForm && (
                <div className="admin-modal-overlay">
                  <div className="admin-modal-content">
                    <div className="admin-modal-header">
                      <h3>{isEditingTestimoni ? 'Edit Testimoni' : 'Tambah Testimoni Baru'}</h3>
                      <button type="button" className="admin-modal-close" onClick={resetTestimoniForm}>&times;</button>
                    </div>

                    <form id="testimoni-form" onSubmit={handleTestimoniSubmit} className="modern-form">
                      <div className="admin-modal-body">
                        <div className="form-group">
                          <label htmlFor="testimoni-title">Judul Testimoni</label>
                          <input type="text" id="testimoni-title" value={currentTestimoni.title} onChange={(e) => setCurrentTestimoni({ ...currentTestimoni, title: e.target.value })} required autoFocus />
                        </div>
                        <div className="form-group">
                          <label htmlFor="testimoni-excerpt">Kutipan Singkat (Subtitle)</label>
                          <textarea id="testimoni-excerpt" rows="2" value={currentTestimoni.excerpt} onChange={(e) => setCurrentTestimoni({ ...currentTestimoni, excerpt: e.target.value })} required></textarea>
                        </div>
                        <div className="form-group">
                          <label htmlFor="testimoni-content">Deskripsi Lengkap</label>
                          <textarea id="testimoni-content" rows="4" value={currentTestimoni.content} onChange={(e) => setCurrentTestimoni({ ...currentTestimoni, content: e.target.value })} required></textarea>
                        </div>
                        <div className="form-group">
                          <label htmlFor="testimoni-date">Tanggal</label>
                          <input type="date" id="testimoni-date" value={currentTestimoni.date} onChange={(e) => setCurrentTestimoni({ ...currentTestimoni, date: e.target.value })} required />
                        </div>
                        <div className="form-group">
                          <label htmlFor="testimoni-order">Urutan Tampilan</label>
                          <input type="number" id="testimoni-order" value={currentTestimoni.order} onChange={(e) => setCurrentTestimoni({ ...currentTestimoni, order: e.target.value })} />
                        </div>
                        <div className="form-group">
                          <label>Foto Alumni</label>
                          <div className="upload-options">
                            <label htmlFor="testimoni-crop" className="file-upload-label">Pilih & Potong (16:9)</label>
                            <input type="file" id="testimoni-crop" onChange={(e) => handleFileChangeWithCrop(e, 'testimoni', 16 / 9)} accept="image/*" style={{ display: 'none' }} />
                            <label htmlFor="testimoni-full" className="file-upload-label alt">Upload Foto Penuh</label>
                            <input type="file" id="testimoni-full" onChange={(e) => handleFullImageUpload(e, 'testimoni')} accept="image/*" style={{ display: 'none' }} />
                          </div>
                          {(testimoniPreview || (isEditingTestimoni && currentTestimoni.image)) && (
                            <div className="image-preview-container" style={{ marginTop: '15px', textAlign: 'center' }}>
                              <img src={testimoniPreview || currentTestimoni.image} alt="Preview" className="image-preview" style={{ maxHeight: '150px', objectFit: 'cover', margin: '0 auto' }} />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="admin-modal-footer">
                        <button type="button" className="cancel-button" onClick={resetTestimoniForm}>Batal</button>
                        <button type="submit" disabled={uploading} className="save-button">{uploading ? 'Menyimpan...' : 'Simpan'}</button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              <div className="resource-grid">
                {testimoniList.sort((a,b) => (a.order || 0) - (b.order || 0)).map(item => (
                  <div key={item.id} className="resource-card">
                    <div className="resource-card-image-container">
                      <img
                        src={item.image || 'https://via.placeholder.com/300x160'}
                        alt={item.name}
                        className="resource-card-image"
                      />
                      <div style={{ position: 'absolute', bottom: '10px', right: '10px', background: 'rgba(0,0,0,0.6)', color: '#fff', padding: '4px 8px', borderRadius: '4px', fontSize: '0.75rem' }}>
                        {item.major} {item.batch && `(${item.batch})`}
                      </div>
                    </div>
                    <div className="resource-card-content">
                      <h4 className="resource-card-title">{item.title}</h4>
                      <p className="resource-card-subtitle">{item.excerpt}</p>
                    </div>
                    <div className="resource-card-footer">
                      <button className="card-action-btn edit" onClick={() => handleEditTestimoni(item)} title="Edit"><FaPencilAlt /></button>
                      <button className="card-action-btn delete" onClick={() => handleDeleteTestimoni(item.id)} title="Hapus"><FaTrash /></button>
                    </div>
                  </div>
                ))}

                {testimoniList.length === 0 && (
                  <div className="empty-state" style={{ gridColumn: '1/-1' }}>
                    <div className="empty-state-icon"><FaQuoteRight /></div>
                    <p>Belum ada testimoni alumni yang ditambahkan.</p>
                  </div>
                )}
              </div>
            </div>
          )
        }
        
        {
          activeTab === 'prestasi' && (
            <div className="admin-section">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2>Kelola Prestasi</h2>
                <button className="add-button" onClick={() => setShowPrestasiForm(true)}>
                  <FaPlus /> Tambah Prestasi
                </button>
              </div>

              {showPrestasiForm && (
                <div className="admin-modal-overlay">
                  <div className="admin-modal-content">
                    <div className="admin-modal-header">
                      <h3>{isEditingPrestasi ? 'Edit Prestasi' : 'Tambah Prestasi Baru'}</h3>
                      <button type="button" className="admin-modal-close" onClick={resetPrestasiForm}>&times;</button>
                    </div>

                    <form onSubmit={handlePrestasiSubmit} className="modern-form">
                      <div className="admin-modal-body">
                        <div className="form-group">
                          <label htmlFor="prestasi-title">Judul Prestasi</label>
                          <input type="text" id="prestasi-title" value={currentPrestasi.title} onChange={(e) => setCurrentPrestasi({ ...currentPrestasi, title: e.target.value })} required autoFocus />
                        </div>
                        <div className="form-group">
                          <label htmlFor="prestasi-excerpt">Kutipan Singkat (Excerpt)</label>
                          <textarea id="prestasi-excerpt" rows="2" value={currentPrestasi.excerpt} onChange={(e) => setCurrentPrestasi({ ...currentPrestasi, excerpt: e.target.value })} required></textarea>
                        </div>
                        <div className="form-group">
                          <label htmlFor="prestasi-content">Deskripsi Lengkap</label>
                          <textarea id="prestasi-content" rows="4" value={currentPrestasi.content} onChange={(e) => setCurrentPrestasi({ ...currentPrestasi, content: e.target.value })} required></textarea>
                        </div>
                        <div className="form-group">
                          <label htmlFor="prestasi-date">Tanggal</label>
                          <input type="date" id="prestasi-date" value={currentPrestasi.date} onChange={(e) => setCurrentPrestasi({ ...currentPrestasi, date: e.target.value })} required />
                        </div>
                        <div className="form-group">
                          <label>Gambar</label>
                          <div className="upload-options">
                            <label htmlFor="prestasi-crop" className="file-upload-label">Pilih & Potong (16:9)</label>
                            <input type="file" id="prestasi-crop" onChange={(e) => handleFileChangeWithCrop(e, 'prestasi', 16 / 9)} accept="image/*" style={{ display: 'none' }} />
                            <label htmlFor="prestasi-full" className="file-upload-label alt">Upload Gambar Penuh</label>
                            <input type="file" id="prestasi-full" onChange={(e) => handleFullImageUpload(e, 'prestasi')} accept="image/*" style={{ display: 'none' }} />
                          </div>
                          {(prestasiPreview || (isEditingPrestasi && currentPrestasi.image)) && (
                            <div className="image-preview-container" style={{ marginTop: '15px' }}>
                              <img src={prestasiPreview || currentPrestasi.image} alt="Preview" className="image-preview" style={{ maxHeight: '150px', objectFit: 'cover' }} />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="admin-modal-footer">
                        <button type="button" className="cancel-button" onClick={resetPrestasiForm}>Batal</button>
                        <button type="submit" disabled={uploading} className="save-button">{uploading ? 'Menyimpan...' : 'Simpan'}</button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              <div className="resource-grid">
                {prestasiList.map(item => (
                  <div key={item.id} className="resource-card">
                    <div className="resource-card-image-container">
                      <img
                        src={item.image || 'https://via.placeholder.com/300x160'}
                        alt={item.title}
                        className="resource-card-image"
                      />
                      <div style={{ position: 'absolute', bottom: '10px', right: '10px', background: 'rgba(0,0,0,0.6)', color: '#fff', padding: '4px 8px', borderRadius: '4px', fontSize: '0.75rem' }}>
                        {item.date?.toDate ? new Date(item.date.toDate()).toLocaleDateString('id-ID') : 'N/A'}
                      </div>
                    </div>
                    <div className="resource-card-content">
                      <h4 className="resource-card-title">{item.title}</h4>
                      <p className="resource-card-subtitle">{item.excerpt}</p>
                    </div>
                    <div className="resource-card-footer">
                      <button className="card-action-btn edit" onClick={() => handleEditPrestasi(item)} title="Edit"><FaPencilAlt /></button>
                      <button className="card-action-btn delete" onClick={() => handleDeletePrestasi(item.id)} title="Hapus"><FaTrash /></button>
                    </div>
                  </div>
                ))}

                {prestasiList.length === 0 && (
                  <div className="empty-state" style={{ gridColumn: '1/-1' }}>
                    <div className="empty-state-icon"><FaTrophy /></div>
                    <p>Belum ada data prestasi yang ditambahkan.</p>
                  </div>
                )}
              </div>
            </div>
          )
        }

        {
          activeTab === 'alumni-lulus' && (
            <div className="admin-section">
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2>Kelola Alumni Lulus</h2>
                <button className="add-button" onClick={() => setShowAlumniLulusForm(true)}>
                  <FaPlus /> Tambah Alumni Lulus
                </button>
              </div>

              {showAlumniLulusForm && (
                <div className="admin-modal-overlay">
                  <div className="admin-modal-content">
                    <div className="admin-modal-header">
                      <h3>{isEditingAlumniLulus ? 'Edit Alumni Lulus' : 'Tambah Alumni Lulus Baru'}</h3>
                      <button type="button" className="admin-modal-close" onClick={resetAlumniLulusForm}>&times;</button>
                    </div>

                    <form onSubmit={handleAlumniLulusSubmit} className="modern-form" id="alumni-lulus-form">
                      <div className="admin-modal-body">
                        <div className="form-group">
                          <label htmlFor="alumni-lulus-title">Nama Alumni</label>
                          <input type="text" id="alumni-lulus-title" value={currentAlumniLulus.title} onChange={(e) => setCurrentAlumniLulus({ ...currentAlumniLulus, title: e.target.value })} required autoFocus />
                        </div>
                        <div className="form-group">
                          <label htmlFor="alumni-lulus-excerpt">Kutipan Singkat (Excerpt)</label>
                          <textarea id="alumni-lulus-excerpt" rows="2" value={currentAlumniLulus.excerpt} onChange={(e) => setCurrentAlumniLulus({ ...currentAlumniLulus, excerpt: e.target.value })} required></textarea>
                        </div>
                        <div className="form-group">
                          <label htmlFor="alumni-lulus-content">Deskripsi Lengkap / Detail</label>
                          <textarea id="alumni-lulus-content" rows="4" value={currentAlumniLulus.content} onChange={(e) => setCurrentAlumniLulus({ ...currentAlumniLulus, content: e.target.value })} required></textarea>
                        </div>
                        <div className="form-group">
                          <label htmlFor="alumni-lulus-date">Tanggal Kelulusan</label>
                          <input type="date" id="alumni-lulus-date" value={currentAlumniLulus.date} onChange={(e) => setCurrentAlumniLulus({ ...currentAlumniLulus, date: e.target.value })} required />
                        </div>
                        <div className="form-group">
                          <label>Gambar</label>
                          <div className="upload-options">
                            <label htmlFor="alumni-lulus-crop" className="file-upload-label">Pilih & Potong (16:9)</label>
                            <input type="file" id="alumni-lulus-crop" onChange={(e) => handleFileChangeWithCrop(e, 'alumni-lulus', 16 / 9)} accept="image/*" style={{ display: 'none' }} />
                            <label htmlFor="alumni-lulus-full" className="file-upload-label alt">Upload Gambar Penuh</label>
                            <input type="file" id="alumni-lulus-full" onChange={(e) => handleFullImageUpload(e, 'alumni-lulus')} accept="image/*" style={{ display: 'none' }} />
                          </div>
                          {(alumniLulusPreview || (isEditingAlumniLulus && currentAlumniLulus.image)) && (
                            <div className="image-preview-container" style={{ marginTop: '15px' }}>
                              <img src={alumniLulusPreview || currentAlumniLulus.image} alt="Preview" className="image-preview" style={{ maxHeight: '150px', objectFit: 'cover' }} />
                            </div>
                          )}
                        </div>
                      </div>

                      <div className="admin-modal-footer">
                        <button type="button" className="cancel-button" onClick={resetAlumniLulusForm}>Batal</button>
                        <button type="submit" disabled={uploading} className="save-button">{uploading ? 'Menyimpan...' : 'Simpan'}</button>
                      </div>
                    </form>
                  </div>
                </div>
              )}

              <div className="resource-grid">
                {alumniLulusList.map(item => (
                  <div key={item.id} className="resource-card">
                    <div className="resource-card-image-container">
                      <img
                        src={item.image || 'https://via.placeholder.com/300x160'}
                        alt={item.title}
                        className="resource-card-image"
                      />
                      <div style={{ position: 'absolute', bottom: '10px', right: '10px', background: 'rgba(0,0,0,0.6)', color: '#fff', padding: '4px 8px', borderRadius: '4px', fontSize: '0.75rem' }}>
                        {item.date?.toDate ? new Date(item.date.toDate()).toLocaleDateString('id-ID') : 'N/A'}
                      </div>
                    </div>
                    <div className="resource-card-content">
                      <h4 className="resource-card-title">{item.title}</h4>
                      <p className="resource-card-subtitle">{item.excerpt}</p>
                    </div>
                    <div className="resource-card-footer">
                      <button className="card-action-btn edit" onClick={() => handleEditAlumniLulus(item)} title="Edit"><FaPencilAlt /></button>
                      <button className="card-action-btn delete" onClick={() => handleDeleteAlumniLulus(item.id)} title="Hapus"><FaTrash /></button>
                    </div>
                  </div>
                ))}

                {alumniLulusList.length === 0 && (
                  <div className="empty-state" style={{ gridColumn: '1/-1' }}>
                    <div className="empty-state-icon"><FaGraduationCap /></div>
                    <p>Belum ada data alumni lulus yang ditambahkan.</p>
                  </div>
                )}
              </div>
            </div>
          )
        }

        {
          activeTab === 'pesan' && (
            <div className="admin-section" style={{ maxWidth: '100%', padding: '0', background: 'transparent', boxShadow: 'none' }}>
              <div className="admin-card" style={{ background: '#fff', borderRadius: '12px', padding: '24px', boxShadow: '0 4px 12px rgba(0,0,0,0.05)' }}>
                <div className="table-header" style={{ marginBottom: '20px', borderBottom: '1px solid #f0f0f0', paddingBottom: '16px' }}>
                  <h2 style={{ fontSize: '1.5rem', color: '#1a1a1a', margin: 0 }}>Pesan Masuk</h2>
                  <div style={{ color: '#666', fontSize: '0.9rem' }}>
                    {pesanKontak.filter(p => !p.read).length} Pesan Belum Dibaca
                  </div>
                </div>

                <div className="modern-table-container">
                  <table className="modern-table" style={{ width: '100%', borderCollapse: 'separate', borderSpacing: '0 4px' }}>
                    <thead>
                      <tr>
                        <th style={{ width: '180px', padding: '12px', color: '#888', fontWeight: '600', fontSize: '0.85rem', textTransform: 'uppercase' }}>Tanggal</th>
                        <th style={{ padding: '12px', color: '#888', fontWeight: '600', fontSize: '0.85rem', textTransform: 'uppercase' }}>Pengirim</th>
                        <th style={{ padding: '12px', color: '#888', fontWeight: '600', fontSize: '0.85rem', textTransform: 'uppercase' }}>Subjek</th>
                        <th style={{ width: '120px', textAlign: 'center', padding: '12px', color: '#888', fontWeight: '600', fontSize: '0.85rem', textTransform: 'uppercase' }}>Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      {pesanKontak.map(pesan => (
                        <Fragment key={pesan.id}>
                          <tr
                            className={pesan.read ? 'search-item' : 'search-item unread'}
                            style={{
                              background: pesan.read ? '#fff' : '#f0f9ff',
                              transition: 'all 0.2s ease',
                              cursor: 'pointer',
                              borderLeft: pesan.read ? '4px solid transparent' : '4px solid #1890ff'
                            }}
                            onClick={() => togglePesanDetail(pesan)}
                          >
                            <td style={{ padding: '16px 12px', borderBottom: '1px solid #f0f0f0', color: '#555', fontSize: '0.9rem' }}>
                              {pesan.timestamp}
                            </td>
                            <td style={{ padding: '16px 12px', borderBottom: '1px solid #f0f0f0' }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                {!pesan.read && (
                                  <span style={{
                                    width: '8px',
                                    height: '8px',
                                    borderRadius: '50%',
                                    background: '#1890ff',
                                    display: 'inline-block',
                                    boxShadow: '0 0 0 2px rgba(24, 144, 255, 0.2)'
                                  }} title="Belum dibaca"></span>
                                )}
                                <span style={{ fontWeight: pesan.read ? '500' : '700', color: '#333' }}>{pesan.name}</span>
                              </div>
                            </td>
                            <td style={{ padding: '16px 12px', borderBottom: '1px solid #f0f0f0', fontWeight: pesan.read ? '400' : '600', color: '#333' }}>
                              {pesan.subject}
                            </td>
                            <td className='actions' style={{ padding: '16px 12px', borderBottom: '1px solid #f0f0f0', justifyContent: 'center' }}>
                              <button
                                className="icon-btn view"
                                onClick={(e) => { e.stopPropagation(); togglePesanDetail(pesan); }}
                                title={expandedPesanId === pesan.id ? 'Tutup' : 'Lihat'}
                                style={{
                                  color: expandedPesanId === pesan.id ? '#fff' : '#1890ff',
                                  background: expandedPesanId === pesan.id ? '#1890ff' : '#e6f7ff',
                                  border: 'none',
                                  borderRadius: '6px',
                                  padding: '8px',
                                  transition: 'all 0.2s'
                                }}
                              >
                                {expandedPesanId === pesan.id ? <FaEyeSlash /> : <FaEye />}
                              </button>
                              <button
                                className="icon-btn delete"
                                onClick={(e) => { e.stopPropagation(); handleDeletePesan(pesan.id); }}
                                title="Hapus"
                                style={{
                                  color: '#ff4d4f',
                                  background: '#fff1f0',
                                  border: 'none',
                                  borderRadius: '6px',
                                  padding: '8px',
                                  marginLeft: '8px',
                                  transition: 'all 0.2s'
                                }}
                              >
                                <FaTrash />
                              </button>
                            </td>
                          </tr>
                          {expandedPesanId === pesan.id && (
                            <tr className="pesan-detail-row">
                              <td colSpan="4" style={{ padding: '0', border: 'none' }}>
                                <div className="form-box" style={{
                                  margin: '0 0 16px 0',
                                  padding: '24px',
                                  background: '#fcfcfc',
                                  borderTop: '1px solid #f0f0f0',
                                  borderBottom: '1px solid #f0f0f0',
                                  boxShadow: 'inset 0 2px 6px rgba(0,0,0,0.02)'
                                }}>
                                  <div style={{ display: 'flex', alignItems: 'center', marginBottom: '20px', gap: '12px' }}>
                                    <div style={{ width: '40px', height: '40px', background: '#e6f7ff', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#1890ff', fontSize: '1.2rem' }}>
                                      <FaEnvelope />
                                    </div>
                                    <div>
                                      <h4 style={{ margin: 0, color: '#333', fontSize: '1rem' }}>{pesan.name}</h4>
                                      <a href={`mailto:${pesan.email}`} style={{ color: '#1890ff', textDecoration: 'none', fontSize: '0.9rem' }}>{pesan.email}</a>
                                    </div>
                                  </div>

                                  <div style={{ background: '#fff', padding: '20px', borderRadius: '8px', border: '1px solid #eee' }}>
                                    <h5 style={{ margin: '0 0 12px 0', color: '#888', fontSize: '0.8rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>Isi Pesan:</h5>
                                    <div style={{ lineHeight: '1.7', color: '#444', whiteSpace: 'pre-wrap', fontSize: '1rem' }}>
                                      {pesan.message}
                                    </div>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          )}
                        </Fragment>
                      ))}
                      {pesanKontak.length === 0 && (
                        <tr>
                          <td colSpan="4" style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
                            <div style={{ fontSize: '2rem', marginBottom: '10px', color: '#e0e0e0' }}><FaEnvelope /></div>
                            Belum ada pesan masuk.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>

          )
        }


        {
          activeTab === 'kurikulum' && (
            <div className="admin-section">
              <h2 className="section-title">Manajemen Halaman Kurikulum</h2>
              <form onSubmit={handleKurikulumSubmit} className="modern-form">

                {/* --- 1. Header / Hero Section --- */}
                <div className="admin-card" style={{
                  padding: 0,
                  overflow: 'hidden',
                  borderRadius: '15px',
                  marginBottom: '30px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  position: 'relative',
                  height: '300px',
                  backgroundImage: `url(${kurikulumHeroFile ? URL.createObjectURL(kurikulumHeroFile) : (kurikulumContent.imageUrl || 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80')})`,
                  backgroundSize: 'cover',
                  backgroundPosition: 'center'
                }}>
                  <div style={{
                    position: 'absolute',
                    inset: 0,
                    background: 'rgba(0,0,0,0.4)',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white'
                  }}>
                    <h1 style={{ fontSize: '2.5rem', marginBottom: '10px', textShadow: '0 2px 4px rgba(0,0,0,0.3)' }}>Waka Kurikulum</h1>
                    <div style={{ background: 'rgba(255,255,255,0.2)', padding: '5px 15px', borderRadius: '20px', backdropFilter: 'blur(5px)', marginBottom: '20px' }}>
                      Preview Header
                    </div>

                    <label className="btn-upload-trigger">
                      <FaImages style={{ color: '#1890ff' }} /> Ganti Background Header
                      <input
                        type="file"
                        onChange={(e) => {
                          if (e.target.files[0]) setKurikulumHeroFile(e.target.files[0]);
                        }}
                        accept="image/*"
                        style={{ display: 'none' }}
                      />
                    </label>
                  </div>
                </div>

                {/* --- 2. Profile Section (Mimicking Frontend Layout) --- */}
                <div className="admin-card" style={{
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '0',
                  padding: '40px',
                  background: 'white',
                  borderRadius: '15px',
                  boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
                  marginBottom: '40px'
                }}>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: '40px' }}>
                    {/* Left: Image */}
                    <div style={{ flex: '1', minWidth: '300px', maxWidth: '350px' }}>
                      <div style={{
                        width: '100%',
                        height: '350px',
                        overflow: 'hidden',
                        borderRadius: '10px',
                        position: 'relative',
                        boxShadow: '0 5px 15px rgba(0,0,0,0.1)',
                        marginBottom: '15px'
                      }}>
                        <img
                          src={kurikulumPreview || kurikulumContent.wakaImageUrl || "https://ui-avatars.com/api/?name=Waka+Kurikulum&background=random&size=256"}
                          alt="Waka Kurikulum"
                          style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                        <div style={{
                          position: 'absolute',
                          bottom: 0,
                          left: 0,
                          right: 0,
                          padding: '10px',
                          background: 'rgba(255,255,255,0.9)',
                          display: 'flex',
                          justifyContent: 'center',
                          gap: '10px'
                        }}>
                          <label htmlFor="kurikulum-crop" style={{ cursor: 'pointer', color: '#1890ff' }} title="Crop & Upload"><FaImages size={20} /></label>
                          <input type="file" id="kurikulum-crop" onChange={(e) => handleFileChangeWithCrop(e, 'kurikulum', 1)} accept="image/*" style={{ display: 'none' }} />

                          <label htmlFor="kurikulum-full" style={{ cursor: 'pointer', color: '#52c41a' }} title="Full Upload"><FaImages size={20} /></label>
                          <input type="file" id="kurikulum-full" onChange={(e) => handleFullImageUpload(e, 'kurikulum')} accept="image/*" style={{ display: 'none' }} />
                        </div>
                      </div>
                      <p style={{ textAlign: 'center', fontSize: '0.8rem', color: '#888' }}>Resolusi disarankan: Portret / Persegi</p>
                    </div>

                    {/* Right: Content Inputs */}
                    <div style={{ flex: '2', minWidth: '300px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      <div className="form-group" style={{ marginBottom: '10px' }}>
                        <label style={{ fontSize: '0.9rem', color: '#888' }}>Nama Lengkap & Gelar</label>
                        <input
                          type="text"
                          value={kurikulumContent.wakaName}
                          onChange={(e) => setKurikulumContent({ ...kurikulumContent, wakaName: e.target.value })}
                          placeholder="Nama Waka, S.Pd., M.Pd."
                          style={{
                            fontSize: '1.8rem',
                            fontWeight: '600',
                            color: '#2c3e50',
                            border: 'none',
                            borderBottom: '2px solid #eee',
                            width: '100%',
                            padding: '5px 0',
                            marginBottom: '5px'
                          }}
                        />
                      </div>

                      <div className="form-group" style={{ marginBottom: '20px' }}>
                        <label style={{ fontSize: '0.9rem', color: '#888' }}>Jabatan</label>
                        <input
                          type="text"
                          value={kurikulumContent.wakaRole}
                          onChange={(e) => setKurikulumContent({ ...kurikulumContent, wakaRole: e.target.value })}
                          style={{
                            fontSize: '1.1rem',
                            fontWeight: '600',
                            color: '#555',
                            border: 'none',
                            borderBottom: '1px solid #eee',
                            width: '100%',
                            padding: '5px 0'
                          }}
                        />
                      </div>

                      <div className="form-group" style={{
                        background: '#f9f9f9',
                        padding: '20px',
                        borderLeft: '4px solid #f39c12',
                        borderRadius: '4px'
                      }}>
                        <label style={{ fontSize: '0.9rem', color: '#888', marginBottom: '10px', display: 'block' }}>Kutipan (Quote)</label>
                        <textarea
                          value={kurikulumContent.wakaQuote}
                          onChange={(e) => setKurikulumContent({ ...kurikulumContent, wakaQuote: e.target.value })}
                          placeholder="Masukkan kutipan..."
                          rows="4"
                          style={{
                            width: '100%',
                            border: 'none',
                            background: 'transparent',
                            fontStyle: 'italic',
                            fontSize: '1rem',
                            color: '#555',
                            resize: 'none',
                            outline: 'none'
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* --- 3. Visi Misi (Grid Layout) --- */}
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '30px', marginBottom: '40px' }}>
                  {/* Visi */}
                  <div className="admin-card" style={{ padding: '30px', borderTop: '4px solid #004d99', borderRadius: '10px', background: 'white', boxShadow: '0 5px 15px rgba(0,0,0,0.05)' }}>
                    <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '1.5rem', marginBottom: '20px' }}>
                      <FaBullseye style={{ color: '#004d99' }} /> Visi
                    </h3>
                    <textarea
                      value={kurikulumContent.visi}
                      onChange={(e) => setKurikulumContent({ ...kurikulumContent, visi: e.target.value })}
                      rows="5"
                      placeholder="Masukkan Visi..."
                      style={{ width: '100%', padding: '15px', borderRadius: '8px', border: '1px solid #ddd', lineHeight: '1.6' }}
                    />
                  </div>

                  {/* Misi */}
                  <div className="admin-card" style={{ padding: '30px', borderTop: '4px solid #004d99', borderRadius: '10px', background: 'white', boxShadow: '0 5px 15px rgba(0,0,0,0.05)' }}>
                    <h3 style={{ display: 'flex', alignItems: 'center', gap: '10px', fontSize: '1.5rem', marginBottom: '20px' }}>
                      <FaListUl style={{ color: '#004d99' }} /> Misi
                    </h3>
                    <ul style={{ listStyle: 'none', padding: 0 }}>
                      {kurikulumContent.misi.map((item, index) => (
                        <li key={index} style={{ marginBottom: '12px', display: 'flex', gap: '10px', alignItems: 'flex-start' }}>
                          <span style={{ color: '#f39c12', fontWeight: 'bold', marginTop: '10px' }}>✓</span>
                          <textarea
                            value={item}
                            onChange={(e) => updateItemInArray('misi', index, e.target.value)}
                            rows="2"
                            style={{ flex: 1, padding: '10px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '0.95rem' }}
                          />
                          <button type="button" onClick={() => removeItemFromArray('misi', index)} className="btn-admin-icon delete"><FaTrash /></button>
                        </li>
                      ))}
                    </ul>
                    <button type="button" onClick={() => addItemToArray('misi', '')} className="btn-admin-dashed" style={{ marginTop: '10px' }}>
                      <FaPlus /> Tambah Misi
                    </button>
                  </div>
                </div>

                {/* --- 4. Programs --- */}
                <div className="admin-section-block" style={{ marginBottom: '40px' }}>
                  <div className="section-title text-center" style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <h2 style={{ fontSize: '2.2rem', color: '#004d99', marginBottom: '10px' }}>Program Unggulan</h2>
                    <p style={{ color: '#666' }}>Kelola daftar program unggulan yang ditampilkan</p>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '25px' }}>
                    {kurikulumContent.programs.map((prog, index) => (
                      <div key={index} style={{
                        background: 'white',
                        borderRadius: '12px',
                        overflow: 'hidden',
                        boxShadow: '0 4px 20px rgba(0,0,0,0.06)',
                        borderTop: '4px solid #f39c12',
                        display: 'flex',
                        flexDirection: 'column'
                      }}>
                        {/* Image Area */}
                        {/* Image Area */}
                        <div style={{ padding: '15px 20px 0 20px' }}>
                          <div style={{ height: '180px', background: '#fafafa', position: 'relative', borderRadius: '8px', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', border: '1px solid #eee' }}>
                            {prog.image ? (
                              <img src={prog.image} alt={prog.title} style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                            ) : (
                              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', color: '#ccc' }}><FaImages size={40} /></div>
                            )}
                          </div>

                          <div style={{ marginTop: '10px', display: 'flex', flexDirection: 'column', gap: '8px' }}>
                            <input
                              type="text"
                              placeholder="Tempel URL Gambar disini..."
                              value={prog.image || ''}
                              onChange={(e) => updateItemInArray('programs', index, { ...prog, image: e.target.value })}
                              style={{ fontSize: '0.8rem', padding: '8px', borderRadius: '4px', border: '1px solid #ddd', width: '100%' }}
                            />
                            <label className="btn-upload-trigger" style={{ width: '100%', justifyContent: 'center', padding: '8px', fontSize: '0.85rem' }}>
                              <FaImages size={14} /> Upload dari Komputer
                              <input type="file" accept="image/*" style={{ display: 'none' }} onChange={(e) => handleProgramImageUpload(index, e, 'kurikulum')} />
                            </label>
                          </div>
                        </div>

                        {/* Content Area */}
                        <div style={{ padding: '20px', flex: 1, display: 'flex', flexDirection: 'column', gap: '15px' }}>
                          <input
                            type="text"
                            value={prog.title}
                            onChange={(e) => updateItemInArray('programs', index, { ...prog, title: e.target.value })}
                            placeholder="Judul Program"
                            style={{ fontSize: '1.2rem', fontWeight: 'bold', color: '#004d99', border: '1px solid #eee', padding: '5px', borderRadius: '4px', width: '100%' }}
                          />
                          <textarea
                            value={prog.description}
                            onChange={(e) => updateItemInArray('programs', index, { ...prog, description: e.target.value })}
                            placeholder="Deskripsi singkat program..."
                            rows="3"
                            style={{ width: '100%', border: '1px solid #eee', padding: '8px', borderRadius: '4px', resize: 'none', color: '#666' }}
                          />
                          <button type="button" onClick={() => handleDeleteKurikulumProgram(index)} className="btn-admin-danger" style={{ alignSelf: 'flex-start' }}>
                            <FaTrash /> Hapus
                          </button>
                        </div>
                      </div>
                    ))}

                    {/* Add Card */}
                    <div
                      onClick={() => addItemToArray('programs', { title: 'Program Baru', description: 'Deskripsi program...', image: '' })}
                      className="btn-admin-dashed hover-card-effect"
                      style={{
                        flexDirection: 'column',
                        minHeight: '300px',
                        color: '#888'
                      }}
                    >
                      <FaPlus size={40} style={{ marginBottom: '15px', color: '#004d99' }} />
                      <span style={{ fontSize: '1.1rem', fontWeight: '600' }}>Tambah Program</span>
                    </div>
                  </div>
                </div>

                {/* --- 5. Download Center --- */}
                <div className="admin-section-block" style={{ marginBottom: '40px', background: '#f8f9fa', padding: '40px 20px', borderRadius: '15px' }}>
                  <div className="section-title text-center" style={{ textAlign: 'center', marginBottom: '30px' }}>
                    <h2 style={{ fontSize: '2.2rem', color: '#004d99', marginBottom: '10px' }}>Pusat Unduhan</h2>
                    <button type="button" onClick={() => addItemToArray('documents', { title: '', url: '', date: '', size: '' })} className="btn-admin-secondary" style={{ margin: '0 auto' }}>
                      <FaPlus /> Tambah Dokumen
                    </button>
                  </div>

                  <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px' }}>
                    {kurikulumContent.documents.map((doc, index) => (
                      <div key={index} style={{
                        background: 'white',
                        padding: '20px',
                        borderRadius: '10px',
                        boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '10px',
                        position: 'relative',
                        borderLeft: '4px solid #f39c12'
                      }}>
                        <button type="button" onClick={() => removeItemFromArray('documents', index)} className="btn-admin-icon delete" style={{ position: 'absolute', top: '10px', right: '10px' }}><FaTrash /></button>

                        <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '10px' }}>
                          <FaFilePdf style={{ fontSize: '2rem', color: '#e74c3c' }} />
                          <input
                            type="text"
                            value={doc.title}
                            onChange={(e) => updateItemInArray('documents', index, { ...doc, title: e.target.value })}
                            placeholder="Nama Dokumen"
                            style={{ fontWeight: 'bold', border: 'none', borderBottom: '1px solid #eee', padding: '5px', flex: 1 }}
                          />
                        </div>

                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px' }}>
                          <input type="text" value={doc.date} onChange={(e) => updateItemInArray('documents', index, { ...doc, date: e.target.value })} placeholder="Tgl" style={{ border: '1px solid #eee', borderRadius: '4px', padding: '5px', fontSize: '0.8rem' }} />
                          <input type="text" value={doc.size} onChange={(e) => updateItemInArray('documents', index, { ...doc, size: e.target.value })} placeholder="Size" style={{ border: '1px solid #eee', borderRadius: '4px', padding: '5px', fontSize: '0.8rem' }} />
                        </div>

                        <input
                          type="text"
                          value={doc.url}
                          onChange={(e) => updateItemInArray('documents', index, { ...doc, url: e.target.value })}
                          placeholder="URL Dokumen"
                          style={{ width: '100%', background: '#f9f9f9', border: '1px solid #eee', borderRadius: '4px', padding: '8px', fontSize: '0.8rem' }}
                        />
                      </div>
                    ))}
                  </div>
                </div>

                <div className="form-actions" style={{ position: 'sticky', bottom: '20px', textAlign: 'right', zIndex: 100 }}>
                  <button type="submit" disabled={uploading} className="btn-admin-primary">
                    {uploading ? 'Menyimpan...' : 'Simpan Perubahan'}
                  </button>
                </div>
              </form>
            </div>
          )
        }

      </main>

      {
        imageToCrop && (
          <ImageCropper
            src={imageToCrop}
            onCropComplete={onCropComplete}
            onCropCancel={onCropCancel}
            aspect={cropAspect}
          />
        )
      }


    </div >
  );
};

export default AdminDashboard;
